/* eslint-disable max-len */
// const SOFTWARE_NAME = '365 Monitoreo';

const formItems = {
  EMAIL: 'Correo',
  PASSWORD: 'Contraseña',
  FIRSTNAME: 'Nombre',
  LASTNAME: 'Apellido',
  WORKSPACE_NAME: 'Nombre del espacio de trabajo',
  WORKSPACE_ID: 'ID del espacio de trabajo',
  COMPANY_NAME: 'Nombre de empresa',
  COUNTRY: 'País',
  WORKSPACE: 'Espacio de trabajo',
  ID: 'Identificador',
};

const formItemsValidation = {
  // ENTER
  ENTER_EMAIL: `Ingrese su ${formItems.EMAIL}`,
  ENTER_PASSWORD: `Ingrese su ${formItems.PASSWORD}`,
  ENTER_NEW_PASSWORD: `Ingrese su nueva ${formItems.PASSWORD}`,
  ENTER_FIRSTNAME: `Ingrese su ${formItems.FIRSTNAME}`,
  ENTER_LASTNAME: `Ingrese su ${formItems.LASTNAME}`,

  // ---------
  // VALIDATE
  GENERIC_VALIDATE: 'El campo no es válido',
  VALIDATE_COUNTRY: `El ${formItems.COUNTRY.toLocaleLowerCase()} no es válido`,
  VALIDATE_WORKSPACE_NAME: `Ingrese un ${formItems.WORKSPACE_NAME.toLocaleLowerCase()}`,
  VALIDATE_PASSWORD_LENGHT_ERROR: `La ${formItems.PASSWORD.toLocaleLowerCase()} tiene que ser mayor a 8 caracteres`,
  VALIDATE_PASSWORD_MAX_LENGHT_ERROR: `La ${formItems.PASSWORD.toLocaleLowerCase()} tiene que ser menor a 16 caracteres`,
  PASSWORD_RULES_LETTER: `La ${formItems.PASSWORD.toLocaleLowerCase()} debe contener al menos una letra`,
  PASSWORD_RULES_NUMBER: `La ${formItems.PASSWORD.toLocaleLowerCase()} debe contener al menos un número`,
  VALIDATE_FIRSTNAME_MIN_LENGHT_ERROR: `El ${formItems.FIRSTNAME.toLocaleLowerCase()} tiene que ser mayor a 2 caracteres`,
  VALIDATE_FIRSTNAME_MAX_LENGHT_ERROR: `El ${formItems.FIRSTNAME.toLocaleLowerCase()} tiene que ser menor a 30 caracteres`,
  VALIDATE_LASTNAME_MIN_LENGHT_ERROR: `El ${formItems.LASTNAME.toLocaleLowerCase()} tiene que ser mayor a 2 caracteres`,
  VALIDATE_LASTNAME_MAX_LENGHT_ERROR: `El ${formItems.LASTNAME.toLocaleLowerCase()} tiene que ser menor a 30 caracteres`,
  VALIDATE_EMAIL_ERROR: `El ${formItems.EMAIL.toLocaleLowerCase()} no es válido`,

  // ---------
  // REQUIRED
  GENERIC_REQUIRED: 'El campo es requerido',
  COMPANY_NAME_REQUIRED: `El ${formItems.COMPANY_NAME.toLocaleLowerCase()} es requerido`,
  FIRSTNAME_REQUIRED: `El ${formItems.FIRSTNAME} es requerido`,
  LASTNAME_REQUIRED: `El ${formItems.LASTNAME} es requerido`,
  EMAIL_REQUIRED: `El ${formItems.EMAIL} es requerido`,
  PASSWORD_REQUIRED: `La ${formItems.PASSWORD} es requerida`,
  ID_REQUIRED: `El ${formItems.ID} es requerido`,

  // ---------
  // VALIDATION UNCATEGORIZED
  CONFIRM_PASSWORD: `Confirme su ${formItems.PASSWORD}`,
  PASSWORD_MUST_MATCH: 'Las contraseñas deben coincidir',
};

// const actions = {
//   SUBMIT: 'Enviar',
//   CANCEL: 'Cancelar',
//   ACCEPT: 'Aceptar',
//   PREVIOUS: 'Regresar',
//   NEXT: 'Siguiente',
//   JOIN: 'Unirse',
//   CONFIRM: 'Confirmar',
//   SIGNIN: 'Ingresar',
//   SAVING: 'Guardando',
//   SAVE_CHANGES: 'Guardar cambios',
// };

const errors = {
  GENERAL_ERROR: 'Un error ha ocurrido',
  NETWORK_ERROR:
    'Un error ha ocurrido procesando su solicitud, intente de nuevo mas tarde.',
  INVALID_LINK: 'Enlace invalido',
  SESSION_EXPIRED_ERROR:
    'La sesión ha expirado, por favor vuelva a ingresar a la plataforma.',
  EMAIL_ALREADY_EXIST_ERROR:
    'El correo ingresado ya existe, si no recuerda su clave intente cambiarla con la opcion de olvidar contraseña',
};

// const registerWizard = {
//   FIRST_STEP_TITLE: 'Empecemos',
//   FIRST_STEP_SUBTITLE: 'Queremos saber tu correo',
//   SECOND_STEP_TITLE: 'Cuenta',
//   SECOND_STEP_SUBTITLE: 'Necesitamos algunos detalles para crear la cuenta',
//   SECOND_STEP_INNER_TITLE: 'Información de la cuenta',
//   THIRD_STEP_TITLE: 'Completar',
//   THIRD_STEP_SUBTITLE: 'Agregue su contraseña y terminamos',
//   THIRD_STEP_INNER_TITLE: 'Último paso',
//   EMAIL_RECOMMENDATION: 'Usa tu email laboral, de esta forma podremos conectarte con tu equipo.',
// };

// const workspaceWizard = {
//   REPRESENT_QUESTION: '¿Cuál de estos te representa mejor?',
//   NO_WORKSPACE_TITLE: 'Aún no estás en un espacio de trabajo.',
//   NO_WORKSPACE_SUBTITLE: 'Un lugar de trabajo es donde sucede todo, suele ser una empresa.',
//   NO_WORKSPACE_FOOTER: 'Si no está seguro de qué hacer, lea las',
//   NO_WORKSPACE_CREATE_BUTTON: 'Crear un espacio de trabajo',
//   NO_WORKSPACE_SECONDARY_TEXT: 'a un existente',
//   CREATE_WORKSPACE_TITLE: 'Creación de espacio de trabajo',
//   CREATE_WORKSPACE_SUBTITLE: 'Un espacio de trabajo es donde viven todos los dispositivos y donde configuras la plataforma,
// generalmente representa a una empresa. Si no está seguro de qué hacer, lea las',
//   CREATE_WORKSPACE_BODY: 'Si tu equipo ya tiene un espacio de trabajo',
//   CREATE_WORKSPACE_QUESTION: '¿Representas a una empresa?',
//   SUBSCRIPTION_WORKSPACE_TITLE: 'Suscripción',
//   SUBSCRIPTION_WORKSPACE_SUBTITLE: 'Primero configuremos los módulos que desea activar, puede modificar esta configuración más tarde.',
//   SUBSCRIPTION_WORKSPACE_BODY: 'Si quieres leer sobre los módulos',
//   JOIN_WORKSPACE_TITLE: 'Únete a un espacio de trabajo existente',
//   JOIN_WORKSPACE_SUBTITLE: 'Para unirse a un espacio de trabajo,
// puede completar el ID del espacio de trabajo aquí, si no lo sabe, solicite una invitación al administrador del espacio de trabajo.',
// };

// const deviceList = {
//   CUSTOMER_TABLE_TITLE: 'Lista de clientes',
//   CUSTOMER_TABLE_SUBTITLE: 'Listado de clientes dentro del espacio de trabajo',
//   DEVICE_TABLE_SUBTITLE: 'Dispositivos pertenecientes al cliente seleccionado',
//   DELETE_CUSTOMER_QUESTION: '¿Seguro que quiere eliminar el cliente',
//   DELETED_CUSTOMER: 'El cliente ha sido eliminado',
//   DELETE_DEVICE_QUESTION: '¿Seguro que quiere eliminar el dispositivo',
//   DELETED_DEVICE: 'Dispositivo eliminado',
//   DEVICES: 'dispositivos',
// };

// const auth = {
//   // signup
//   SIGNUP: 'Registro',
//   SIGNUP_ACTION: 'Crear una cuenta',
//   SIGNUP_SUBTITLE: 'Ingrese su información para crear la cuenta',
//   REGISTRATION_SUCCESSFUL: '¡Registro exitoso! Se envió un correo electrónico para validar la cuenta.',
//   VALIDATED_ACCOUNT_SUCCESS: 'Su cuenta se ha validado correctamente',

//   // login
//   LOGIN: 'Iniciar sesión',
//   LOGIN_SUBTITLE: 'Ingrese su correo y contraseña',
//   GO_BACK_TO_LOGIN: 'Inicia sesión aqui',
//   BACK_TO_LOGIN_QUESTION: '¿Ya tienes cuenta?',

//   // forgotPassword
//   FORGOT_PASSWORD_QUESTION: `¿Olvido su ${formItems.PASSWORD}?`,
//   FORGOT_PASSWORD_SUBTITLE: `Ingrese su correo para restaurar su ${formItems.PASSWORD}`,
//   FORGOT_PASSWORD_SUCCESS: 'Se ha enviado un enlace al correo para que pueda recuperar su contraseña',

//   // resetPassword
//   RESET_PASSWORD: `Restablecer ${formItems.PASSWORD}`,
//   RESET_PASSWORD_SUBTITLE: `Ingresa tu nueva ${formItems.PASSWORD} y confirmala`,
//   RESET_PASSWORD_SUCCESS: `${formItems.PASSWORD} actualizada correctamente`,

//   // changePassword
//   CHANGE_PASSWORD: `Cambiar ${formItems.PASSWORD}`,
//   CHANGE_PASSWORD_SUBTITLE: `Ingrese los campos para cambiar su ${formItems.PASSWORD}`,
//   CHANGE_PASSWORD_SUCCESS: `${formItems.PASSWORD} actualizada correctamente`,
// };

// // always last
// const miscellaneous = {
//   AUTH_PAGE_TITLE: `Bienvenido a ${SOFTWARE_NAME}`,
//   AUTH_PAGE_SUBTITLE: 'El software de monitoreo más moderno del mercado',
//   COPYRIGHT: `${(new Date()).getFullYear()} ${SOFTWARE_NAME}`,
//   I_ACCEPT_THE: 'Yo acepto los',
//   TERMS_AND_CONDITIONS: 'Términos y condiciones',
//   HAVING_ISSUES: '¿Teniendo problemas?',
//   GET_HELP: 'Consigue ayuda',
//   FAQ: 'preguntas frecuentes',
//   CONTACT_US: 'contacta con nosotros',
//   CLICK_HERE: 'haga click aquí',
//   CLICK_HERE_TO_JOIN: 'haz clic aquí para unirte',
//   OR: 'o',
//   SKIP_STEP: 'omitir paso',
//   NO_ACCOUNT_QUESTION: '¿No tienes cuenta todavía?',
//   GO_BACK_TO_DASHBOARD: 'Volver al dashboard',
//   NO_CHANGES_MADE: 'No se realizaron cambios.',
//   NOTIFICATION: 'Notificación',
//   THEME: 'Tema',
//   SELECT_THEME: 'Seleccione tema',
//   THEME_LIGHT: 'Claro',
//   THEME_DARK: 'Oscuro',
//   APPEARANCE: 'Aspecto',
//   SELECT: 'Seleccione',
// };

// const profile = {
//   PERSONAL_INFORMATION: 'Información personal',
//   UPDATE_YOUR_INFORMATION: 'Actualiza tu información personal',
//   LANGUAGE: 'Idioma',
//   CUSTOMER_INFO: 'Información del cliente',
//   SELECT_LANGUAGE: 'Seleccione un idioma',
//   UPDATE_USER_SUCCESSFULL: 'Usuario actualizado exitosamente',
// };

export default {
  reporter_face: {
    title: 'Verificación facial',
    description:
      'Se administra aquí para este espacio de trabajo. El reportero captura su rostro en el teléfono tras confirmar su contraseña. Siempre podrá usar la contraseña.',
    // The long form explains the state; it is what the dialog shows and what
    // the table column puts in the chip's tooltip.
    status: {
      disabled: 'Desactivada',
      awaiting_capture: 'Pendiente de captura por el reportero',
      pending_approval: 'Pendiente de aprobación',
      approved: 'Aprobada',
    },
    // The short form fits a table cell.
    statusShort: {
      disabled: 'Desactivada',
      awaiting_capture: 'Pendiente de captura',
      pending_approval: 'Pendiente de aprobación',
      approved: 'Aprobada',
    },
    unavailable:
      'El servicio de verificación facial no está disponible actualmente.',
    reviewHelp:
      'Comprueba mediante una verificación de identidad fiable que este rostro pertenece al reportero indicado antes de aprobarlo.',
    preview: 'Rostro pendiente de aprobación',
    enable: 'Activar',
    approve: 'Aprobar',
    reject: 'Rechazar',
    reset: 'Solicitar nuevo registro',
    disable: 'Desactivar',
    erase: 'Eliminar datos faciales',
    error:
      'No se pudo actualizar la verificación facial. Comprueba tus permisos y actualiza antes de reintentar.',
    errors: {
      changed:
        'Este registro cambió mientras lo revisabas. Se ha actualizado, revísalo de nuevo.',
      notPending: 'Esta captura ya no está pendiente.',
    },
    confirm: {
      approve: 'He comprobado que este rostro pertenece a este reportero.',
      reject: '¿Rechazar esta captura y solicitar otra al reportero?',
      reset:
        '¿Eliminar el rostro actual y solicitar nueva captura y aprobación?',
      disable:
        '¿Desactivar la verificación facial y eliminar el rostro registrado?',
      erase:
        '¿Eliminar de forma permanente los datos faciales de este reportero en este espacio de trabajo? No se puede deshacer y funciona aunque ya no esté asignado a un dispositivo.',
    },
    close: 'Cerrar',
  },
  // traducciones genericas
  ...formItemsValidation,
  recurrence_days: {
    monday: 'LU',
    tuesday: 'MA',
    wednesday: 'MI',
    thursday: 'JU',
    friday: 'VI',
    saturday: 'SA',
    sunday: 'DO',
  },

  // **--------------- ** //
  'monitoring.call.button.tooltip': 'Realizar una llamada',
  'monitoring.chat.button.tooltip': 'Iniciar un chat',
  'monitoring.log.button.tooltip': 'Ver registro',
  'monitoring.verification.button.tooltip': 'Solicitar verificación de alarma',
  'monitoring.verification.error.no_eligible_members':
    'Ningún miembro de la conversación está vinculado como contacto de emergencia con códigos para este dispositivo.',
  'monitoring.verification.error.no_codes_configured':
    'Este dispositivo no tiene códigos de verificación. Agregue una clave secreta o de coacción al dispositivo, o un contacto de emergencia propio del dispositivo con correo y código.',
  'monitoring.verification.error.request_pending':
    'Ya hay una solicitud de verificación pendiente. Espere a que el usuario responda antes de enviar otra.',
  'monitoring.verification.error.generic':
    'No se pudo enviar la solicitud de verificación. Por favor intente nuevamente.',
  'monitoring.unread_chat_message': 'Mensaje de chat sin leer',
  'monitoring.open_situation_chat': 'Abrir chat',
  Resolution: 'Resolución',
  'authpage.title': 'Treinco',
  'authpage.subtitle': 'plataforma de monitoreo basada en la nube',
  'login.noaccount.message': 'Crea una cuenta gratis.',
  'page.authentication': 'Treinco Cloud',
  'login.link.register': 'Registrarse',
  'login.title': 'Iniciar sesión',
  'login.subtitle': '¿Ya estás registrado? Inicia sesión',
  'login.form.email': 'Correo electrónico',
  'login.form.password': 'Contraseña',
  'login.button.forgotPassword': '¿Olvidaste tu contraseña?',
  'login.button.submit': 'Inicia sesión',
  'register.title': 'Crea una cuenta',
  'register.subtitle':
    'Puedes crear una cuenta en segundos rellenando el siguiente formulario',
  'registered.title': 'Tu cuenta ha sido creada!',
  'registered.subtitle':
    'Revisa tu bandeja de entrada y confirma tu dirección de correo electrónico.',
  'signup.form.firstname': 'Nombre',
  'signup.form.lastname': 'Apellido',
  'signup.form.email': 'Correo Electrónico',
  'signup.form.password': 'Contraseña',
  'signup.form.confirmpassword': 'Confirma tu contraseña',
  'register.haveaccount.message': '¿Ya estás registrado?',
  'register.link.login': 'Inicia sesión',
  'register.info.fromInvitationLink':
    'Esta cuenta fue creada desde un enlace de invitación',
  'forgotpassword.title': 'Resetea tu contraseña',
  'forgotpassword.subtitle':
    '¿Olvidaste tu contraseña? Rellena el formulario y te ayudaremos a crear una nueva.',
  'forgotpassword.button.submit': 'Resetea tu contraseña',
  'forgotpassword.link.login': 'Inicia sesión',
  'signup.success': '¿Listo para comenzar?',
  'signup.link.login': 'Inicia sesión',
  'signup.button.submit': 'Registrarse',
  'forgotpassword.success': 'Revisa tu bandeja de entrada',
  'forgotpassword.confirmation.send.to': 'Te hemos enviado un correo a',
  'forgotpassword.confirmation.check.email':
    'Allí encontrarás las instrucciones para crear una nueva contraseña',
  'validateaccount.success': 'Hemos validado tu cuenta',
  'validateaccount.link.login': 'Inicia sesión',
  'resetpassword.title': 'Crear nueva contraseña',
  'resetpassword.subtitle': 'Usa una contraseña segura y que puedas recordar',
  'resetpassword.form.password': 'Contraseña',
  'resetpassword.form.confirmpassword': 'Confirma tu contraseña',
  'resetpassword.form.button.submit': 'Crear nueva contraseña',
  'resetpassword.success': 'Tu contraseña ha sido actualizada',
  'resetpassword.link.login': 'Iniciar sesión',

  // User Profile Form
  'userprofile.form.firstname': 'Nombre',
  'userprofile.form.lastname': 'Apellido',
  'userprofile.form.email': 'Correo electrónico',

  // Invite Members Form
  'invite_members_form.title': 'Invitar Miembro',
  'invite_members_form.subtitle': 'Enviar una invitación a un nuevo miembro',
  'invite_members_form.email': 'Correo electrónico',
  'invite_members_form.button_submit_label': 'Enviar Invitación',
  'invite_members_form.success': 'Invitación enviada exitosamente',
  'invite_members_form.error.user_exist': 'Este usuario ya existe',
  'invite_members_form.error.user_invited_already':
    'Este usuario ya ha sido invitado',
  'invite_members_form.error.general_error':
    'Ocurrió un error al enviar la invitación',
  'invite_members_form.error.device_not_belong_to_customer':
    'Uno de los dispositivos seleccionados no pertenece a este cliente',
  'invite_members_form.error.inviter_role_ambiguous':
    'Los dispositivos seleccionados tienen roles distintos. Invítelos por separado.',

  // Edit Members Form

  'edit_members_form.title': 'Editar Miembro',
  'edit_members_form.subtitle': 'Editar un miembro existente',
  'user_edit_form.devices': 'Dispositivos',

  // Monitoring

  'situation_category.title_text': 'Categorías de Situaciones',
  'situation_category.category_label': 'Seleccionar Categoría de Situación',
  'situation_category.process_button': 'Procesar Situación',
  'situation_category.fetch_error':
    'Error al cargar categorías. Por favor intente nuevamente.',

  'events.event_field_text': 'Evento',
  'events.generated_at_text': 'Generado',
  'events.received_at_text': 'Recibido',
  'events.action_field_text': 'Acciones',

  'removeDeviceHistory.success': 'Evento excluido de la situación',
  'removeDeviceHistory.error': 'Falló al excluir el evento',

  'select.one': 'Selecciona',
  'resolution.placeholder':
    'Escribe lo que está pasando sobre esta situación para procesarla o agregarlo al log',
  'monitoring.process.button.text': 'Procesar',
  'monitoring.comment.button.text': 'Comentar',
  'monitoring.pending.button.text': 'Pasar a pendientes',
  'monitoring.pending.button.hold': 'Sacar de pendientes',
  'monitoring.transfer.button.text': 'Transferir',
  'monitoring.process_bulk_modal': 'Procesado por lotes',
  'monitoring.bulk.select_all': 'Seleccionar todos',
  'monitoring.situation_events_count': 'Eventos por procesar',
  'Monitoring.bulk.byEventCode': 'Por código de evento',
  'Monitoring.bulk.byDevice': 'Por dispositivo',
  'Monitoring.bulk.byEventgroup': 'Por grupo de evento',
  'Monitoring.bulk.all': 'Todas',
  'events.timeline.title_text': 'Log',
  'timeline.error_text': 'No se pudo cargar el log.',
  'timeline.retry_button_text': 'Reintentar',
  'events.notes.title_text': 'Notas',
  'events.notes.empty_state': 'Sin notas para este dispositivo.',
  'notes.createdAt': 'Creado',
  'notes.expiresAt': 'Expira',
  'events.tab.activities': 'Actividades',
  'events.tab.events': 'Eventos',
  'events.activities.empty': 'No hay cámaras asociadas a la ronda activa',
  'events.activities.channel_commented': 'Canal ya comentado',
  'events.activities.comment_channel': 'Comentar canal',
  'events.activities.round_started':
    'Ronda CCTV iniciada — la pestaña de Actividades ya está disponible',
  'events.timeline.opened_cctv_camera_log_text': 'Cámara abierta',
  'events.timeline.opened_cctv_camera_log_description':
    '{{ operator }} abrió la cámara {{ channelName }}',
  'events.timeline.checked_cctv_channel_log_text': 'Canal revisado',
  'events.timeline.checked_cctv_channel_log_description':
    '{{ operator }} revisó el canal {{ channelName }}: "{{ comment }}"',
  'events.contacts.title_text': 'Contactos de Emergencia',
  'monitoring.chat.button.text': 'Chat',
  'monitoring.call.button.text': 'Llamar',
  'monitoring.send.button.tooltip': 'Enviar (próximamente)',
  'monitoring.games.button.tooltip': 'Acciones rápidas (próximamente)',
  'monitoring.general_chat_tooltip': 'Chat general',
  'monitoring.situation_chat_tooltip': 'Chat de situación',
  'Situation.comment.success': 'Comentario agregado',
  'Situation.comment.error': 'Error al enviar el comentario',

  'pending_situation_time_form.time_label': 'Tiempo de espera',
  'pending_situation_time_form.time_placeholder': 'Minutos',
  'pending_situation_time_form.time_error':
    'El tiempo debe ser mayor a 1 y menor a 720 minutos',
  'pending_situation_time_form.submit_button': 'Pasar a pendientes',
  'pending_situation_time_form.title_text': 'Pasar a pendientes',

  'monitoring.summary.button': 'Generar resumen',
  'monitoring.summary.loading': 'Generando...',
  'monitoring.summary.success': 'Resumen generado con éxito',
  'monitoring.summary.error': 'Error al generar el resumen',
  'monitoring.summary.disabled.no_key':
    'Falta configurar la API Key de OpenRouter en el Espacio de Trabajo',
  'monitoring.summary.disabled.no_call':
    'No hay grabaciones de llamadas completadas para esta situación',

  'events.timeline.assigned_log_text': 'Asignada',
  'events.timeline.assigned_event_log_text': 'Evento asignado',
  'events.timeline.abandoned_log_text': 'Abandonada',
  'events.timeline.abandoned_event_log_text': 'Evento excluido',
  'events.timeline.created_log_text': 'Creada',
  'events.timeline.opened_log_text': 'Abierta',
  'events.timeline.comment_log_text': 'Comentada',
  'events.timeline.processed_log_text': 'Procesada',
  'events.timeline.default_log': 'Sin clasificar',
  'events.timeline.autoprocessed_log_text': 'Autoprocesada',
  'events.timeline.opened_conversation_log_text': 'Chat abierto',
  'events.timeline.contact_called_log_text': 'Llamada',

  'events.timeline.commented_log_description':
    '{{ operator }} comentó: "{{ comment }}"',
  'events.timeline.opened_log_description':
    '{{ operator }} evaluó esta situación',
  'events.timeline.assigned_log_description':
    'La situación fue asignada al operador {{ operator }}',
  'events.timeline.processed_log_description':
    'La situación fue procesada por {{ operator }}',
  'events.timeline.created_log_description': 'Situación generada',
  'events.timeline.assigned_event_log_description':
    'Evento {{ eventCode }} asignado a la situación',
  'events.timeline.opened_conversation_log_description':
    'Conversación de chat abierta',
  'events.timeline.abandoned_event_log_description':
    'Evento {{ eventCode }} excluido de la situación',
  'events.timeline.autoprocessed_log_description': 'Situación autoprocesada',
  'events.timeline.reason_label': 'Razón',
  'events.timeline.abandoned_log_text': '{{ operator }} abandonó la situación',
  'events.timeline.contact_called_log_description':
    '{{ operator }} hizo una llamada al {{ phoneNumber }}',

  'events.timeline.call_comment_text': 'Comentario de llamada',
  'events.timeline.call_comment_customer_description': `Se llamó al número del cliente {{ phoneNumber}}: {{ comment}}`,
  'events.timeline.call_comment_device_description': `Se llamó al número del dispositivo {{ phoneNumber}}: {{ comment}}`,
  'events.timeline.call_comment_description':
    'Se llamó al usuario {{ phoneContact }} al número {{ phoneNumber }}: {{ comment }}',
  'events.timeline.call_recording_text': 'Llamada grabada',
  'events.timeline.call_recording_description':
    'Llamada al {{ number }} grabada - {{ duration }}',
  'events.timeline.duress_confirmed_log_text': 'Duress confirmado',
  'events.timeline.duress_confirmed_log_description':
    'El usuario confirmó que la alarma ES REAL (código duress)',
  'events.timeline.set_to_pending_log_text': 'Pasada a pendiente',
  'events.timeline.set_to_pending_log_description':
    '{{ operator }} pasó la situación a pendiente',
  'voip.recording_listen': 'Escuchar',
  'voip.recording_loading': 'Cargando...',
  'voip.recording_incomplete': 'Escuchar (incompleta)',
  'voip.call_summary':
    'Resumen de la llamada (generado por IA, puede contener errores)',
  'voip.saving_recording':
    'Guardando grabación... Por favor no cierre esta ventana',

  'monitoring.call_window_title': 'Hacer una llamada',
  'contacts.phone_number_label': 'Número de teléfono {{ index }}',
  'contacts.local_phone_label': 'Número de teléfono local',
  'contacts.mobile_phone_label': 'Número de teléfono móvil',
  'contacts.group_label': 'Contacto(s): {{ count }}',
  'contacts.empty_contacts_text': 'No hay contactos disponibles',
  'contacts.contact_information_title': 'Información de Contacto',
  'contacts.security_codes_title': 'Códigos de Seguridad',
  'contacts.person_id_label': 'ID de Persona:',
  'contacts.cra_code_label': 'Código CRA',
  'contacts.duress_code_label': 'Coacción',
  'contacts.confirmation_code_label': 'Confirmación',
  'contacts.not_available': 'N/D',
  'contacts.emergency_fallback': 'Emergencia',
  'contacts.contact_fallback': 'Contacto',
  'contacts.device_fallback': 'Dispositivo',
  'contacts.user_fallback': 'Usuario',
  'contacts.emergency_contact_category': 'Contacto de Emergencia',
  'contacts.device_user_category': 'Usuario del Dispositivo',
  'contacts.customer_category': 'Cliente',
  'contacts.device_contact_category': 'Contacto del Dispositivo',
  'contacts.emergency_contact_info_default':
    'Información de contacto de emergencia',
  'contacts.customer_address_not_available':
    'Dirección del cliente no disponible',
  'phonebook.customer_contacts': 'Clientes',
  'phonebook.device_contacts': 'Dispositivos',
  'phonebook.user_contacts': 'Usuarios',
  'phonebook.emergency_contacts': 'Contactos de emergencia',

  'self.generated': 'Autogenerada',
  'self.processed': 'Autoprocesada',
  'self.devicehistory_details_title': 'Detalles de la señal',
  'situation.log': 'Log de situación',
  'device_history_table.chat_history': 'Historial de chat',
  'device_history_table.more_info_button': 'Más información',
  'device_history_table.processed_view': 'Procesada',
  'device_history_table.original_view': 'Original',

  'Situation.processed.success': 'La situación fue procesada exitosamente',
  'Situation.processed.error': 'Error al procesar la situación',

  'monitoring.monitoring_error_modal_title': 'Mensaje importante',
  'monitoring.operator_already_exists_message':
    'Ya estás conectado al servicio de monitoreo',
  'monitoring.expired_user_connection_message':
    'Tu conexión al servicio de monitoreo ha expirado, por favor recarga',
  'monitoring_monitoring_error_modal.button_reset': 'Recargar',

  'sidebar.dashboard_tab_title': 'Panel',
  'sidebar.monitoring_tab_title': 'Monitoreo',
  'sidebar.traffic_tab_title': 'Tráfico',
  'sidebar.customers_tab_title': 'Clientes',
  'sidebar.devices_tab_title': 'Dispositivos',
  'sidebar.reports_tab_title': 'Reportes',
  'sidebar.invoices_tab_title': 'Facturas',
  'sidebar.places_tab_title': 'Lugares',
  'sidebar.settings_tab_title': 'Configuración',
  'sidebar.chat_tab_title': 'Chat',
  'sidebar.service_orders_tab_title': 'Órdenes de servicio',

  // Generic table
  'table.more_options.edit': 'Editar',
  'table.more_options.delete': 'Eliminar',
  'table.create_button.text': 'Crear',

  // Workspaces
  'page.workspace.create': 'Crear Espacio de Trabajo',
  'page.workspaces.title': 'Espacios de trabajo',
  'page.workspaces.subtitle':
    'Selecciona o administra los espacios de trabajo a los que perteneces',
  'workspaces.create_workspace.button.text': 'Crear espacio de trabajo',
  'workspace.select_workspace_error.snackbar.text':
    'Tuvimos problemas para obtener la información del espacio de trabajo',
  'workspace.super_admin_role': 'Super Admin',
  'workspaces.create_workspace_modal.step1.text': 'Paso 1',
  'workspaces.create_workspace_modal.step2.text': 'Paso 2',
  'workspaces.create_workspace_modal.step3.text': 'Paso 3',
  'workspaces.create_workspace_modal.step1.title':
    'Elije el nombre de tu espacio de trabajo',
  'workspaces.create_workspace_modal.step1.subtitle':
    'Este es el nombre con el que se identificará tu espacio de trabajo y será visible para todo tipo de usuarios',
  'workspaces.create_workspace_modal.back_button.text': 'Atrás',
  'workspaces.create_workspace_modal.finish_button.text':
    'Crear espacio de trabajo',
  'workspaces.create_workspace_modal.next_button.text': 'Siguiente',
  'workspaces.create_workspace_modal.step2.title':
    'Selecciona el tipo de espacio de trabajo que deseas crear',
  'workspaces.create_workspace_modal.step2.subtitle':
    'Dependiendo del tipo de espacio de trabajo que crees adaptaremos la interfaz para ofrecerte una mejor experiencia',
  'workspaces.create_workspace_modal.step2.card1.title': 'Básico',
  'workspaces.create_workspace_modal.step2.card1.subtitle':
    'Si solo monitoreas tus propios dispositivos',
  'workspaces.create_workspace_modal.step2.card2.title': 'Avanzado',
  'workspaces.create_workspace_modal.step2.card2.subtitle':
    'Cuando monitoreas dispositivos que pertenecen a distintos clientes',
  'workspaces.create_workspace_modal.step3.title':
    'Estamos listos para crear el espacio de trabajo',
  'workspaces.create_workspace_modal.step3.subtitle':
    'Cuando hagas clic en crear, nos encargaremos de configurar el nuevo workspace donde podrás administrar dispositivos y usuarios de forma aislada.',
  'createWorkspace.finish.title': 'Espacio de Trabajo Creado Exitosamente',
  'createWorkspace.finish.description':
    'Su espacio de trabajo se está configurando. Esto puede tomar unos momentos.',
  'createWorkspace.error.title': 'Error al Crear Espacio de Trabajo',
  'createWorkspace.error.description':
    'Algo salió mal al crear su espacio de trabajo. Por favor, inténtelo de nuevo.',
  'workspace.remove.avatar.title': 'Eliminar avatar',
  'workspace.remove.avatar.description':
    'Seguro que desea eliminar la imagen permanentemente?',
  'CreateWorkspace.success': 'Espacio de trabajo creado exitosamente',
  'CreateWorkspace.error': 'Error al crear el espacio de trabajo',
  // Monitoring
  'monitoring.situations_tab_title': 'Situaciones',
  'monitoring.device_history_tab_title': 'Tráfico',
  'monitoring.on_hold_tab_title': 'Pendientes',
  'monitoring.situation.processedByUser':
    'Esta situación fue verificada y procesada por el usuario desde la app',
  'page.monitoring.title': 'Monitoreo',
  'page.monitoring.subtitle':
    'En este módulo recibirás los eventos de tus dispositivos que deban ser procesados',
  'monitoring.monitoring_table.name_field_text': 'Dispositivo',
  'monitoring.monitoring_table.events_field_text': 'Evento',
  'monitoring.monitoring_table.complement_field_text': 'Complemento',
  'monitoring.monitoring_table.extra_field_text': 'Extra',
  'monitoring.monitoring_table.date_field_text': 'Recibido',
  'monitoring.monitoring_table.actions_field_text': 'Acciones',
  'createDeviceHistory.submit': 'Simular historial',
  'createDeviceHistory.form.longitude': 'Longitud',
  'createDeviceHistory.form.latitude': 'Latitud',
  'createDeviceHistory.form.line': 'Línea',
  'createDeviceHistory.form.partition': 'Partición',
  'createDeviceHistory.form.zone_or_user': 'Zona o usuario',
  'createDeviceHistory.form.channel': 'Canal',
  'createDeviceHistory.form.code': 'Código de evento',
  'createDeviceHistory.form.protocol': 'Protocolo',
  'createDeviceHistory.form.device': 'Dispositivo',
  'createDeviceHistory.dialog.subtitle':
    'Aquí puedes simular un evento en el historial del dispositivo',
  'createDeviceHistory.dialog.title': 'Simular evento',
  'monitoring.map_situationDevice.no_position': 'Dispositivo sin posición',
  'timeline_grid.details_modal_title': 'Detalles',
  'timeline_grid.no_user_text': 'Sin usuario',

  // Traffic

  'page.traffic.title': 'Tráfico',
  'page.traffic.subtitle':
    'En este módulo puedes ver todo el tráfico de tus dispositivos conectados',

  // Emergency Contact List
  'emergency_contact_list.title_text': 'Lista de contactos de emergencia',
  'emergency_contact_list_table.name_field_text': 'Contacto de Emergencia',
  'emergency_contact_list_table.order_field_text': 'Orden',
  'emergency_contact_list_table.phone_numbers_field_text': 'Teléfonos',
  'emergency_contact_list_table.call_field_text': 'Llamar',
  'emergency_contact_list_table.actions_field_text': 'Acciones',
  'emergency_contact_list.button_add_emergency_contact':
    'Agregar contacto de emergencia',
  'emergency_contact_list.button_update_emergency_contact_list_order':
    'Actualizar lista de contactos de emergencia',
  // Customers
  'page.customers.title': 'Clientes',
  'page.customers.subtitle':
    'En este módulo puedes administrar tus clientes. Los clientes son los usuarios finales y estos agrupan dispositivos.',
  'customers.table.name_field.text': 'Cliente',
  'customers.table.identifier_field.text': 'Identificador',
  'customers.table.devices_field.text': 'Dispositivos',
  'customers.table.actions_field.text': 'Acciones',
  'customers.table.link.customer': 'Ir al cliente',
  'customerForm.title': 'Cliente',
  'customer.form.name': ' Nombre',
  'customer.form.identifier': 'Identificador único',
  'customerSelector.add.customer.submit': 'Crear cliente',
  'customerSelector.edit.customer.submit': 'Editar cliente',
  'CreateCustomer.create.success': 'Cliente creado exitosamente',
  'CreateCustomer.edit.success': 'Cliente actualizado exitosamente',
  'CreateCustomer.create.error': 'Error al crear el cliente',
  'EditCustomer.create.error': 'Error al actualizar el cliente',
  'DeleteCustomer.delete.error': 'Error al eliminar el cliente',

  // Missing translations batch
  'DeleteCustomer.delete.success': 'Cliente eliminado correctamente',
  'devicePartition.schedule.partition.created': 'Partición asignada al horario',
  'devicePartition.schedule.partition.removed':
    'Partición removida del horario',
  'updateWorkspace.general.success':
    'Espacio de trabajo actualizado correctamente',
  'customer_profile.no_identifier_text': 'Sin identificador',
  'customer.no_identifier_text': 'Sin identificador',
  'InvitationItem.success.message': 'Invitación eliminada correctamente',
  'userItem.success.message': 'Usuario eliminado correctamente',
  'membersItem.delete.title.confirmation': 'Eliminar miembro',
  'membersItem.delete.confirmation': '¿Seguro que desea eliminar este miembro?',
  'resetpassword.invalidlink': 'Este enlace no es válido o ha expirado',
  'workspace.delete.title.confirmation': 'Eliminar avatar',
  'workspace.avatar.delete.confirmation':
    'Los datos eliminados no se pueden recuperar',
  'register.message.accept.invitation': 'Regístrate para aceptar tu invitación',
  'login.info.fromInvitationLink': 'Inicia sesión para aceptar tu invitación',
  'customerItem.delete.title.confirmation': 'Eliminar cliente',
  'customerItem.delete.confirmation':
    '¿Estás seguro de que deseas eliminar este cliente? Esta acción no se puede deshacer.',

  // Customer profile
  'customer_profile.devices_tab_title': 'Dispositivos',
  'customer_profile.members_tab_title': 'Miembros',
  'customer_profile.title_text': 'Ficha del cliente',
  'customer_profile.delete_customer_confirmation_title_text':
    'Eliminar cliente',
  'customer_profile.delete_customer_confirmation_description_text':
    '¿Estás seguro de que deseas eliminar este cliente? Esta acción no se puede deshacer.',
  'members_table.name_field.text': 'Nombre',
  'members_table.type_field_text': 'Tipo',
  'members_table.actions_field.text': 'Acciones',
  'members_table.action_field_text': 'Acción',
  'members_table.invite_member_text': 'Invitar usuario',
  'members_table.invitation_type_text': 'Invitación',
  'members_table.access_type': 'Tipo de acceso',
  'members_table.access_all': 'Todos los dispositivos',
  'members_table.access_devices': 'Dispositivos',
  'invitation.waiting.approval': 'Esperando aprobación',
  'customer.change_avatar_modal.title': 'Cambiar avatar',
  'customer.remove.avatar.title': 'Eliminar avatar',
  'customer.remove.avatar.description':
    'Seguro que desea eliminar la imagen permanentemente?',
  'customer.view_avatar_modal.label': 'Ver avatar',
  'customer.view_avatar_modal.title': 'Avatar',
  // Customer Category Select
  'customer_category.created_success': 'Categoría creada exitosamente',
  'customer_category.create_error': 'Error al crear la categoría',
  'customer_category.select_label': 'Categoría del cliente',
  'customer_category.search_error': 'Error al buscar categorías',
  'customer_category.add_new': 'Agregar nueva categoría',
  'customer_category.create_title': 'Crear nueva categoría',
  'customer_category.description_label': 'Descripción de la categoría',
  'customer_category.create_button': 'Crear',
  'customer_profile.general_tab_title': 'General',
  // Monitoring
  'device_profile.events_tab_title': 'Situación',

  // Devices
  'page.devices.title': 'Dispositivos',
  'page.devices.subtitle':
    'En este módulo puedes administrar y ver todo lo relacionado con tus dispositivos conectados',
  'devices.button_create': 'Crear',
  'devices.title_text': 'Dispositivos',

  'createdevice.create.title': 'Crear dispositivo',
  'createdevice.create.subtitle': 'Sigue los pasos para crear tu dispositivo',
  'customer.select': 'Selecciona un cliente',
  'createalarm.form.uniqueid': 'Identificador',
  'createalarm.form.name': 'Nombre',
  'creategps.form.uniqueId': 'Identificador',
  'creategps.form.name': 'Nombre',
  'CreateRound.form.uniqueId': 'Identificador',
  'CreateRound.form.name': 'Nombre',
  'createBrand.form.brand': 'Seleccione una marca',
  'createalarm.form.model': 'Seleccione un modelo',
  'createdevice.button.submit': 'Crear dispositivo',
  'updatedevice.button.submit': 'Actualizar dispositivo',
  'createalarm.form.is_active_input_label': 'Estado general',
  'createalarm.form.is_active_input_description': 'Activo o inactivo',
  'createalarm.form.is_monitoring_input_label': 'Monitoreable',
  'createalarm.form.is_monitoring_input_description':
    'Este dispositivo es monitoreable',
  'createalarm.form.is_push_notifications_enabled_label': 'Notificaciones Push',
  'createalarm.form.is_push_notifications_enabled_description':
    'Habilitar notificaciones push para este dispositivo',
  'createalarm.form.prefix': 'Prefijo',
  'createDevice.edit.title': 'Editar dispositivo',
  'createDevice.edit.subTitle': 'Aquí puedes editar tu dispositivo',
  'createDevice.form.timezone': 'Zona horaria',

  'createdevice.create.cctv_type': 'Tipo de CCTV',
  'createdevice.create.fields.ipAddress': 'IP / DNS',
  'createdevice.create.fields.port': 'Puerto',

  'createdevice.create.fields.connectionString': 'Cadena de conexión',
  'createdevice.create.fields.user': 'Usuario',
  'createdevice.create.fields.password': 'Contraseña',
  'createdevice.create.fields.serial': 'Serial',
  'createdevice.create.fields.hikvisionKey': 'Key',
  'createdevice.create.fields.hikvisionSecret': 'Secret',

  'create_treinco_app.form.email': 'Correo electrónico',
  'create_treinco_app.form.name': 'Nombre',
  'create_treinco_app.form.last_name': 'Apellido',
  'create_treinco_app.form.device_name': 'Nombre del dispositivo',
  'create_treinco_app.button.submit': 'Enviar invitación',

  'device.type.subtitle.gps':
    'Rastrea posiciones GPS en tiempo real y recibe alertas de movimiento, velocidad y zonas geográficas de vehículos o unidades móviles.',
  'device.type.subtitle.alarm':
    'Conecta y supervisa paneles de alarma con múltiples zonas. Recibe automáticamente alertas de intrusión, incendio, pánico y fallos técnicos de los sensores conectados.',
  'device.type.subtitle.round':
    'Configura rondas de patrullaje, puntos de control y tipos de incidentes. Recibe registros automáticos y alertas cuando los guardias completan o incumplen las rondas programadas.',
  'device.type.subtitle.treinco-app':
    'Da a tus clientes (usuarios finales) acceso en tiempo real al estado y ubicación de sus dispositivos. Las centrales de monitoreo pueden configurar botones personalizados para que envíen alertas al instante.',
  'device.type.subtitle.cctv':
    'Conecta sistemas de CCTV para ver transmisiones en vivo, detectar movimiento y recibir alertas relacionadas con cámaras desde tu panel de monitoreo.',

  'devices.name_field_text': 'Dispositivo',
  'devices.type_field_text': 'Tipo',
  'devices.info_field_text': 'Información',
  'devices.speed_field_text': 'Velocidad',
  'devices.status_field_text': 'Estado',
  'devices.action_field_text': 'Acciones',
  'devices.customer_field_text': 'Cliente',
  'devices.no_customer_text': 'Sin cliente',
  'devices.created_field_text': 'Creado',
  'devices.services_status_field_text': 'Estado de los servicios',
  'devices.events_tooltip_text': 'Lista de eventos',
  'devices.routes_tooltip_text': 'Rutas',
  'devices.close_panel_tooltip_text': 'Cerrar',

  'devicetable.link.device.profile': 'Ir a la ficha',
  'devicetable.link.edit.device': 'Editar',
  'devicetable.delete.device': 'Eliminar',
  'device.delete.title.confirmation': 'Eliminar dispositivo',
  'device.delete.confirmation':
    '¿Estás seguro de que deseas eliminar este dispositivo? Esta acción no se puede deshacer.',
  'deviceTable.success.message': 'Dispositivo eliminado exitosamente',
  'deviceTable.error.active_situation_message':
    'El dispositivo tiene una o más situaciones activas',

  'devices.alarm_type_text': 'Alarma',
  'devices.round_type_text': 'Rondas',
  'devices.gps_type_text': 'GPS',
  'devices.treinco_app_type_text': 'Treinco App',
  'devices.cctv_type_text': 'CCTV',

  'deviceEvent_table.actions_field': 'Acciones',
  'deviceEvent.create_device_event_form': 'Formulario de grupo de eventos',
  'createDeviceHistory.form.event': 'Seleccione evento',
  'event.form.type_zone_option': 'Zona',
  'event.form.type_user_option': 'Usuario',
  'event.form.type_none_option': 'Ninguno',

  'devicemap.tooltip.latitude': 'Latitud',
  'devicemap.tooltip.longitude': 'Longitud',
  'devicemap.tooltip.speed': 'Velocidad',
  'devicemap.tooltip.date': 'Fecha',
  'devicemap.tooltip.status': 'Estado',

  'routes.tooltip.no_direction': 'Sin dirección',
  'routes.tooltip.no_time': 'Sin tiempo',
  'routes.tooltip.no_distance': 'Sin distancia',
  'routes.tooltip.no_battery': 'Sin batería',
  'routes.tooltip.no_status': 'Sin estatus',
  'routes.tooltip.no_speed': 'Sin velocidad',
  'routes.tooltip.no_gps_date': 'Sin fecha gps',
  'route.tooltip.no_server_date': 'Sin fecha del servidor',
  'route.tooltip.signal_level': 'Nivel de señal',
  'route.tooltip.battery': 'Batería',
  'route.tooltip.end_date': 'Fecha de fin',
  'route.tooltip.initial_date': 'Fecha de inicio',
  'route.tooltip.stop_time': 'Tiempo de parada',
  'route.tooltip.status': 'Estatus',
  'route.tooltip.gps_date': 'Fecha gps',
  'route.tooltip.date': 'Fecha',

  // Device Profile
  'device_profile.title_text': 'Ficha del dispositivo',
  'device_profile.alarm_type_text': 'Alarma',
  'device_profile.round_type_text': 'Rondas',
  'device_profile.gps_type_text': 'GPS',
  'device_profile.treinco_app_type_text': 'Treinco App',
  'device_profile.cctv_type_text': 'CCTV',

  'device_profile.situation_tab_title': 'Situación',
  'device_profile.reporters_tab_title': 'Personas',
  'device_profile.map_tab_title': 'Mapa',
  'device_profile.zones_tab_title': 'Zonas',
  'device_profile.schedule_tab_title': 'Horarios',
  'device_profile.rounds_tab_title': 'Rondas',
  'device_profile.users_tab_title': 'Usuarios',
  'device_profile.history_tab_title': 'Historial',
  'device_profile.emergency_contact_tab_title': 'Contactos',
  'device_profile.notes_tab_title': 'Notas',
  'device_profile.channels_tab_title': 'Canales',
  'device_profile.orders_tab_title': 'Órdenes de Servicio',
  'device_profile.partitions_tab_title': 'Particiones',
  'device.remove.avatar.title': 'Eliminar avatar',
  'device.remove.avatar.description':
    'Seguro que desea eliminar la imagen permanentemente?',
  show_expired_notes: 'Mostrar notas vencidas',
  hide_expired_notes: 'Ocultar notas vencidas',
  'device_profile.timers_tab_title': 'Temporizadores',
  'device_profile.inactivations_tab_title': 'Desactivaciones',
  'device_profile.custom_events_tab_title': 'Eventos personalizados',
  'device_profile.attachments_tab_title': 'Adjuntos',
  'device_profile.links_tab_title': 'Enlaces',
  'device.change_avatar_modal.title': 'Cambiar avatar',
  'device.view_avatar_modal.label': 'Ver avatar',
  'device.status.isActive': 'Dispositivo activo',
  'device.status.isMonitorable': 'Dispositivo monitorable',
  'device.status.isPushNotificationsEnabled': 'Notificaciones push habilitadas',
  'device_profile.unknown_status_text': 'Desconocido',
  'device_profile.status_tooltip': 'Estado del dispositivo',
  'device_profile.empty_address_text': 'Sin ubicación',
  'device_profile.customer_id_label': 'ID de cliente',
  'speed_limit_form.title_text': 'Configurar limite de velocidad',
  'speed_limit_form.speed_limit_label_text': 'Límite de velocidad',
  'speed_limit_form.submit_text': 'Guardar límite de velocidad',
  'command_form.title_text': 'Enviar comando',
  'command_form.send_by_label': 'Enviar vía',
  'command_form.command_select_label_text': 'Selecciona un comando',
  'command_form.submit_text': 'Enviar comando',
  'command_form.error_message': 'Error al enviar el comando',

  'history.event.not.exist': 'Evento no existe',

  'open.geofence.list': 'Geocercas',
  'close.geofence.list': 'Cerrar geocercas',
  'open.route.list': 'Recorridos',
  'close.route.list': 'Cerrar recorridos',

  'geofences.empty.create':
    'Aún no has creado geocercas para este dispositivo, cuando haya se mostrarán aquí.',

  'geofences.button.create': 'Crear',

  'item.update_default.title.confirmation':
    '¿Estás seguro de que quieres establecer este grupo como predeterminado?',
  'item.update_default.confirmation':
    'Esto solo afectará a los nuevos dispositivos',
  'table.more_options.set_default': 'Establecer como predeterminado',

  'zones.identifier_field_text': 'Identificador',
  'zones.name_field_text': 'Nombre',
  'zones.partition_field_text': 'Partición',
  'zones.action_field_text': 'Acciones',
  'CreateZoneDialog.dialog.title': 'Crear zona',
  'CreateZoneDialog.dialog.subtitle':
    'Aquí tú puedes crear una zona para usar en tu dispositivo',
  'createZoneDialog.create': 'Crear zona',
  'createZoneDialog.update': 'Editar zona',
  'createZoneDialog.form.identifier': 'Identificador',
  'createZoneDialog.form.name': 'Nombre de la zona',
  'deviceZone.delete.title.confirmation': 'Eliminar zona',
  'deviceZone.delete.subtitle.confirmation':
    '¿Estás seguro que deseas eliminar la zona?',
  'createDeviceZone.general.error': 'Error creando la zona del dispositivo',
  'deviceUsertable.edit.assign.partition': 'Asignar partición',
  'deviceUsertable.edit.deviceUser': 'Editar',
  'deviceUsertable.delete.deviceUser': 'Eliminar',
  'deviceZonetable.edit.deviceZone': 'Editar',
  'deviceZonetable.delete.deviceZone': 'Eliminar',
  'deviceZonetable.manage.deviceZoneCCTV': 'Gestionar asociaciones de CCTV',
  'deviceZonetable.schedule.deviceZone': 'Configuración de horarios',
  'deviceZoneSchedule.create_success':
    'Horario de la zona creado correctamente',
  'deviceZoneSchedule.create_error': 'Error al crear horario de la zona',
  'deviceZoneSchedule.day.Monday': 'Lunes',
  'deviceZoneSchedule.day.Tuesday': 'Martes',
  'deviceZoneSchedule.day.Wednesday': 'Miércoles',
  'deviceZoneSchedule.day.Thursday': 'Jueves',
  'deviceZoneSchedule.day.Friday': 'Viernes',
  'deviceZoneSchedule.day.Saturday': 'Sábado',
  'deviceZoneSchedule.day.Sunday': 'Domingo',
  'deviceZoneSchedule.form_startTime': 'Hora inicial',
  'deviceZoneSchedule.form_endTime': 'Hora final',
  'deviceZoneSchedule.form.enabled': 'Habilitado',
  'deviceZoneSchedule.form.disabled': 'Deshabilitado',
  'zones.schedule_dialog_title': 'Gestionar horarios de la zona',
  'zones.schedule_dialog_subtitle':
    'Aquí puedes configurar horarios de la partición',
  'deviceZoneSchedule.form.save_button': 'Guardar',
  'deviceZoneSchedule.validation.startTimeRequired':
    'La hora de inicio es requerida cuando está habilitado',
  'deviceZoneSchedule.validation.endTimeRequired':
    'La hora de finalización es requerida cuando está habilitado',
  'deviceZoneSchedule.validation.endTimeAfterStart':
    'La hora de finalización debe ser posterior a la hora de inicio',
  'deviceZoneSchedule.loading_error': 'Error cargando horarios de la zona',
  'deviceZoneSchedule.validation.differentTimes':
    'La hora de finalización debe ser diferente de la hora de inicio',
  'deviceZoneSchedule.validation.noOverlaps':
    'Los horarios no pueden solaparse entre sí',
  'deviceZoneSchedule.validation.overlapDetected': 'Choque de horarios',
  'deviceZoneSchedule.validation.overlapType.identical': 'Horarios idénticos',
  'deviceZoneSchedule.validation.overlapType.partial': 'Solapamiento parcial',
  'deviceZoneSchedule.validation.overlapType.contained': 'Horario contenido',
  'deviceZoneSchedule.validation.overlapType.contains': 'Horario contiene otro',
  'deviceZoneSchedule.validation.overlapNote':
    'Los horarios superpuestos pueden causar comportamientos inesperados. Por favor ajuste los horarios para asegurar que no entren en conflicto entre sí.',
  'deviceZoneSchedule.validation.note': 'Nota:',
  'deviceZoneSchedule.overnight': 'Nocturno',
  'deviceZoneSchedule.overnight_tooltip':
    'Este horario continúa hasta el día siguiente',

  'cctv_zone_manager.title': 'Configurar canales CCTV',
  'cctv_zone_manager.location_details':
    'Zona: {{deviceZoneName}} - Ubicación: {{address}} - Lat: {{lat}} Lon: {{lon}}',
  'cctv_zone_manager.no_location':
    'Zona: {{deviceZoneName}} - Ubicación: Sin ubicación',
  'cctv_zone_manager.total_associated_channels': 'Canales CCTV asociados',
  'cctv_zone_manager.search_associated_channels_placeholder':
    'Buscar canales asociados...',
  'cctv_zone_manager.total_available_devices': 'Dispositivos disponibles',
  'cctv_zone_manager.search_devices_placeholder':
    'Buscar dispositivos disponibles...',
  'cctv_zone_manager.add_cctv_success':
    'Canal de CCTV añadido exitosamente a la zona',
  'cctv_zone_manager.add_cctv_error': 'Error al añadir canal de CCTV a la zona',
  'cctv_zone_manager.remove_cctv_success':
    'Canal de CCTV removido exitosamente de la zona',
  'cctv_zone_manager.remove_cctv_error':
    'Error al remover canal de CCTV de la zona',

  'users.identifier_field_text': 'Identificador',
  'users.name_field_text': 'Nombre',
  'users.lastname_field_text': 'Apellido',
  'users.partition_field_text': 'Partición',
  'users.action_field_text': 'Acciones',
  'users.userIdentifier_field_text': 'Documento de identificación',

  'create.DeviceEmergencyContact.form.name': 'Nombre completo',
  'create.DeviceEmergencyContact.form.note': 'Nota',
  'create.DeviceEmergencyContact.form.contactIdentifier':
    'Documento de identificación',
  'create.DeviceEmergencyContact.form.email': 'Correo electrónico',
  'Create.DeviceEmergencyContact.button.submit': 'Crear',
  'Create.DeviceEmergencyContact.title': 'Contacto de emergencia',

  'add.emergency.contact.title': 'Agregar contacto de emergencia',
  'emergencyContactEmergencyContactListEventGroup.delete.title.confirmation':
    'Esta acción no se puede deshacer',
  'emergencyContactEmergencyContactListEventGroup.delete.confirmation':
    '¿Está seguro de que desea eliminar este contacto?',
  'deviceEmergencyContactEventGroup.delete.title.confirmation':
    'Esta acción no se puede deshacer',
  'deviceEmergencyContactEventGroup.delete.confirmation':
    '¿Está seguro de que desea eliminar este contacto?',
  'emergencyContactList.delete.title.confirmation':
    'Esta acción no se puede deshacer',
  'emergencyContactList.delete.confirmation':
    '¿Está seguro de que desea eliminar esta lista?',

  'emergencyContactListItem.delete.success': 'Lista eliminada exitosamente',

  'CreateUserDialog.dialog.title': 'Crear usuario',
  'CreateUserDialog.dialog.subtitle':
    'Aquí tú puedes registrar un usuario del panel de alarmas',
  'CreateUserDialog.create': 'Crear usuario',
  'CreateUserDialog.update': 'Editar usuario',
  'CreateUserDialog.form.identifier': 'Identificador',
  'CreateUserDialog.form.firstName': 'Nombre',
  'CreateUserDialog.form.lastName': 'Apellido',
  'CreateUserDialog.form.userIdentifier': 'Documento de identificación',

  'dolynk.errors.playback_url_not_found': 'URL de reproducción no encontrada',
  'dolynk.errors.cctv_websocket_error':
    'Error al conectar al WebSocket de CCTV',
  'dolynk.errors.live_url_not_found': 'URL en vivo no encontrada',
  'dolynk.errors.stream_lost':
    'La vista en vivo se detuvo. El stream no respondió.',
  'dolynk.retry': 'Reintentar',
  'dolynk.playback.from': 'Reproducir desde',
  'dolynk.playback.to': 'Reproducir hasta',
  'table.more_options.playback_camera': 'Reproducir cámara',
  'dolynk.errors.select_start_end_dates':
    'Por favor, selecciona las fechas de inicio y fin para la reproducción',
  'dolynk.errors.end_date_before_start_date':
    'La fecha de fin debe ser posterior a la fecha de inicio',
  'dolynk.errors.select_dates_before_playback':
    'Define un rango de fechas antes de cargar la reproducción',
  'dolynk.channel_list': 'Canales',
  'dolynk.select_slot':
    'Haz clic en una celda para seleccionarla, luego en un canal para cargarlo',
  'dolynk.empty_slot': 'Selecciona un canal',
  'dolynk.layout.one_up': '1 Cámara',
  'dolynk.layout.four_up': '4 Cámaras',

  'cctv.error_conection': 'Falla al conectar.',
  'cctv.download_plugin': ' Descargue el plugin de cámara.',
  'cctv.success': 'Enviado exitosamente.',

  //Device Profile Rounds
  //Device Profile Rounds
  'round.point.stack.add_button': 'Agregar puntos',
  'round.form.title': 'Detalles del Recorrido',
  'round.device_points.title': 'Puntos del Dispositivo',
  'round.device_points.add_selected': 'Agregar a la ronda',
  'round.round_points.title': 'Puntos de la Ronda',
  'round.empty_round_points_label': 'Debes agregar puntos a la ronda',
  'round.device_channels.title': 'Canales de Cámara',
  'rounds.channel': 'Canal',
  'rounds.channel_id_column': 'Canal #',
  'rounds.channel_description_column': 'Descripción',
  // CCTV Point form
  'cctv_point.channel_label': 'Canal de Cámara',
  'cctv_point.identifier_label': 'Identificador (auto)',
  'cctv_point.name_label': 'Nombre',
  'cctv_point.description_label': 'Descripción',
  'cctv_point.add_error': 'Error al vincular canal de cámara al recorrido',
  'point_table.search_point': 'Buscar Lugar',
  'Rounds.dialog.title': 'Formulario de Recorrido',
  'Rounds.name': 'Nombre del Recorrido',
  'Rounds.startDate': 'Fecha Inicial',
  'Rounds.endDate': 'Fecha Final',
  'Rounds.recurrence.select.title': 'Recurrencia',
  notRepeated: 'No Repetir',
  businessDays: 'Días Hábiles',
  custom: 'Personalizado',
  'Rounds.add_button_text': 'Agregar Recorrido',
  'Rounds.edit_button_text': 'Editar Recorrido',
  'calendar_form.delete_button_text': 'Eliminar',
  'calendar_form.clone_button_text': 'Clonar',
  'calendar_form.color_validation_error':
    'Por favor selecciona un color válido de las opciones disponibles',
  'rounds.points_table.name_field': 'Nombre',
  'rounds.points_table.place_field': 'Lugar',
  'rounds.points_table.order_field': 'Orden',
  'rounds.points_table.action_field': 'Acciones',
  'actions.create_action.success': 'Acción creada exitosamente',
  'actions.create_action.error': 'Error al crear la acción',

  'point.download_qr_button': 'Imprimir QR de puntos',
  'point.create_success': 'Punto creado correctamente',
  'point.create_error': 'No se pudo crear el punto',
  'point.update_success': 'Punto actualizado correctamente',
  'point.update_error': 'No se pudo actualizar el punto',
  'point.delete_success': 'Punto desvinculado correctamente',
  'point.delete_error': 'No se pudo desvincular el punto',
  'point.button_add_existing': 'Buscar',
  'point.attach_modal.title': 'Adjuntar puntos del workspace',
  'point.attach_modal.confirm': 'Adjuntar puntos',
  'point.attach_modal.cancel': 'Cancelar',
  'point.attach_modal.success': 'Puntos adjuntados correctamente',
  'point.attach_modal.error': 'No se pudieron adjuntar los puntos',
  'point.attach_modal.workspace_error':
    'No se encontró el workspace del dispositivo',
  'pointItem.delete.title.confirmation':
    '¿Estás seguro de que quieres eliminar este punto de la ronda?',
  'pointItem.delete.confirmation': 'Esta acción no se puede deshacer',
  'table.more_options.delete.point': 'Eliminar de la ronda',
  'table.more_options.edit.point': 'Editar punto',
  'points.view_qr_text': 'Ver código QR',

  // Alarm Schedules
  'alarm_schedule.add_button_text': 'Agregar Horario de Alarma',
  'alarm_schedule.edit_button_text': 'Editar Horario de Alarma',
  'alarm_schedule.name': 'Nombre',
  'alarm_schedule.startDate': 'Fecha de Inicio',
  'alarm_schedule.endDate': 'Fecha de Fin',
  'alarm_schedule.recurrence.select.title': 'Recurrencia',
  assign_partition: 'Asignar partición',
  'alarm_schedule.dialog.title': 'Horario de Alarma',

  //Points
  'createPoint.add.title': 'Formulario de Puntos',
  'createPoint.add.subtitle':
    'Aquí puedes gestionar los puntos para tu recorrido.',
  'CreatePointDialog.form.identifier': 'Identificador',
  'CreatePointDialog.form.name': 'Nombre',
  'CreatePointDialog.form.description': 'Descripción',
  'CreatePointDialog.form.place': 'Lugar',
  'CreatePointDialog.form.tasks': 'Tareas del punto',
  'CreatePointDialog.form.add_tasks': 'Agregar tarea',
  'createPoint.add.point.submit': 'Crear Punto',
  'updatePoint.submit': 'Actualizar Punto',

  //Device Profile Persons
  'reporters_table.firstName_field': 'Nombre',
  'reporters_table.lastName_field': 'Apellido',
  'reporters_table.username_field': 'Nombre de usuario',
  'reporters_table.email_field': 'Correo Electrónico',
  'reporters_table.actions_field': 'Acciones',
  'reporters.add_reporter_form': 'Agregar Persona',
  'reporters.edit_reporter_form': 'Editar Persona',
  'reporters.remove_reporter': 'Quitar persona',
  'reporters.edit_restricted':
    'Este usuario tiene otros roles asignados, por lo que para cambiar su contraseña desde hacerlo desde su propia cuenta.',
  'reporters.edit_wrong_workspace':
    'Esta persona fue creada desde otro espacio de trabajo y no puede ser editada aquí',
  'reporters.search_placeholder': 'Nombre',
  'add_reporters_form.add_reporter': 'Agregar Persona',
  'reporters.search.add_reporter': 'Crear persona',
  'add_reporters_form.create_reporter': 'Crear persona',
  'create_reporter_user.first_name_label': 'Nombre',
  'create_reporter_user.last_name_label': 'Apellido',
  'create_reporter_user.email_label': 'Correo Electrónico',
  'create_reporter_user.username_label': 'Nombre de usuario',
  'create_reporter_user.password_label': 'Contraseña',
  'create_reporter_user.confirm_password_label': 'Confirmar contraseña',
  'create_reporter_user.submit_button': 'Crear persona',
  'reporters.deleted_reporter_success':
    'Persona desvinculada del dispositivo exitosamente',
  'reporters.updated_user_success': 'Persona actualizada exitosamente',

  //Device Profile Actions
  'device_profile.actions_tab_title': 'Acciones',
  'actions_table.id_field_text': 'ID',
  'actions_table.name_field_text': 'Nombre',
  'actions_table.event_field_text': 'Evento',
  'actions_table.action_group_field_text': 'Acción pertenece a',
  'actions_table.actions_field_text': 'Acciones',
  'actions_form.event_label': 'Evento',
  'actions_form.create_action': 'Crear Acción',
  'actions_form.update_action': 'Editar Acción',
  'actions_form.search_action': 'Buscar Acción',
  'actions_form.search_label': 'Buscar',
  'actions_form.name_label': 'Nombre',
  'actions_form.countdown_label': 'Contador',
  'actions_form.icon_label': 'Icono',
  'actions_form.color_select_label': 'Color',
  'actions_form.content_label': 'Contenido',
  'actions_form.add_free_content_label': 'Agregar contenido libre',
  'actions_form.submit_button': 'Crear Acción',
  'actions_form.add_content_label': 'Agregar contenido',
  'actions_form.question_label': 'Pregunta',
  'actions_form.content_type_label': 'Tipo de contenido',
  'actions_form.mandatory_label': 'Obligatorio',
  'actions_form.edit_confirm_message': '¿Está seguro?',
  'actions_form.edit_confirm_description':
    'Modificar una acción asociada afectará a todos los dispositivos vinculados.',
  'action_content.choice_key': 'Clave',
  'action_content.choice_value': 'Valor',
  'actions.search_action_title': 'Buscar acción',
  'actions.create_action_title': 'Crear acción',
  'actions.update_action_title': 'Actualizar acción',
  'actions.associate_action_to_action_group.success':
    'Acción asociada al grupo de acciones exitosamente',
  'actions.associate_action_to_action_group.error':
    'Error al asociar la acción al grupo de acciones',
  'add_action_form.add_action': 'Agregar acción',
  'actions.title_text': 'Acciones',
  'actions.reorder_action_success': 'Acciones reordenadas exitosamente',
  'actions_table.order_field_text': 'Orden',
  'update_action_form.success': 'Acción actualizada correctamente',
  'update_action_form.error': 'Error al actualizar la acción',

  'channels_table.id_field_text': 'ID de Canal',
  'channels_table.description_field_text': 'Descripción',
  'channels_table.actions_field_text': 'Acciones',
  'table.more_options.view_camera': 'Ver camara',
  'table.more_options.playback_camera': 'Reproducir cámara',

  'history.attachments': 'Adjuntos',
  'history.identifier_field_text': 'Identificador',
  'history.info_field_text': 'Info',
  'history.device_name_field_text': 'Nombre Dispositivo',
  'history.event_field_text': 'Evento',
  'history.quick_search.events': 'Eventos',
  'history.quick_search.from': 'Fecha desde',
  'history.quick_search.to': 'Fecha hasta',
  'history.export_html.title': 'Historial del dispositivo',
  'history.export_html.truncated':
    'Exportación truncada a las primeras {{max}} filas',
  'history.export_html.error': 'Error al exportar el historial como HTML',
  'history.export_html.attachments': 'Adjuntos',
  'history.export_html.view_image': 'Ver imagen',
  'history.export_html.view_video': 'Ver video',
  'history.export_html.view_audio': 'Ver audio',
  'history.export_html.view_signature': 'Ver firma',
  'history.export_html.view_legacy_image': 'Imagen adjunta',
  'history.export_html.view_legacy_audio': 'Audio adjunto',
  'history.export_html.view_legacy_video': 'Video adjunto',
  'history.export_html.text_attachment': 'Texto adjunto',
  'history.export_html.qr_attachment': 'QR adjunto',
  'history.export_html.nfc_attachment': 'NFC adjunto',
  'history.export_html.choice_attachment': 'Selección adjunta',
  'history.export_html.position': 'Posición',
  'history.export_html.view_on_map': 'Ver en Google Maps',
  'table.toolbar.export_html': 'Descargar como HTML',
  'table.toolbar.print': 'Imprimir (PDF)',
  'history.event_is_self_generated': 'Autogenerado',
  'history.point_field_text': 'Punto',
  'history.zone_field_text': 'Zona',
  'history.zone_identifier_field_text': 'ID Zona',
  'history.user_field_text': 'Usuario',
  'history.user_identifier_field_text': 'ID Usuario',
  'history.partition_field_text': 'Partición',
  'history.partition_identifier_field_text': 'ID Partición',
  'history.channel_identifier_field_text': 'ID Canal',
  'history.channel_field_text': 'Canal',
  'history.generated_at_field_text': 'Generada',
  'history.received_at_field_text': 'Recibida',
  'history.processed_at_field_text': 'Procesada',
  'history.processed_at_not_monitorable': 'No monitoreable',
  'history.actions_field_text': 'Acciones',
  'history.position': 'Ver posición',
  'history.videos': 'Videos',
  'history.audios': 'Audios',
  'history.images': 'Imágenes',
  'history.round_field_text': 'Ronda',
  'history.site_place_field_text': 'Lugar',
  'history.site_device_field_text': 'Dispositivo',
  'history.person_field_text': 'Persona',
  'deviceHistory.images': 'Imágenes',
  'deviceHistory.videos': 'Videos',
  'deviceHistory.audios': 'Audios',
  'history.live_cam': 'Cámara en vivo',
  'history.cctv_channel': 'Canal',
  'history.task_point_field_text': 'Tareas del punto',

  'notes.button_add': 'Crear',
  'createNote.add.note.title': 'Crear nota',
  'createNote.add.note.subtitle':
    'Aquí tú puedes crear una nota para usar en tu dispositivo',
  'createNote.add.note.close': 'Cancelar',
  'createNote.add.note.submit': 'Crear nota',
  'CreateNoteDialog.form.title': 'Título',
  'CreateNoteDialog.form.content': 'Contenido',
  'CreateNoteDialog.form.expirationDate': 'Fecha de expiración',

  // Links
  'links.button_add': 'Agregar enlace',
  'links.form.title_create': 'Crear enlace',
  'links.form.title_edit': 'Editar enlace',
  'links.form.description': 'Descripción',
  'links.form.url': 'URL',
  'links.table.description': 'Descripción',
  'links.table.url': 'URL',
  'links.table.actions': 'Acciones',
  'links.create_success': 'Enlace creado exitosamente',
  'links.update_success': 'Enlace actualizado exitosamente',
  'links.delete_success': 'Enlace eliminado exitosamente',
  'links.save_error': 'Error al guardar el enlace',
  'links.delete_error': 'Error al eliminar el enlace',
  'linkItem.delete.title.confirmation': 'Eliminar enlace',
  'linkItem.delete.confirmation':
    '¿Estás seguro de que deseas eliminar este enlace? Esta acción no se puede deshacer.',
  'table.more_options.edit.link': 'Editar enlace',
  'table.more_options.delete.link': 'Eliminar enlace',

  'device_action_groups.import.button.text': 'Importar grupo de acciones',
  'device_action.groups_.import.title': 'Importar grupo de acciones',

  'emergency_contact.name_field_text': 'Nombre del contacto de emergencias',
  'emergency_contact.order_field_text': 'Orden',
  'emergency_contact.phone_numbers_field_text': 'Teléfonos',
  'emergency_contact.call_field_text': 'Llamar',
  'emergency_contact.edit_field_text': 'Acciones',
  //Timers
  'timers.create_timer_form': 'Formulario de Temporizadores',
  'timers.update_timer_form': 'Editar Formulario de Temporizadores',
  'timer_form.start_date_label': 'Fecha de inicio',
  'timer_form.end_date_label': 'Fecha Final',
  'timer_form.interval_label':
    'Intervalo (Cada cuántos minutos se va a repetir)',
  'timer_form.action_label': 'Acción del temporizador',
  'timer_form.reset_configuration_label': 'Configurar restauración de evento',
  'timer_form.protocol_label': 'Protocolo',
  'timer_form.event_label': 'Evento',
  'timer_form.create_submit_button': 'Crear Temporizador',
  'timer_form.update_submit_button': 'Editar Temporizador',
  'timers_table.start_date_field': 'Fecha Inicial',
  'timers_table.end_date_field': 'Fecha Final',
  'timers_table.interval_field': 'Intervalo',
  'timers_table.actions_field': 'Acciones',
  'timers_table.action_field': 'Acción',
  'timers_table.reset_config_field': 'Evento de restauracion',
  'timer_action.generate_event': 'Generar Evento',

  //Inactivations
  'inactivations.create_inactivation_form': 'Formulario de desactivaciones',
  'inactivations.update_inactivation_form':
    'Editar Formulario de desactivaciones',
  'inactivation_form.start_date_label': 'Fecha Inicial',
  'inactivation_form.end_date_label': 'Fecha Final',
  'inactivation_form.protocol': 'Protocolo',
  'inactivation_form.event': 'Codigo de Evento',
  'inactivation_form.zone_or_user': 'Zona o Usuario',
  'inactivation_form.reason_label': 'Razón o Motivo',
  'reason_form.create_submit_button': 'Crear Inactivación',
  'reason_form.update_submit_button': 'Editar Inactivación',
  'inactivations_table.eventId_field_text': 'Codigo de Evento',
  'inactivations_table.reason_field_text': 'Razón o Motivo',
  'inactivations_table.from_field_text': 'Desde',
  'inactivations_table.to_field_text': 'Hasta',
  'inactivations_table.actions_field': 'Acciones',

  //Inactivations
  'notifications_table.description_field_text': 'Descripcion',
  'notifications_table.type_field_text': 'Tipo de notificación',
  'notifications_table.users_field_text': 'Usuarios',
  'notifications_table.createdAt_field_text': 'Creado',
  'notifications_table.notification_group_field_text': 'Grupo de Notificación',
  'notifications_table.actions_field': 'Acciones',
  'notifications_table.recipients_field_text': 'Destinatarios',
  'device_notifications.form.contacts_label': 'Contactos',
  'device_notifications.form.new_contact_button': 'Nuevo contacto',
  'notifications.validation.description_required':
    'La descripción es obligatoria',
  'notifications.validation.description_min_length':
    'La descripción debe tener al menos 3 caracteres',
  'notifications.validation.description_max_length':
    'La descripción debe tener como máximo 255 caracteres',
  'notifications.validation.type_required': 'El tipo es obligatorio',
  'notifications.validation.language_required': 'Elija un idioma',
  'notifications.validation.type_min_length': 'El tipo es obligatorio',
  'notifications.validation.userId_required': 'Seleccione al menos un usuario',
  'notifications.validation.userId_uuid': 'Usuario inválido',
  'notifications.validation.notificationGroupId_required':
    'El grupo de notificación es obligatorio',
  'notifications.validation.notificationGroupId_uuid':
    'Grupo de notificación inválido',
  'notifications.validation.contactId_required':
    'Seleccione al menos un contacto',
  'notifications.validation.contactId_uuid': 'Contacto inválido',

  // Contactos de notificación: destinatarios sin cuenta en Treinco
  'settings.settings_tabs.notification_contacts_tab_title':
    'Contactos de notificación',
  'notification_contacts.subtitle':
    'Personas que reciben alertas por correo, Telegram o SMS sin tener cuenta en Treinco.',
  'notification_contacts.table.name': 'Nombre',
  'notification_contacts.table.email': 'Correo',
  'notification_contacts.table.actions': 'Acciones',
  'notification_contacts.form.create_title': 'Nuevo contacto',
  'notification_contacts.form.edit_title': 'Editar contacto',
  'notification_contacts.form.name': 'Nombre',
  'notification_contacts.form.email': 'Correo',
  'notification_contacts.form.email_helper':
    'Opcional. Necesario para alertas por correo.',
  'notification_contacts.form.submit': 'Guardar',
  'notification_contacts.create_success': 'Contacto creado',
  'notification_contacts.create_error': 'No se pudo crear el contacto',
  'notification_contacts.update_success': 'Contacto actualizado',
  'notification_contacts.update_error': 'No se pudo actualizar el contacto',
  'notification_contacts.delete_success': 'Contacto eliminado',
  'notification_contacts.delete_error': 'No se pudo eliminar el contacto',
  'notification_contacts.validation.name_required': 'El nombre es obligatorio',
  'notification_contacts.validation.name_min_length':
    'El nombre debe tener al menos 2 caracteres',
  'notification_contacts.validation.name_max_length':
    'El nombre debe tener como máximo 100 caracteres',
  'notification_contacts.validation.email_invalid': 'Correo inválido',
  'device_notifications.form.search_member_placeholder':
    'Buscar usuario del cliente',
  'notifications.delete_success': 'Notificación eliminada exitosamente',
  'notifications.delete_error': 'Error al eliminar la notificación',
  'notifications.fetch_error': 'Error al obtener las notificaciones',
  'notifications.create_notification_form': 'Crear notificación',
  'notifications.update_notification_form': 'Editar notificación',
  'notifications.update_success': 'Notificación actualizada exitosamente',
  'notifications.update_error': 'Error al actualizar la notificación',
  'notifications.create_success': 'Notificación creada exitosamente',
  'notifications.create_error': 'Error al crear la notificación',
  'device_notifications.form.create_button': 'Crear notificación',
  'device_notifications.form.notification_group_label':
    'Grupo de notificaciones',
  'device_notifications.form.errors.notification_group_load_error':
    'Error al cargar los grupos de notificaciones',
  'device_notifications.form.type_label': 'Tipo de notificación',
  'device_notifications.form.language_label': 'Idioma del mensaje',
  'device_notifications.form.language_helper':
    'Etiquetas y formato de fecha del aviso. Los nombres de evento se envían tal como están configurados.',
  'device_notifications.form.description_label': 'Descripción',
  'device_notifications.form.users_label': 'Usuarios',
  'device_notifications.form.errors.no_customer_assigned':
    'El dispositivo no tiene cliente asignado. Asigne un cliente para seleccionar usuarios.',
  'device_profile.notifications_tab_title': 'Notificaciones',
  'device_notifications.form.type_treinco_app_push':
    'Notificación push de Treinco App',
  'device_notifications.form.type_telegram': 'Telegram',

  'members_search.username_text': 'Nombre de usuario',
  'members_search.email_text': 'Correo electrónico',
  'customer_invitation.button.go_home': 'Ir al Inicio',
  'treinco_app_invitation.success.new_user':
    '¡Cuenta creada! Revisa tu correo para obtener tu contraseña e iniciar sesión.',
  'treinco_app_invitation.success.existing': '¡Invitación aceptada!',
  'treinco_app_invitation.rejected': 'Invitación rechazada.',
  'device_authorization.title': 'Autorizar dispositivo',
  'device_authorization.subtitle':
    '¿Querés autorizar a "{{label}}" a acceder a tu cuenta?',
  'device_authorization.unknown_device': 'esta app',
  'device_authorization.button.approve': 'Autorizar',
  'device_authorization.button.deny': 'Rechazar',
  'customerMember.invitation.modal': 'Gestionar miembros',
  // Places
  'page.places_title': 'Places',
  'page.places.subtitle':
    'Aquí puedes administrar y ver todo lo relacionado con tus lugares, los lugares se usan para agrupar dispositivos y puntos',
  'createPlace.title_text': 'Crear lugar',
  'editPlace.title_text': 'Editar lugar',
  'CreatePlaceOptions.select_place_text': 'Selecciona un lugar',
  'CreatePlaceOptions.select_place_description':
    'Aquí puedes seleccionar un lugar, y asociarlo a este dispositivo',
  'CreatePlaceOptions.create_place_text': 'Crear lugar',
  'CreatePlaceOptions.create_place_description':
    'Aquí puedes crear un lugar, puedes asociar tu dispositivo a lugares',
  'createPlace.subtitle_text':
    'Aquí tú puedes crear un lugar para usar en tu espacio de trabajo',
  'editPlace.subtitle':
    'Aquí tú puedes editar un lugar para usar en tu espacio de trabajo',
  'createPlace.form.streetAndNumber': 'Calle y número',
  'createPlace.form.name': 'Nombre',
  'createPlace.form.city': 'Ciudad',
  'createPlace.form.state': 'Estado',
  'createPlace.form.zipCode': 'Código postal',
  'createPlace.button.next': 'Siguiente',
  'createPlace.button.back': 'Volver',
  'createPlace.button.submit': 'Crear lugar',
  'createPlace.form.country': 'País',
  'places.toggle.devices': 'Dispositivos',
  'places.toggle.points': 'Puntos',
  'places.points_field_text': 'Puntos',
  'places.point_identifier_text': 'Identificador',
  'places.points_without_place': 'Sin lugar',
  'places.devices_field_text': 'Dispositivos',
  'places.name_field_text': 'Nombre',
  'places.description_field_text': 'Descripción',
  'places.latitude_field_text': 'Latitud',
  'places.longitude_field_text': 'Longitud',
  'places.radius_field_text': 'Radio',
  'places.action_field_text': 'Acciones',
  'places.empty.create':
    'Aún no has creado lugares para este espacio de trabajo, cuando haya se mostrarán aquí.',
  'places.button.create': 'Crear',
  'placePicker.place_input_label': 'Selecciona un lugar',
  'placePicker.search_by_label': 'Buscar por',
  'placePicker.search_by_place_label': 'Lugares',
  'placePicker.search_by_device_label': 'Dispositivos',
  'places.table.add_button': 'Agregar puntos',
  'createPlace.subtitle':
    'Aquí puedes crear un Lugar, puedes agrupar dispositivos a lugares',
  'places.address_field_text': 'Dirección',
  'places.zipCode_field_text': 'Código Postal',
  'places.city_field_text': 'Ciudad',
  'places.country_field_text': 'País',
  'places.place_required': 'Debe seleccionar un lugar',
  'devicePlace.create_success': 'Lugar creado exitosamente',
  'devicePlace.update_success': 'Lugar editado exitosamente',
  'placesItem.delete.title.confirmation':
    '¿Seguro que deseas eliminar este lugar?',
  'placesItem.delete.confirmation': 'Esta acción no se puede deshacer',
  'devicePlace.delete.title.confirmation': 'Eliminar lugar',
  'placePicker.button_submit': 'Seleccionar lugar',
  'devicePlace.create_error': 'Error al crear el lugar',
  'devicePlace.update_error': 'Error al editar el lugar',
  'places.delete_success': 'Lugar eliminado exitosamente',
  'places.delete_error': 'Error al eliminar el lugar',
  'places.delete_conflict':
    'No se puede eliminar el lugar porque tiene dispositivos asociados.',

  // Point management
  'editPoint.title_text': 'Editar punto',
  'updatePoint.success': 'Punto actualizado exitosamente',
  'updatePoint.error': 'Error al actualizar el punto',
  'deletePoint.success': 'Punto eliminado exitosamente',
  'deletePoint.error': 'Error al eliminar el punto',
  'deletePoint.error_associated_with_device':
    'No se puede eliminar el punto porque tiene dispositivos asociados.',

  //Service order
  'treinco.service_order_status.unassigned': 'Sin asignar',
  'treinco.service_order_status.assigned': 'Asignado',
  'treinco.service_order_status.tracking': 'Seguimiento',
  'treinco.service_order_status.onhold': 'En espera',
  'treinco.service_order_status.finished': 'Finalizado',
  'treinco.service_order_status.canceled': 'Cancelado',
  'device_service_orders_table.type_field_text': 'Tipo',
  'device_service_orders_table.description_field_text': 'Descripción',
  'device_service_orders_table.priority_field_text': 'Prioridad',
  'device_service_orders_table.createdAt_field_text': 'Fecha de creación',
  'device_service_orders_table.scheduledAt_field_text': 'Fecha programada',
  'device_service_orders_table.executedAt_field_text': 'Fecha de ejecución',
  'device_service_orders_table.status_field_text': 'Estado',

  //Chat
  'chat.contacts_search_input_placeholder': 'Buscar contactos',
  'chat.chat_compose_tooltip': 'Crear chat',
  'chat.to_addressee_text': 'Agregar a',
  'chat.empty_chat_message':
    'Selecciona o crea una conversación para empezar a chatear',
  'chat.user_info_title': 'Información',
  'chat.input_text_placeholder': 'Escribe un mensaje',
  'chat.add_participants_tooltip': 'Agregar participantes',
  'chat.group_participants_count': '{{total}} participantes',
  'chat.group_total_participants': 'Total de participantes',
  'chat.record_audio_not_supported_button_text':
    'Tu navegador no soporta grabar audio',
  'chat.record_audio_button_text': 'Enviar un mensaje de voz',
  'chat.empty_chats_text': 'No hay chats',
  'chat.recipients_placeholder_text': 'Busca a alguien',
  'chat.self_user_name': 'Tú',
  'chat.add_participants_button_text': 'Invitar',
  'chat.system.group_join_message': '{{ name }} agregó a un nuevo participante',
  'chat.system.group_entry_message': '{{ name }} se unió a la conversación',
  'chat.system.finished_conversation_message':
    '{{ name }} finalizó la conversación',
  'chat.system.default_message': 'Mensaje del sistema',
  'chat.system.verification_request_message':
    '{{ name }} solicitó verificación de alarma',
  'chat.system.false_alarm_confirmed_message':
    '{{ name }} confirmó alarma falsa — situación resuelta',
  'chat.system.duress_confirmed_message':
    '{{ name }} confirmó coacción — alarma real',
  'chat.system.verification_invalid_code_message':
    '{{ name }} ingresó un código de verificación inválido',
  'chat.search_not_found_title': 'No encontrado',
  'chat.search_not_found_description': 'No se encontraron resultados para',
  'chat.search_enter_keywords': 'Por favor ingrese palabras clave',
  'chat.finish_chat_confirmation': '¿Finalizar conversación?',
  'chat.finish_chat_description':
    '¿Está seguro que desea finalizar esta conversación? Esta acción no se puede deshacer.',
  'chat.finish_chat_error':
    'Error al finalizar la conversación. Por favor intente nuevamente.',
  'chat.finish_chat_option': 'Finalizar conversación',
  'chat.unknown_user_name': 'Usuario desconocido',
  'chat.join_group_error':
    'Error al unirse al grupo. Por favor, intente de nuevo.',
  'chat.status_online': 'En línea',
  'chat.last_seen': 'En línea {{time}}',

  // Settings
  'settings.title_text': 'Configuración',
  'settings.settings_tabs.general_tab_title': 'General',
  'settings.settings_tabs.integrations_tab_title': 'Integraciones',
  'settings.settings_tabs.users_tab_title': 'Usuarios',
  'settings.settings_tabs.roles_tab_title': 'Roles',
  'settings.settings_tabs.event_groups_tab_title': 'Grupos de eventos',
  'settings.settings_tabs.events_tab_title': 'Eventos',
  'settings.settings_tabs.brands_tab_title': 'Marcas',
  'settings.settings_tabs.models_tab_title': 'Modelos',
  'settings.settings_tabs.resolutions_tab_title': 'Mensajes predefinidos',
  'settings.settings_tabs.emergency_contact_tab_title':
    'Contactos de emergencia',
  'settings.settings_tabs.emergency_contact_lists_tab_title':
    'Listas de contactos de emergencia',
  'settings.settings_tabs.integrations_tab_title': 'Integraciones',
  'settings.settings_tabs.notification_groups_tab_title':
    'Grupos de notificaciones',

  // Settings connectors
  'connector_form.title_text': 'Conector',
  'connector_form.subtitle_text':
    'Aquí puedes configurar tu conector, este te servirá para conectar dispositivos a tu espacio de trabajo',
  'connector_form.description_field': 'Descripción',
  'connector_form.errors.description_min':
    'La descripción debe tener al menos 3 caracteres',
  'connector_form.errors.description_max':
    'La descripción debe tener máximo 50 caracteres',
  'connector_form.errors.description_required': 'La descripción es obligatoria',
  'create_connector_form.submit_text': 'Crear integración',
  'edit_connector_form.submit_text': 'Editar integración',
  'settings.connectors_table.description_field_text': 'Descripción',
  'settings.connectors_table.secret_field_text': 'Clave Secreta',
  'settings.connectors_table.status_field_text': 'Estado',
  'settings.connectors_table.receivers_status_field_text': 'Receptores',
  'settings.connectors_table.receiver_status_not_available_message':
    'Sin receptores',
  'settings.connectors_table.receiver_status_unknown_label':
    'Estado desconocido',
  'settings.connectors_table.receiver_label_fallback': 'Receptor',
  'settings.connectors_table.receiver_last_event_prefix': 'Último evento:',
  'settings.connectors_table.receiver_should_be_connected_false':
    'Marcado como detenido',
  'settings.connectors_table.receiver_status_connected': 'Conectado',
  'settings.connectors_table.receiver_status_connecting': 'Conectando',
  'settings.connectors_table.receiver_status_disconnected': 'Desconectado',
  'settings.connectors_table.actions_field_text': 'Acciones',
  'integration_details.buffer_section_title': 'Buffer del conector',
  'integration_details.buffer_status_title': 'Eventos en cola',
  'integration_details.buffer_summary':
    'Pendientes: {{pending}}, En proceso: {{active}}',
  'integration_details.buffer_columns.id': 'ID',
  'integration_details.buffer_columns.status': 'Estado',
  'integration_details.buffer_columns.timestamp': 'Fecha y hora',
  'integration_details.buffer_columns.device': 'Dispositivo',
  'integration_details.buffer_columns.event': 'Evento',
  'integration_details.buffer_status.inited': 'Inicializado',
  'integration_details.buffer_status.queued': 'En cola',
  'integration_details.buffer_status.in_progress': 'En proceso',
  'integration_details.buffer_status.acknowledged': 'Confirmado',
  'integration_details.buffer_status.failed': 'Fallido',
  'integration_details.buffer_status.unknown': 'Desconocido',
  'integration_details.buffer_status_help.inited':
    'Guardado por el receptor. Todavía no se ha enviado.',
  'integration_details.buffer_status_help.queued':
    'Listo para enviar al Cloud Receiver. Se reintentará automáticamente.',
  'integration_details.buffer_status_help.in_progress':
    'Enviado. Esperando la respuesta del Cloud Receiver.',
  'integration_details.buffer_status_help.acknowledged':
    'El Cloud Receiver lo procesó y lo guardó correctamente.',
  'integration_details.buffer_status_help.failed':
    'El Cloud Receiver lo recibió y lo rechazó. No se reintenta.',
  'integration_details.buffer_status_help.unknown':
    'Estado no reconocido por esta versión.',
  'integration_details.buffer_reason.DEVICE_NOT_FOUND':
    'No hay ningún dispositivo dado de alta con ese identificador para este receptor y línea. Revisa el uniqueId y el prefijo del workspace.',
  'integration_details.buffer_reason.PROCESSING_ERROR':
    'La plataforma no pudo procesar el evento. Revisa los logs del Cloud Receiver con la marca de tiempo de esta fila.',
  'integration_details.buffer_reason.INTERNAL_ERROR':
    'Error interno inesperado en la plataforma al procesar el evento.',
  'integration_details.buffer_empty': 'No hay eventos esperando en el buffer.',
  'integration_details.refresh': 'Actualizar estado del buffer',
  'integration_details.last_updated': 'Actualizado {{relative}} ({{date}})',
  'integration_details.empty_message': 'No hay detalles disponibles.',
  'receiver_actions.start': 'Iniciar receptor',
  'receiver_actions.stop': 'Detener receptor',
  'receiver_actions.start_success':
    'El receptor {{name}} se inició correctamente.',
  'receiver_actions.start_error':
    'No se pudo iniciar el receptor {{name}}: {{message}}',
  'receiver_actions.stop_success':
    'El receptor {{name}} se detuvo correctamente.',
  'receiver_actions.stop_error':
    'No se pudo detener el receptor {{name}}: {{message}}',
  'receiver_actions.stop_confirm_title': '¿Detener receptor?',
  'receiver_actions.stop_confirm_description':
    'El receptor dejará de aceptar nuevas conexiones hasta que se inicie nuevamente.',

  // Settings integrations
  'settings.integrations_table.type_field_text': 'Tipo',
  'settings.integrations_table.port_config_field_text': 'Config. Puerto',
  'integrations_table.connector_type_text': 'Conector',
  'integrations_table.cloud_connector_type_text': 'Conector en la Nube',
  'integrations_table.dahua_dolynk_type_text': 'Dahua Dolynk',
  'integration_details.title': 'Detalles de la integración',
  'integration.select_title': 'Selecciona una integración',
  'integration.select_description':
    'Por favor selecciona el tipo de integración que deseas crear',
  'create_integration_form.title': 'Crear integración',
  'create_integration_form.description': 'Especifica la configuración',
  'update_integration_form.title': 'Editar integración',
  'update_integration_form.description': 'Modifica la configuración',
  'integration_labels.description': 'Descripción',
  'integration_labels.host': 'Servidor',
  'integration_labels.port': 'Puerto',
  'integration_labels.connectionStatus': 'Estado de la conexión',
  'integration_labels.secret': 'Clave secreta',
  'integration_labels.email': 'Correo electrónico',
  'integration_labels.region': 'Región',
  'integration_labels.password': 'Contraseña',
  'integration_labels.version': 'Versión',
  'integration_labels.isConnected': 'Conectado',
  'integration_labels.lastHeartbeatAt': 'Último latido',
  'integration_labels.lastConnection': 'Última conexión',
  'integration_labels.workspaceId': 'ID del espacio de trabajo',
  'integration_labels.botId': 'ID del bot',
  'integration_labels.botToken': 'Token del bot',
  'integration_labels.botUsername': 'Usuario del bot',
  'integration_labels.user': 'Usuario',
  'integration_labels.pass': 'Contraseña',
  'integration_labels.fromName': 'Nombre del remitente',
  'integration_labels.fromEmail': 'Dirección del remitente',
  'integration_labels.replyEmail': 'Dirección de respuesta',
  'integrations_form.email_field': 'Correo electrónico',
  'integrations_form.password_field': 'Contraseña',
  'integrations_form.region_field_label': 'Región',
  'integrations.details_label_menu': 'Ver detalles',
  'integrations.list_devices_label_menu': 'Listar Dispositivos',
  'integrations.manage_extensions_label_menu': 'Gestionar Extensiones',
  'integrations.already_exists_tooltip':
    'Este espacio de trabajo ya tiene una. Solo se permite una.',
  'integrations_table.jssip_type_text': 'JSSIP VoIP',
  'jssip_form.server_field': 'Servidor SIP',
  'jssip_form.port_field': 'Puerto',
  'jssip_form.prefix_field': 'Prefijo de Extensión',
  'jssip_form.extension_field': 'Extensión',
  'jssip_form.password_field': 'Contraseña',
  'jssip_form.user_field': 'Seleccionar Usuario',
  'jssip_form.users_field': 'Seleccionar Usuarios',
  'jssip_form.openrouter_api_key_field': 'Clave API de OpenRouter',
  'jssip_form.openrouter_api_key_label': 'Clave API de OpenRouter (opcional)',
  'jssip_extensions.title': 'Extensiones JSSIP',
  'jssip_extensions.extension_column': 'Extensión',
  'jssip_extensions.password_column': 'Contraseña',
  'jssip_extensions.user_column': 'Usuario',
  'jssip_extensions.users_column': 'Usuarios',
  'jssip_extensions.create_button': 'Crear Extensión',
  'jssip_extensions.create_title': 'Crear Extensión',
  'jssip_extensions.create_submit': 'Crear',
  'jssip_extensions.edit_title': 'Editar Extensión',
  'jssip_extensions.edit_submit': 'Guardar',
  'jssip_extensions.delete_confirm':
    '¿Está seguro de que desea eliminar esta extensión?',
  'jssip_extensions.create_success': 'Extensión creada exitosamente',
  'jssip_extensions.update_success': 'Extensión actualizada exitosamente',
  'jssip_extensions.delete_success': 'Extensión eliminada exitosamente',
  'jssip_extensions.extension_already_exists':
    'Este número de extensión ya existe en esta integración',
  'jssip_extensions.error': 'Ocurrió un error',
  'dolynk_devices.title': 'Dispositivos Dahua DoLynk',
  'dolynk_devices.device_id': 'ID del Dispositivo',
  'dolynk_devices.name': 'Nombre',
  'dolynk_devices.status': 'Estado',
  'dolynk_devices.activation_status': 'Estado de Activación',
  'dolynk_devices.bind_time': 'Tiempo de Vinculación',
  'dolynk_devices.account': 'Cuenta',
  'dolynk_devices.activate': 'Activar',
  'dolynk_devices.deactivate': 'Desactivar',
  'dolynk_devices.activation_success': 'Dispositivo {{status}} exitosamente',
  'dolynk_devices.activation_error':
    'Error al cambiar el estado de activación del dispositivo',
  'integrations_form.access_key_field': 'Clave de acceso',
  'integrations_form.secret_key_field': 'Clave secreta',
  'connector.create_success': 'Integración creada exitosamente',
  'connector.create_error': 'Error al crear la integración',
  'connector.update_success': 'Integración actualizada exitosamente',
  'connector.update_error': 'Error al crear la integración',
  'connector.delete.success': 'Integración eliminada exitosamente',
  'connector.delete.error': 'Error al eliminar la integración',
  'connector.download.menu_label': 'Configurar connector',
  'connector.download.dialog_title': 'Configurar connector',
  'connector.download.step1_title': 'Paso 1 — Paquete del connector',
  'connector.download.step1_description':
    'El soporte de Treinco te provee el paquete treinco-connector-<version>.zip, con connector.exe y un archivo config/config.ini.',
  'connector.download.step2_title': 'Paso 2 — Archivo de configuración',
  'connector.download.step2_description':
    'Estos valores son específicos para este connector. Podés copiarlos al portapapeles o descargar el archivo config.ini ya listo.',
  'connector.download.copy_tooltip': 'Copiar al portapapeles',
  'connector.download.config_copied': 'Configuración copiada al portapapeles',
  'connector.download.config_copy_error': 'No se pudo copiar al portapapeles',
  'connector.download.download_config_button': 'Descargar config.ini',
  'connector.download.step3_title': 'Paso 3 — Instalación',
  'connector.download.step3_extract':
    'Extraé el zip que te dio el soporte de Treinco a una carpeta (por ejemplo, C:\\Treinco\\).',
  'connector.download.step3_replace_config':
    'Reemplazá el archivo config/config.ini por el que descargaste (o pegá el contenido copiado).',
  'connector.download.step3_run':
    'Abrí una terminal en la carpeta y ejecutá connector.exe.',
  'connector.download.close': 'Cerrar',
  'connector.update.no_connector': 'No se encontró el connector',
  'connector.version.unknown': 'Desconocida',

  // Cloud Connector
  'cloud_connector.description':
    'Un conector gestionado por Treinco en la nube. Obtén una IP estática dedicada para tus dispositivos sin necesidad de instalación local.',
  'cloud_connector.size_label': 'Tamaño del servidor',
  'cloud_connector.pricing_note':
    'La facturación de cloud connectors está basada en uso. Contacta a soporte para más detalles.',
  'cloud_connector.connection_info': 'Información de conexión',
  'cloud_connector.provisioning_message':
    'Aprovisionando cloud connector... Esto puede tomar unos minutos.',
  'cloud_connector.configuring_message':
    'Configurando cloud connector... Casi listo.',
  'cloud_connector.static_ip_label': 'IP Estática',
  'cloud_connector.copy_ip': 'Copiar IP',
  'cloud_connector.copied': '{{label}} copiado al portapapeles',
  'cloud_connector.ip_instructions':
    'Configura tus dispositivos para conectarse a esta dirección IP. Todos los puertos de receptores están disponibles (30000, 9898, 5000, etc.)',
  'cloud_connector.failed_message':
    'El aprovisionamiento falló. Por favor intenta de nuevo o contacta a soporte.',
  'cloud_connector.retry_button': 'Reintentar',
  'cloud_connector.update_button': 'Actualizar Connector',
  'cloud_connector.update_error': 'Error al actualizar el cloud connector',
  'cloud_connector.restart_button': 'Reiniciar Connector',
  'cloud_connector.restart_error': 'Error al reiniciar el cloud connector',
  'cloud_connector.retry_success': 'Reintentando aprovisionamiento...',
  'cloud_connector.retry_error': 'Error al reintentar el aprovisionamiento',
  'cloud_connector.not_available': 'No disponible',
  'cloud_connector.busy':
    'Ya hay una operación en curso en este cloud connector. Espera a su resultado.',
  'cloud_connector.operation_no_result':
    'No llegó el resultado. Vuelve a abrir los detalles en unos minutos para ver cómo quedó.',
  'cloud_connector.restart_started': 'Reinicio iniciado',
  'cloud_connector.restart_outcome_success': 'Connector reiniciado',
  'cloud_connector.restart_outcome_failed':
    'No se pudo reiniciar el connector: {{reason}}',
  'cloud_connector.restart_outcome_unknown':
    'No se sabe si el connector se reinició: {{reason}}',
  'cloud_connector.update_started':
    'Actualización iniciada. Puede tardar unos minutos.',
  'cloud_connector.update_outcome_success': 'Connector actualizado',
  'cloud_connector.update_outcome_failed':
    'No se pudo actualizar el connector: {{reason}}',
  'cloud_connector.update_outcome_unknown':
    'No se sabe si la actualización terminó: {{reason}}',
  'cloud_connector.pending_message': 'Preparando el aprovisionamiento...',
  'cloud_connector.stale_message':
    'El aprovisionamiento lleva demasiado tiempo sin terminar. Puedes reintentarlo.',
  'cloud_connector.status_ready': 'Listo: el connector está conectado.',
  'cloud_connector.status_installing':
    'Instalando el connector en el droplet: aparecerá conectado en unos minutos.',
  'cloud_connector.status_offline': 'El connector no está conectado.',
  'cloud_connector.extras_title': 'Extras',
  'cloud_connector.extras_description':
    'Servicios opcionales que corren junto al connector en el droplet. Encenderlos o apagarlos nunca reinicia el connector.',
  'cloud_connector.extras_legacy':
    'Este cloud connector se creó antes de que los extras fueran opcionales, y ejecuta OSM y Traccar. Guarda una vez para que Treinco los gestione: el connector no se reinicia.',
  'cloud_connector.extra_osm': 'OSM (servidor GPRS de EBS)',
  'cloud_connector.extra_osm_ports':
    'Los paneles EBS se conectan a la IP estática: LX 6876, AT 6877, CPX 6878, AG 6879.',
  'cloud_connector.extra_osm_receiver_missing':
    'OSM envía los eventos al connector por el puerto 7000, y este connector no tiene ese receiver: sin él no llega nada. Crea un receiver con tipo EBS, conexión tcp_server y puerto 7000; asígnale el prefijo del workspace con la línea vacía y pulsa Start.',
  'cloud_connector.extra_traccar': 'Traccar (rastreadores GPS)',
  'cloud_connector.extra_traccar_ports':
    'Los rastreadores se conectan a la IP estática: gps103 5001, tk103 5002, teltonika 5027, osmand 5055.',
  'cloud_connector.extra_traccar_receiver_missing':
    'Traccar envía las posiciones al connector por el puerto 1598, y este connector no tiene ese receiver: sin él no llega nada. Crea un receiver con tipo Traccar, conexión http_server y puerto 1598; deja vacíos la URL, el usuario y la contraseña de Traccar, asígnale el prefijo del workspace con la línea vacía y pulsa Start.',
  'cloud_connector.extras_save': 'Guardar extras',
  'cloud_connector.extras_applying_button': 'Aplicando...',
  'cloud_connector.extras_applying':
    'Aplicando los extras en el droplet. Puede tardar unos minutos.',
  'cloud_connector.extras_success': 'Extras aplicados',
  'cloud_connector.extras_unknown':
    'No se sabe cómo quedaron los extras: {{reason}}. Vuelve a guardar para asegurarte.',
  'cloud_connector.extras_partial': 'Los extras se guardaron, pero: {{reason}}',
  'cloud_connector.extras_failed':
    'No se pudieron aplicar los extras: {{reason}}',
  'cloud_connector.extras_error': 'Error al guardar los extras',

  // Cloud connector integration labels
  'integration_labels.provisioningStatus': 'Estado de aprovisionamiento',
  'integration_labels.reservedIp': 'IP Reservada',
  'integration_labels.dropletSize': 'Tamaño del servidor',
  'integration_labels.statusMessage': 'Mensaje de estado',

  'integrations_table.hik_partner_pro_type_text': 'Hikvision Partner Pro',
  'integrations_form.workspace_prefix_field': 'Prefijo de la integración',

  // Settings general
  'workspace.settings.general.form.name': 'Nombre del espacio de trabajo',
  'workspace.settings.general.form.workspaceUrl':
    'Dirección URL del espacio de trabajo',
  'settings.general.button_edit': 'Guardar cambios',
  'validation.workspace_name_required':
    'El nombre del espacio de trabajo no puede estar vacío',
  'validation.workspace_name_min_length':
    'El nombre del espacio de trabajo debe tener al menos 3 caracteres',
  'validation.workspace_name_max_length':
    'El nombre del espacio de trabajo no puede tener más de 50 caracteres',
  'workspaces.create_workspace_modal.step1.name.input_label_text':
    'Nombre del espacio de trabajo',
  'workspace.settings.general.form.addressTitle': 'Dirección',
  'workspace.settings.general.form.billingTitle': 'Facturación',
  'workspace.settings.general.form.currency': 'Moneda predeterminada',
  'validation.currency_format': 'La moneda debe ser un código ISO de 3 letras',
  'workspace.change_avatar_modal.title': 'Cambiar avatar',
  'workspace.view_avatar_modal.label': 'Ver',
  'workspace.view_avatar_modal.title': 'Avatar del espacio de trabajo',
  // Settings users
  'settings.users_table.name_field_text': 'Roles',
  'settings.users_table.type_field_text': 'Tipo',
  'settings.users_table.last_activity_field_text': 'Última conexión',
  'settings.users_table.action_field_text': 'Acciones',
  'settings.users_table.user_roles_field_text': 'Usuarios',
  'settings.users_table.invitation_type_text': 'Invitación',
  'inviteUser.dialog.title': 'Invitar al espacio de trabajo',
  'inviteUser.dialog.subtitle':
    'Envía una invitación para formar parte de este espacio de trabajo, si el correo electrónico aún no está registrado, se le invitará primero a crear una cuenta',
  'WorkspaceInvitation.invitation.accepted':
    'Invitación al espacio de trabajo aceptada exitosamente',
  'WorkspaceInvitation.invitation.invalid': 'La invitación no es válida',
  'InviteUserToWorkspace.invite': 'Invitar usuario al workspace',
  'InviteUserToWorkspace.form.email': 'Correo electrónico',
  'user_edit_form.title_text': 'Editar rol de usuario',
  'user_edit_form.subtitle_text': 'Aqui puedes cambiar el rol de un usuario',
  'user_edit_form.role': 'Seleccionar rol de usuario',
  'user_edit_form.button_submit_label': 'Editar usuario',
  'user_edit_form.success_message': 'Usuario actualizado exitosamente',
  // Settings roles
  'settings.roles_table.name_field_text': 'Nombre',
  'settings.roles_table.actions_field_text': 'Acciones',

  'roles_form.create': 'Crear rol',
  'roles_form.update': 'Editar rol',
  'roles_form.name_placeholder_text': 'Nombre del rol',
  'roles_form.create_submit_text': 'Crear',
  'roles_form.update_submit_text': 'Editar',
  'roles_form.update_role_success_message': 'Rol actualizado exitosamente',
  'roles_form.create_role_error_message': 'Error al crear el rol',
  'roles_form.create_role_success_message': 'Rol creado exitosamente',
  'role_form.permissions_label': 'Selecciona los permisos por recurso',
  'role_form.select_all_label': 'Seleccionar todos',
  'role_form.permission_not_assignable': 'No tienes este permiso',

  // Settings events
  'settings.events_table.description_field_text': 'Descripción',
  'settings.events_table.type_field_text': 'Tipo',
  'settings.events_table.code_field_text': 'Código',
  'settings.events_table.event_group_field_text': 'Grupo de eventos',
  'settings.events_table.protocol_field_text': 'Protocolo',
  'settings.events_table.actions_field_text': 'Acciones',
  'settings.events_table.monitorable_field_text': 'Monitoreable',
  'settings.events_table.monitorable': 'Evento monitoreable',
  'settings.events_table.not_monitorable': 'Evento no monitoreable',

  'createEvent.dialog.title': 'Crear evento',
  'createEvent.dialog.subtitle':
    'Aquí puedes crear un evento para que esté disponible en tu espacio de trabajo',
  'createEvent.form.technicalDescription': 'Descripción',
  'createEvent.form.type': 'Tipo',
  'createEvent.form.code': 'Código',
  'event.form.type_zone_option': 'Zona',
  'event.form.type_user_option': 'Usuario',
  'event.form.type_none_option': 'Ninguno',
  'create_event.form.protocol': 'Selecciona un protocolo',
  'create_event.event_group.select': 'Selecciona un grupo de eventos',
  'createEvent.form.priority': 'Prioridad',
  'createEvent.form.priority_helper':
    '1 = Crítico (emergencias de vida), 10 = Mínimo (sin impacto en seguridad)',
  'events.form.is_monitoring_input_label': '¿Es un evento de monitoreable?',
  'createEvent.submit': 'Crear evento',
  'editEvent.submit': 'Editar evento',
  'editEvent.dialog.title': 'Editar evento',
  'editEvent.dialog.subtitle':
    'Aquí puedes editar un evento para que esté disponible en tu espacio de trabajo',
  'createEvent.form.color.not_selected': 'Sin color',
  'createEvent.form.color_select_label': 'Color de fondo',
  'CreateEvent.success': 'Evento creado exitosamente',
  'updateEvent.success': 'Evento actualizado exitosamente',
  'updateEvent.general.error': 'Error al actualizar el evento',
  'eventItem.delete.title.confirmation': 'Eliminar Evento',
  'eventItem.delete.confirmation':
    '¿Estás seguro de que deseas eliminar este evento?',
  'eventItem.general.error': 'Error al generar el evento',
  'updateEvent.general.error': 'Error al actualizar el evento',
  // Settings brands
  'settings.brands_table.name_field_text': 'Marca',
  'settings.brands_table.website_field_text': 'Sitio web',
  'settings.brands_table.actions_field_text': 'Acciones',
  'CreateBrand.title': 'Crear marca',
  'CreateBrand.form.name': 'Nombre',
  'CreateBrand.form.website': 'Sitio web',
  'CreateBrand.button.submit': 'Crear',
  'CreateBrand.success': 'Marca creada exitosamente',
  'CreateBrand.general.error': 'Error al crear la marca',
  'brandItem.delete.title.confirmation': 'Eliminar marca',
  'brandItem.delete.confirmation':
    '¿Está seguro de que desea eliminar esta marca?',
  'brandItem.general.error': 'Error al eliminar la marca',

  // Settings models
  'settings.models_table.name_field_text': 'Modelo',
  'settings.models_table.actions_field_text': 'Acciones',
  'settings.models_table.type_field_text': 'Tipo',
  'settings.models_table.brand_field_text': 'Marca',
  'CreateModel.title': 'Crear modelo',
  'CreateModel.form.name': 'Nombre',
  'CreateModel.brand.select': 'Selecciona una marca',
  'CreateModel.form.type': 'Tipo',
  'CreateModel.button.submit': 'Crear',
  'CreateModel.success': 'Modelo creado exitosamente',
  'CreateModel.general.error': 'Error al crear el modelo',
  'settings.models_table.round_type_text': 'Rondas',
  'settings.models_table.gps_type_text': 'GPS',
  'settings.models_table.alarm_type_text': 'Alarma',
  'settings.models_table.cctv_type_text': 'CCTV',
  'model.type.round': 'Rondas',
  'model.type.gps': 'GPS',
  'model.type.alarm': 'Alarma',
  'model.type.cctv': 'CCTV',

  // Settings resolutions
  'settings.resolutions_table.text_field_text': 'Resolución predefinida',
  'settings.resolutions_table.actions_field_text': 'Acciones',
  'CreateResolution.title': 'Crear resolución',
  'CreateResolution.form.text': 'Texto',
  'CreateResolution.button.submit': 'Crear',
  'CreateResolution.success': 'Resolución creada exitosamente',
  'updateResolution.success': 'Resolución actualizada exitosamente',
  'CreateResolution.general.error': 'Error al crear la resolución',
  'resolutionItem.general.error': 'Error con la resolución',

  // Settings event groups
  'settings.event_groups_table.name_field_text': 'Nombre',
  'settings.event_groups_table.device_type_field_text': 'Tipos de dispositivos',
  'settings.event_groups_table.actions_field_text': 'Acciones',
  'CreateEventGroup.title': 'Crear grupo de eventos',
  'CreateEventGroup.form.name': 'Nombre',
  'CreateEventGroup.form.deviceTypes': 'Tipos de dispositivos',
  'CreateEventGroup.button.submit': 'Crear',
  'CreateEventGroup.success': 'Grupo de eventos creado exitosamente',
  'CreateEventGroup.general.error': 'Error al crear grupo de eventos',
  'eventGroupItem.general.error': 'Error con el grupo de eventos',
  'eventGroupTable.edit.eventGroup': 'Editar',

  // Settings emergency contact
  'settings.emergency_contacts_table.button_create':
    'Crear contacto de emergencia',
  'settings.emergency_contact_table.name_field_text': 'Contacto de emergencia',
  'settings.emergency_contact_table.phone_numbers_field_text':
    'Números de teléfono',
  'settings.emergency_contact_table.actions_field_text': 'Acciones',
  'CreateEmergencyContact.title': 'Crear contacto de emergencia',
  'EditEmergencyContact.title': 'Actualizar contacto de emergencia',
  'createEmergencyContact.form.name': 'Nombre',
  'createEmergencyContact.form.note': 'Nota',
  'createEmergencyContact.form.contactIdentifier':
    'Documento de identificación',
  'createEmergencyContact.form.email': 'Correo electrónico',
  'PhoneNumberForm.form.phoneNumbers': 'Números de teléfono',
  'CreateEmergencyContact.button.submit': 'Crear contacto',
  'EditEmergencyContact.button.submit': 'Actualizar contacto',
  'emergencyContact.create.success':
    'Contacto de emergencia creado exitosamente',
  'emergencyContact.update.success':
    'Contacto de emergencia actualizado exitosamente',
  'CreateEmergencyContact.general.error':
    'Error al crear el contacto de emergencia',
  'form.phoneNumber': 'Número de teléfono',
  'value.Add': 'Agregar',
  'value.Number': 'Número',
  'value.Code': 'Código',
  'emergencyContact.button_import_contacts': 'Importar contactos de emergencia',
  'emergencyContact.button_add': 'Agregar contacto de emergencia',
  'import.emergency.contact.title': 'Título',
  'device.emergency.contact.button.submit': 'Importar contacto de emergencia',
  'emergency.contact.list.select.title': 'Seleccionar contacto de emergencia',
  'emergency.contact.button.submit': 'Agregar contacto de emergencia',
  'add.device.emergency.contact.title': 'Agregar contacto de emergencia',
  'deviceEmergencyContact.select': 'Nombre de contacto de emergencia',
  'device.emergency.contact.button.submit': 'Agregar contacto de emergencia',
  'CreateEmergencyContact.advancedSettings': 'Opciones avanzadas',
  'createEmergencyContact.form.confirmation_code': 'Código de confirmación',
  'createEmergencyContact.form.duress_code': 'Código de Coacción',
  'createEmergencyContact.form.cra_code': 'Código CRA',

  // Settings emergency contact list
  'settings.emergency_contact_list_table.button_create':
    'Crear lista de contactos de emergencia',
  'settings.emergency_contact_list_table.name_field_text':
    'Lista de contactos de emergencia',
  'settings.emergency_contact_list_table.actions_field_text': 'Acciones',
  'CreateEmergencyContactList.title': 'Crear lista de contactos de emergencia',
  'createEmergencyContactList.form.name': 'Nombre',
  'CreateEmergencyContactList.button.submit': 'Crear lista',
  'CreateEmergencyContactList.success':
    'Lista de contactos de emergencia creada exitosamente',
  'EditEmergencyContactList.title': 'Editar lista de contactos de emergencia',
  'EditEmergencyContactList.button.submit': 'Actualizar lista',

  // Settings notification groups
  'notification_group_form.description_field': 'Descripción',
  'notification_group_form.add_events_or_groups_label':
    'Agregar eventos o grupos de eventos',
  'create_notification_group_form.error_message':
    'Error creando grupo de notificaciones',
  'edit_notification_group_form.error_message':
    'Error actualizando grupo de notificaciones',
  'create_notification_group_form.submit_text': 'Crear grupo de notificaciones',
  'edit_notification_group_form.submit_text':
    'Actualizar grupo de notificaciones',
  'notification_group_data_search.no_options': 'Sin opciones',
  'notification_group_form.selected_item_name_column': 'Descripción',
  'notification_group_form.type_event': 'Evento',
  'notification_group_form.type_eventGroup': 'Grupo de eventos',
  'notification_group_form.type_allProtocolEvents': 'Protocolo',
  'notification_group_data_search.all_protocol_events':
    'Todos los eventos de {{protocol}}',
  'notification_group_form.selected_item_actions_column': 'Acción',
  'notification_group_form.remove_item_aria_label': 'Quitar',
  'notification_group_data_search.label': 'Buscar evento o grupo de eventos',
  'notification_group.delete.success':
    'grupo de notificaciones borrado correctamente',
  'notification_group.delete.error': 'Error al borrar grupo de notificaciones',
  'notificationGroup_form.title_text': 'Grupo de notificaciones',
  'notificationGroup_form.subtitle_text':
    'Aquí puedes configurar tu grupo de notificaciones, lo que te permitirá agrupar eventos y grupos de eventos para enviar notificaciones.',
  'notification_group_form.create_success':
    'Grupo de notificaciones creado correctamente',
  'notification_group_form.update_success':
    'Grupo de notificaciones actualizado correctamente',
  'notification_group_form.create_error':
    'Error al crear grupo de notificaciones',
  'notification_group_form.update_error':
    'Error al actualizar el grupo de notificaciones',

  //Dashboard (greetings)
  'page.dashboard.title': 'Panel',
  'page.reports.title': 'Reportes',
  'page.reports.subtitle': 'Selecciona un reporte para visualizar',

  // Reports
  'reports.devices_by_event.title': 'Dispositivos por Evento',
  'reports.devices_by_event.description':
    'Lista de dispositivos que reportaron un evento o grupo de eventos específico en un período de tiempo',
  'reports.devices_by_event.table.events': 'Eventos',
  'reports.devices_by_event.table.events_button': '{{count}} eventos',
  'reports.devices_by_event.table.events_button_one': '{{count}} evento',
  'reports.select_date': 'Seleccionar fecha',
  'reports.start_date': 'Fecha inicio',
  'reports.end_date': 'Fecha fin',
  'reports.date_range_error':
    'La fecha de fin debe ser posterior a la de inicio',
  'reports.date_required': 'Este campo es obligatorio',
  'reports.fetch': 'Consultar',
  'reports.view_table': 'Tabla',
  'reports.view_chart': 'Gráfica',
  'reports.no_results': 'Sin resultados',
  'reports.no_rounds_for_date':
    'No se encontraron rondas para la fecha seleccionada.',
  'reports.round_resume': 'Resumen de ronda',
  'reports.events_summary': 'Resumen de eventos',
  'reports.rounds_completed': 'Rondas completadas',
  'reports.rounds_incomplete': 'Rondas incompletas',
  'reports.start': 'Inicio',
  'reports.end': 'Fin',
  'reports.incomplete': 'Incompleta',
  'reports.total_events': 'Eventos totales',
  'reports.event': 'Evento (Descripción)',
  'reports.total': 'Total',
  'reports.percent': '%',
  'reports.rounds_initiated': 'Rondas iniciadas',
  'reports.export': 'Exportar',
  'reports.export_csv': 'CSV',
  'reports.export_xls': 'XLS',
  'reports.export_pdf': 'PDF',
  'reports.rounds_report.description':
    'Visualiza los eventos registrados durante las rondas de guardia',
  'reports.rounds_report.col_round': 'Ronda',
  'reports.devices_by_event.table.events_button_other': '{{count}} eventos',
  'reports.devices_by_event.modal.title': 'Eventos del dispositivo',
  'reports.devices_by_event.modal.total_one': '{{count}} evento en este rango',
  'reports.devices_by_event.modal.total_other':
    '{{count}} eventos en este rango',
  'reports.devices_by_event.modal.close': 'Cerrar',
  'reports.devices_by_activity.title': 'Dispositivos por Actividad',
  'reports.devices_by_activity.description':
    'Lista de dispositivos ordenados por número de eventos o situaciones reportadas en un período de tiempo',
  'reports.devices_by_activity.table.events': 'Eventos',
  'reports.devices_by_activity.table.events_button': '{{count}} eventos',
  'reports.devices_by_activity.table.events_button_one': '{{count}} evento',
  'reports.devices_by_activity.table.events_button_other': '{{count}} eventos',
  'reports.devices_by_activity.modal.title': 'Eventos del dispositivo',
  'reports.devices_by_activity.modal.total_one':
    '{{count}} evento en este rango',
  'reports.devices_by_activity.modal.total_other':
    '{{count}} eventos en este rango',
  'reports.devices_by_activity.modal.total': 'Total',
  'reports.devices_by_activity.modal.close': 'Cerrar',
  'reports.devices_by_activity.no_search_prompt':
    'Seleccione el rango de fechas y haga clic en Buscar para ver los resultados',
  'reports.devices_by_last_event.title': 'Dispositivos por Último Evento',
  'reports.devices_by_last_event.description':
    'Lista de dispositivos ordenados por último evento recibido (ascendente o descendente)',
  'reports.devices_by_last_event.table.last_event_date': 'Fecha Último Evento',
  'reports.devices_by_last_event.table.event': 'Evento',
  'reports.devices_by_last_event.table.zone': 'Zona',
  'reports.devices_by_last_event.table.user': 'Usuario',
  'reports.devices_by_last_event.table.partition': 'Partición',
  'reports.devices_by_last_event.table.no_event': 'Sin eventos',
  'reports.devices_by_last_event.load_devices': 'Cargar Dispositivos',
  'reports.devices_by_last_event.no_search_prompt':
    'Haga clic en Cargar Dispositivos para ver los resultados',
  'reports.devices_without_image.title': 'Dispositivos sin Imagen',
  'reports.devices_without_image.description':
    'Lista de dispositivos que no tienen una imagen asignada',
  'reports.devices_without_image.load_devices': 'Cargar Dispositivos',
  'reports.devices_without_image.no_search_prompt':
    'Haga clic en Cargar Dispositivos para ver dispositivos sin imágenes',
  'reports.devices_without_image.found_devices':
    '{{count}} dispositivos sin imagen',
  'reports.devices_without_image.found_devices_one':
    '{{count}} dispositivo sin imagen',
  'reports.devices_without_image.found_devices_other':
    '{{count}} dispositivos sin imagen',
  'reports.devices_by_last_position.title': 'Dispositivos por Última Posición',
  'reports.devices_by_last_position.description':
    'Lista de dispositivos ordenados por última posición recibida (ascendente o descendente)',
  'reports.devices_by_last_position.table.last_position_date':
    'Fecha Última Posición',
  'reports.devices_by_last_position.table.latitude': 'Latitud',
  'reports.devices_by_last_position.table.longitude': 'Longitud',
  'reports.devices_by_last_position.table.speed': 'Velocidad',
  'reports.devices_by_last_position.table.received_at': 'Recibido En',
  'reports.devices_by_last_position.table.no_position': 'Sin posición',
  'reports.devices_by_last_position.load_devices': 'Cargar Dispositivos',
  'reports.devices_by_last_position.no_search_prompt':
    'Haga clic en Cargar Dispositivos para ver los resultados',
  'reports.devices_without_place.title': 'Dispositivos sin Lugar',
  'reports.devices_without_place.description':
    'Lista de dispositivos que no tienen un lugar asignado',
  'reports.devices_without_place.load_devices': 'Cargar Dispositivos',
  'reports.devices_without_place.no_search_prompt':
    'Haga clic en Cargar Dispositivos para ver dispositivos sin lugares',
  'reports.devices_without_place.found_devices':
    '{{count}} dispositivos sin lugar',
  'reports.devices_without_place.found_devices_one':
    '{{count}} dispositivo sin lugar',
  'reports.devices_without_place.found_devices_other':
    '{{count}} dispositivos sin lugar',
  'reports.filters.event_group': 'Grupo de Eventos',
  'reports.filters.date_from': 'Fecha Desde',
  'reports.filters.date_to': 'Fecha Hasta',
  'reports.filters.all': 'Todos',

  'dashboard.greetings.morning': '¡Buenos días! 👋',
  'dashboard.greetings.afternoon': '¡Buenas tardes! ☕',
  'dashboard.greetings.night': '¡Buenas noches! 🌃',
  'dashboard.graph_message.new_devices_from_last_month':
    'Dispositivos creados los últimos 31 días',
  'dashboard.graph_legend.devices_created': 'Dispositivos creados',
  'dashboard.devices_chart.labels.daily': 'Total diario (últimos 31 días)',
  'dashboard.devices_chart.labels.monthly': 'Total mensual (últimos 12 meses)',
  'dashboard.devices_chart.labels.yearly': 'Total anual (últimos 5 años)',
  'dashboard.devices_chart.legend.total_devices':
    'Dispositivos en el espacio de trabajo',
  'dashboard.devices_chart.toggle.daily': 'Diario',
  'dashboard.devices_chart.toggle.monthly': 'Mensual',
  'dashboard.devices_chart.toggle.yearly': 'Anual',
  'dashboard.monitoring_heatmap.title': 'Carga de situaciones',
  'dashboard.monitoring_heatmap.range': '{{start}} – {{end}}',
  'dashboard.monitoring_heatmap.previous_week': 'Semana anterior',
  'dashboard.monitoring_heatmap.next_week': 'Semana siguiente',
  'dashboard.monitoring_heatmap.no_data':
    'Aún no hay situaciones registradas esta semana',
  'dashboard.monitoring_heatmap.tooltip_empty':
    'No hay situaciones a las {{hour}} el {{day}}',
  'dashboard.monitoring_heatmap.tooltip_one':
    '{{count}} situación a las {{hour}} el {{day}}',
  'dashboard.monitoring_heatmap.tooltip_other':
    '{{count}} situaciones a las {{hour}} el {{day}}',
  'dashboard.monitoring_heatmap.error':
    'No fue posible cargar el mapa de calor de situaciones',
  // user profile
  'account.popover.home': 'Inicio',
  'account.popover.profile': 'Perfil',
  'account.popover.settings': 'Configuración',
  'account.popover.logout': 'Cerrar sesión',
  'account_popover.workspace_user': 'Cambiar a usuario de espacio de trabajo',
  'account_popover.customer_user': 'Cambiar a usuario de cliente',
  'account_popover.admin_mode': 'Modo Admin',

  // Admin Mode
  'admin.sidebar.title': 'Treinco Admin',
  'admin.sidebar.subtitle': 'Gestión del Sistema',
  'admin.sidebar.management': 'Gestión',
  'admin.sidebar.workspaces': 'Espacios de Trabajo',
  'admin.sidebar.users': 'Usuarios',
  'admin.sidebar.integrations': 'Integraciones',
  'admin.integrations.title': 'Integraciones',
  'admin.integrations.subtitle':
    'Administrar todas las integraciones de todos los espacios de trabajo',
  'admin.integrations.workspace_column': 'Espacio de trabajo',
  'admin.integrations.select_workspace': 'Seleccionar Espacio de Trabajo',
  'admin.integrations.search_workspace': 'Buscar espacio de trabajo...',
  'admin.integrations.no_workspaces_found':
    'No se encontraron espacios de trabajo',
  'admin.workspaces.title': 'Espacios de Trabajo',
  'admin.workspaces.subtitle':
    'Ver y gestionar todos los espacios de trabajo del sistema',
  'admin.workspaces.columns.name': 'Nombre',
  'admin.workspaces.columns.mode': 'Modo',
  'admin.workspaces.columns.created_at': 'Creado',
  'admin.workspaces.open_dashboard': 'Abrir panel del espacio de trabajo',
  'admin.users.title': 'Usuarios',
  'admin.users.subtitle': 'Ver todos los usuarios del sistema',
  'admin.users.columns.user': 'Usuario',
  'admin.users.columns.name': 'Nombre',
  'admin.users.columns.email': 'Email',
  'admin.users.columns.roles': 'Roles',
  'admin.users.columns.role': 'Rol',
  'admin.users.columns.scope': 'Alcance',
  'admin.users.columns.resource': 'Recurso',
  'admin.users.columns.created_at': 'Creado',
  'admin.users.columns.actions': 'Acciones',

  // Admin Workspace Profile
  'admin.workspace_profile.tabs.general': 'General',
  'admin.workspace_profile.tabs.monitoring': 'Monitoreo',
  'admin.workspace_profile.cover.mode': 'Modo',
  'admin.workspace_profile.cover.created_at': 'Creado',
  'admin.workspace_profile.cover.id': 'ID',
  'admin.workspace_profile.not_found.title': 'Workspace no encontrado',
  'admin.workspace_profile.not_found.description':
    'El workspace que buscas no existe o no tienes acceso a él.',
  // Admin Monitoring Tab
  'admin.monitoring.stats.online_operators': 'Operadores en línea',
  'admin.monitoring.stats.free_situations': 'Situaciones libres en cola',
  'admin.monitoring.columns.operator': 'Operador',
  'admin.monitoring.columns.status': 'Estado',
  'admin.monitoring.columns.assigned_situations': 'Situaciones asignadas',
  'admin.monitoring.columns.last_activity': 'Última actividad',
  'admin.monitoring.columns.session': 'Sesión',
  'admin.monitoring.status.free': 'Libre',
  'admin.monitoring.status.busy': 'Ocupado',
  'admin.monitoring.status.paused': 'Pausado',
  'admin.monitoring.status.unknown': 'Desconocido',
  'admin.monitoring.empty.title': 'Sin operadores conectados',
  'admin.monitoring.empty.description':
    'No hay operadores activos en este workspace.',
  'admin.monitoring.error.title': 'Error al cargar operadores',
  'admin.workspace_profile.not_found.description':
    'El workspace que buscas no existe o no tienes acceso a él.',
  'admin.workspace_profile.monitoring.toggle_label': 'Monitoreo habilitado',
  'admin.workspace_profile.monitoring.update_error':
    'Error al actualizar el estado de monitoreo',
  'admin.workspace_profile.monitoring.enable_success':
    'Monitoreo habilitado exitosamente',
  'admin.workspace_profile.monitoring.disable.title': 'Deshabilitar monitoreo',
  'admin.workspace_profile.monitoring.disable.description':
    'Los nuevos eventos de este workspace dejarán de entregarse a los operadores. Las situaciones activas continuarán su flujo normal.',
  'admin.users.actions.add_role': 'Agregar Rol',
  'admin.users.actions.remove_role': 'Eliminar Rol',
  'admin.users.scope.system': 'Sistema',
  'admin.users.scope.account': 'Cuenta',
  'admin.users.scope.workspace': 'Espacio de trabajo',
  'admin.users.scope.customer': 'Cliente',
  'admin.users.scope.device': 'Dispositivo',
  'admin.users.scope.user': 'Usuario',
  'admin.users.messages.role_added': 'Rol agregado exitosamente',
  'admin.users.messages.role_removed': 'Rol eliminado exitosamente',
  'admin.users.messages.error': 'Ocurrió un error',
  'admin.users.messages.error_loading_roles': 'Error al cargar roles',
  'admin.users.add_role_modal.title': 'Agregar rol a {{name}}',
  'admin.users.add_role_modal.steps.scope': 'Alcance',
  'admin.users.add_role_modal.steps.resource': 'Recurso',
  'admin.users.add_role_modal.steps.role': 'Rol',
  'admin.users.add_role_modal.scope_description':
    'Seleccione el nivel de alcance para este rol',
  'admin.users.add_role_modal.scope_hints.system':
    'Acceso completo a todo el sistema',
  'admin.users.add_role_modal.scope_hints.account':
    'Acceso a una cuenta específica',
  'admin.users.add_role_modal.scope_hints.workspace':
    'Acceso a un espacio de trabajo específico',
  'admin.users.add_role_modal.scope_hints.customer':
    'Acceso a un cliente específico',
  'admin.users.add_role_modal.scope_hints.device':
    'Acceso a un dispositivo específico',
  'admin.users.add_role_modal.scope_hints.user':
    'Acceso para administrar un usuario específico',
  'admin.users.add_role_modal.select_account': 'Seleccionar cuenta',
  'admin.users.add_role_modal.select_workspace':
    'Seleccionar espacio de trabajo',
  'admin.users.add_role_modal.select_customer': 'Seleccionar cliente',
  'admin.users.add_role_modal.select_device': 'Seleccionar dispositivo',
  'admin.users.add_role_modal.select_user': 'Seleccionar usuario',
  'admin.users.add_role_modal.search_placeholder': 'Escriba para buscar...',
  'admin.users.add_role_modal.type_to_search':
    'Escriba al menos 2 caracteres para buscar',
  'admin.users.add_role_modal.no_results': 'No se encontraron resultados',
  'admin.users.add_role_modal.select_role': 'Seleccionar rol',
  'admin.users.add_role_modal.role_description':
    'Asignar un rol para {{scope}}: {{resource}}',
  'admin.users.add_role_modal.add_role': 'Agregar Rol',

  'page.user.profile': 'Perfil de usuario',
  'page.user.tabs.general': 'General',
  'page.user.tabs.change_password': 'Cambiar Contraseña',
  'user.profile.tabs.general': 'General',
  'user.profile.tabs.change_password': 'Cambiar contraseña',
  'user.profile.changePassword.form.oldPassword': 'Contraseña anterior',
  'user.profile.changePassword.form.new.password': 'Contraseña nueva',
  'user.profile.changePassword.form.confirm.password': 'Confirmar contraseña',
  'user.profile.changePassword.submit': 'Cambiar contraseña',
  'user_edit_form.button_submit_label': 'Editar usuario',
  'user_edit_form.role': 'Seleccionar rol',
  'user.profile.file_type': 'Archivos permitidos : *.jpeg, *.jpg, *.png, *.gif',
  'user.profile.max_size': 'tamaño maximo de',
  'user.profile.file': 'Subir archivo',
  'user.remove.avatar.title': 'Eliminar avatar',
  'user.remove.avatar.description':
    '¿Estás seguro que deseas eliminar tu avatar?',
  'user.delete.title.confirmation':
    '¿Estás seguro que deseas eliminar tu cuenta?',
  'user.avatar.delete.confirmation':
    'Los datos eliminados no podrán ser recuperados',
  'user.change_avatar_modal.title': 'Cambiar avatar',
  'user.view_avatar_modal.label': 'Ver avatar',
  'user.view_avatar_modal.title': 'Avatar',
  // 'removeCustomerDialog.title': 'Esta seguro que desea eliminar el cliente',
  // 'removeCustomerDialog.subtitle':
  //   'Se borraran todos los datos del Cliente y no se podrán recuperar',

  // action groups
  'settings.settings_tabs.actions_tab_title': 'Grupos de Accion',
  'settings.settings_tabs.items_tab_title': 'Artículos',
  'settings.settings_tabs.plans_tab_title': 'Planes',
  'settings.settings_tabs.invoice_series_tab_title': 'Series de Facturas',
  'settings.settings_tabs.api_keys_tab_title': 'Gestión de API',
  'api_keys.name': 'Nombre',
  'api_keys.role': 'Rol',
  'api_keys.created_by': 'Creado por',
  'api_keys.expires': 'Vence',
  'api_keys.created_at': 'Creado',
  'api_keys.actions': 'Acciones',
  'api_keys.never': 'Nunca',
  'api_keys.revoke': 'Revocar',
  'api_keys.create': 'Crear clave de API',
  'api_keys.expires_at': 'Fecha de expiración (opcional)',
  'api_keys.revoke_confirm_title': 'Revocar clave de API',
  'api_keys.revoke_confirm_body':
    'Esta acción no se puede deshacer. La clave dejará de funcionar de inmediato.',
  'api_keys.revoked_success': 'Clave de API revocada',
  'api_keys.token_title': 'Clave de API creada',
  'api_keys.token_warning': 'Copie este token ahora. No se mostrará de nuevo.',
  'api_keys.token_copied': 'Token copiado',
  'api_keys.date_future_error': 'La fecha debe ser en el futuro',
  'api_keys.name_required_error': 'El nombre es obligatorio',
  'api_keys.role_required_error': 'El rol es obligatorio',
  'api_keys.copy': 'Copiar',
  'settings.actions_table.name_field_text': 'Nombre del grupo de accion',
  'settings.actions_table.actions_field_text': 'Acciones',
  'create_action_group_form.submit_text': 'Crear Grupo de Acción',
  'edit_action_group_form.submit_text': 'Editar Grupo de Acción',
  'action_group_form.name_field': 'Nombre del Grupo de Acción',
  'action_group_form.success': 'Grupo de acciones creado exitosamente',
  'action_group_form.error': 'Error al crear el grupo de acciones',
  'action_group_form.update_default.success':
    'Grupo de acciones predeterminado actualizado exitosamente',
  'action.delete_success': 'Acción eliminada exitosamente',
  'action.delete_error': 'Error al eliminar la acción',
  'import_action_group_form.success':
    'Grupo de acciones importado exitosamente',
  'import_action_group_form.error': 'Error al importar el grupo de acciones',
  'actionGroup.delete.success': 'Grupo de acciones eliminado exitosamente',
  'actionGroups.save.order': 'Guardar orden',
  'deviceActionGroup.order.success': 'Orden guardado exitosamente',
  'monitoring_device_history.loading_error':
    'Error al cargar el historial del dispositivo',
  'action_groups.error': 'Error con los grupos de acción',
  // custom event form
  'event_form.create_submit_button': 'Crear evento personalizado',
  'event_form.update_submit_button': 'Editar evento personalizado',
  'createDeviceCustomEvent.success':
    'Evento personalizado del dispositvo creado correctamente',
  'createDeviceCustomEvent.error':
    'Error al crear el evento personalizado del dispositivo',
  'updateDeviceCustomEvent.success':
    'Evento personalizado actualizado correctamente',
  'updateDeviceCustomEvent.error':
    'Error al actualizar el evento personalizado',

  'create_event.form.eventGroup': 'Grupo de eventos',

  'item.delete.title.confirmation':
    '¿Estás seguro que deseas eliminar este elemento?',
  'item.delete.confirmation': 'Los datos eliminados no podrán ser recuperados',
  'itemItem.delete.title.confirmation': 'Eliminar elemento',
  'itemItem.delete.confirmation':
    '¿Está seguro de que desea eliminar este elemento?',

  // kanban

  'service_orders_page.title_text': 'Órdenes de servicio',
  'invoices_page.title_text': 'Facturas',

  'invoices.table.identifier': 'Identificador',
  'invoices.table.customer': 'Cliente',
  'invoices.table.no_customer': 'Sin cliente',
  'invoices.table.status': 'Estado',
  'invoices.table.issue_date': 'Fecha de emisión',
  'invoices.table.due_date': 'Fecha de vencimiento',
  'invoices.table.currency': 'Moneda',
  'invoices.table.total': 'Total',
  'invoices.table.created_at': 'Creada el',

  'invoices.detail.page_title': 'Detalles de la Factura',
  'invoices.detail.general_tab': 'General',
  'invoices.detail.items_tab': 'Items',
  'invoices.detail.payments_tab': 'Pagos',
  'invoices.detail.notes_tab': 'Notas',
  'invoices.detail.information': 'Información',
  'invoices.detail.identifier': 'Número de Factura',
  'invoices.detail.status': 'Estado',
  'invoices.detail.issue_date': 'Fecha de Emisión',
  'invoices.detail.due_date': 'Fecha de Vencimiento',
  'invoices.detail.total_amount': 'Monto Total',
  'invoices.detail.customer_information': 'Información del Cliente',
  'invoices.detail.invoice_details': 'Detalles de la Factura',
  'invoices.detail.financial_summary': 'Resumen Financiero',
  'invoices.detail.subtotal': 'Subtotal',
  'invoices.detail.tax_total': 'Impuestos',
  'invoices.detail.currency': 'Moneda',
  'invoices.detail.notes': 'Notas',
  'invoices.detail.no_notes': 'No hay notas disponibles',
  'invoices.detail.phone': 'Teléfono',
  'invoices.detail.created_at': 'Creado',
  'invoices.detail.updated_at': 'Actualizado',
  'invoices.detail.not_found_title': 'Factura no encontrada',
  'invoices.detail.not_found_description':
    'La factura que busca no existe o no tiene acceso a ella',
  'invoices.detail.back_button': 'Volver a facturas',

  'invoices.items.title': 'Items de la Factura',
  'invoices.items.description': 'Descripción',
  'invoices.items.quantity': 'Cantidad',
  'invoices.items.unit_price': 'Precio Unitario',
  'invoices.items.tax_rate': 'Tasa de Impuesto',
  'invoices.items.line_total': 'Total Línea',
  'invoices.items.actions': 'Acciones',
  'invoices.items.edit_item': 'Editar Item',
  'invoices.items.delete_item': 'Eliminar Item',
  'invoices.items.create_item': 'Crear Item',
  'invoices.items.update_item': 'Actualizar Item',
  'invoices.items.create_item_form': 'Crear Item de Factura',
  'invoices.items.update_item_form': 'Actualizar Item de Factura',
  'invoices.items.delete_confirmation_title': 'Eliminar Item',
  'invoices.items.delete_confirmation_description':
    '¿Está seguro que desea eliminar este item? Esta acción no se puede deshacer.',
  'invoices.items.description_required': 'La descripción es requerida',
  'invoices.items.quantity_required': 'La cantidad es requerida',
  'invoices.items.quantity_positive': 'La cantidad debe ser positiva',
  'invoices.items.quantity_min': 'La cantidad debe ser al menos 0.01',
  'invoices.items.unit_price_required': 'El precio unitario es requerido',
  'invoices.items.unit_price_min': 'El precio unitario debe ser al menos 0',
  'invoices.items.tax_rate_min': 'La tasa de impuesto debe ser al menos 0',
  'invoices.items.tax_rate_max': 'La tasa de impuesto no puede exceder 100',
  'invoices.items.create_success': 'Item creado exitosamente',
  'invoices.items.create_error': 'Error al crear el item',
  'invoices.items.update_success': 'Item actualizado exitosamente',
  'invoices.items.update_error': 'Error al actualizar el item',
  'invoices.items.delete_success': 'Item eliminado exitosamente',
  'invoices.items.delete_error': 'Error al eliminar el item',

  'invoices.payments.title': 'Historial de Pagos',
  'invoices.payments.payment_date': 'Fecha de Pago',
  'invoices.payments.amount': 'Monto',
  'invoices.payments.method': 'Método de Pago',
  'invoices.payments.reference': 'Referencia',
  'invoices.payments.total_paid': 'Total Pagado',
  'invoices.payments.balance': 'Saldo',
  'invoices.payments.add_payment': 'Agregar Pago',
  'invoices.payments.actions': 'Acciones',
  'invoices.payments.create_payment': 'Crear Pago',
  'invoices.payments.edit_payment': 'Editar Pago',
  'invoices.payments.delete_payment': 'Eliminar Pago',
  'invoices.payments.create_payment_form': 'Nuevo Pago',
  'invoices.payments.update_payment_form': 'Editar Pago',
  'invoices.payments.update_payment': 'Actualizar Pago',
  'invoices.payments.delete_confirmation_title': 'Eliminar Pago',
  'invoices.payments.delete_confirmation_description':
    '¿Está seguro que desea eliminar este pago? Esta acción no se puede deshacer.',
  'invoices.payments.amount_required': 'El monto es requerido',
  'invoices.payments.amount_positive': 'El monto debe ser positivo',
  'invoices.payments.amount_min': 'El monto debe ser al menos 0.01',
  'invoices.payments.payment_date_required': 'La fecha de pago es requerida',
  'invoices.payments.create_success': 'Pago creado exitosamente',
  'invoices.payments.create_error': 'Error al crear el pago',
  'invoices.payments.update_success': 'Pago actualizado exitosamente',
  'invoices.payments.update_error': 'Error al actualizar el pago',
  'invoices.payments.delete_success': 'Pago eliminado exitosamente',
  'invoices.payments.delete_error': 'Error al eliminar el pago',

  'invoices.notes.placeholder': 'Ingresa notas aquí...',
  'invoices.notes.no_notes': 'Sin notas',
  'invoices.notes.save': 'Guardar',
  'invoices.notes.cancel': 'Cancelar',
  'invoices.notes.updated': 'Notas actualizadas exitosamente',
  'invoices.notes.error': 'Error al actualizar las notas',

  'invoices.create.button': 'Crear Factura',
  'invoices.create.dialog_title': 'Crear Nueva Factura',
  'invoices.create.customer': 'Cliente',
  'invoices.create.customer_required': 'El cliente es requerido',
  'invoices.create.identifier': 'Número de Factura',
  'invoices.create.identifier_required': 'El número de factura es requerido',
  'invoices.create.identifier_max':
    'El número de factura debe tener menos de 255 caracteres',
  'invoices.create.status': 'Estado',
  'invoices.create.status_required': 'El estado es requerido',
  'invoices.create.currency': 'Moneda',
  'invoices.create.currency_required': 'La moneda es requerida',
  'invoices.create.currency_format':
    'La moneda debe tener 3 caracteres (ej: USD)',
  'invoices.create.issue_date': 'Fecha de Emisión',
  'invoices.create.due_date': 'Fecha de Vencimiento',
  'invoices.create.due_date_after_issue':
    'La fecha de vencimiento debe ser posterior a la fecha de emisión',
  'invoices.create.notes': 'Notas',
  'invoices.create.notes_max': 'Las notas deben tener menos de 5000 caracteres',
  'invoices.create.submit': 'Crear Factura',
  'invoices.create.success': 'Factura creada exitosamente',
  'invoices.create.error': 'Error al crear la factura',

  'invoices.update.submit': 'Actualizar Factura',
  'invoices.update.success': 'Factura actualizada exitosamente',
  'invoices.update.error': 'Error al actualizar la factura',

  'invoices.delete.title': 'Eliminar Factura',
  'invoices.delete.confirmation':
    '¿Está seguro de que desea eliminar esta factura? Esta acción no se puede deshacer y también eliminará todos los artículos y pagos asociados.',
  'invoices.delete.success': 'Factura eliminada exitosamente',
  'invoices.delete.error': 'Error al eliminar la factura',

  'invoices.table.actions': 'Acciones',
  'invoices.table.view_invoice': 'Ver Factura',
  'invoices.table.edit_invoice': 'Editar Factura',
  'invoices.table.delete_invoice': 'Eliminar Factura',

  'invoices.status.draft': 'Borrador',
  'invoices.status.final': 'Finalizada',
  'invoices.status.paid': 'Pagada',
  'invoices.status.overdue': 'Vencida',
  'invoices.status.cancelled': 'Cancelada',

  // Series de Facturas
  'invoice_series.title': 'Series de Facturas',
  'invoice_series.description':
    'Administre las series de facturas (lotes) para la numeración secuencial de facturas en su workspace.',
  'invoice_series.create_button': 'Crear Serie',
  'invoice_series.error_loading': 'Error al cargar las series de facturas.',
  'invoice_series.table.name': 'Nombre',
  'invoice_series.table.prefix': 'Prefijo',
  'invoice_series.table.current_number': 'Número Actual',
  'invoice_series.table.next_number': 'Próximo Número',
  'invoice_series.table.status': 'Estado',
  'invoice_series.table.active': 'Activa',
  'invoice_series.table.inactive': 'Inactiva',
  'invoice_series.table.created_at': 'Fecha de Creación',
  'invoice_series.table.actions': 'Acciones',
  'invoice_series.form.title_create': 'Crear Serie de Facturas',
  'invoice_series.form.title_edit': 'Editar Serie de Facturas',
  'invoice_series.form.name': 'Nombre de la Serie',
  'invoice_series.form.name_required': 'El nombre es obligatorio',
  'invoice_series.form.name_helper':
    'Un nombre descriptivo para esta serie (ej. "Serie Principal", "Facturas de Exportación")',
  'invoice_series.form.prefix': 'Prefijo',
  'invoice_series.form.prefix_required': 'El prefijo es obligatorio',
  'invoice_series.form.prefix_helper':
    'Prefijo corto para los números de factura (ej. "FAC", "A", "EXP"). Máximo 10 caracteres.',
  'invoice_series.form.is_active': 'Activa',
  'invoice_series.form.is_active_helper':
    'Solo las series activas pueden usarse para nuevas facturas',
  'invoice_series.form.submit_create': 'Crear Serie',
  'invoice_series.form.submit_edit': 'Guardar Cambios',
  'invoice_series.create.success': 'Serie de facturas creada exitosamente',
  'invoice_series.create.error': 'Error al crear la serie de facturas',
  'invoice_series.update.success': 'Serie de facturas actualizada exitosamente',
  'invoice_series.update.error': 'Error al actualizar la serie de facturas',
  'invoice_seriesItem.delete.title.confirmation': 'Eliminar Serie de Facturas',
  'invoice_seriesItem.delete.confirmation':
    '¿Está seguro que desea eliminar esta serie de facturas? Esta acción no se puede deshacer.',
  'invoice_series.delete.success': 'Serie de facturas eliminada exitosamente',
  'invoice_series.delete.error': 'Error al eliminar la serie de facturas',
  'invoice_series.status.active': 'Activo',
  'invoice_series.status.inactive': 'Inactivo',

  // Errores de Facturación
  'billingErrors.INVOICE_NOT_EDITABLE_AFTER_FINALIZATION':
    'Esta factura ha sido finalizada y no puede ser editada. Solo las notas y pagos pueden ser modificados.',
  'billingErrors.CANNOT_ADD_ITEMS_TO_FINALIZED_INVOICE':
    'No se pueden agregar items a una factura finalizada. Solo las facturas en borrador pueden ser modificadas.',
  'billingErrors.CANNOT_MODIFY_ITEMS_ON_FINALIZED_INVOICE':
    'No se pueden modificar items en una factura finalizada. Solo las facturas en borrador pueden ser editadas.',
  'billingErrors.CANNOT_DELETE_ITEMS_FROM_FINALIZED_INVOICE':
    'No se pueden eliminar items de una factura finalizada. Solo las facturas en borrador pueden ser modificadas.',
  'billingErrors.INVALID_INVOICE_STATUS_TRANSITION':
    'Cambio de estado inválido. Por favor verifique las transiciones de estado permitidas.',
  'billingErrors.ONLY_DRAFT_INVOICES_CAN_BE_FINALIZED':
    'Solo las facturas en borrador pueden ser finalizadas.',
  'billingErrors.CANNOT_FINALIZE_INVOICE_WITHOUT_ITEMS':
    'No se puede finalizar una factura sin items. Por favor agregue al menos un item.',
  'billingErrors.CANNOT_DELETE_NON_DRAFT_INVOICE':
    'Solo las facturas en borrador pueden ser eliminadas. Las facturas finalizadas deben ser canceladas.',
  'billingErrors.SERVICE_PERIOD_REQUIRED_FOR_SUBSCRIPTION_ITEMS':
    'Las fechas del período de servicio son requeridas para items de factura vinculados a suscripciones.',
  'billingErrors.INVALID_STATUS_TRANSITION':
    'Cambio de estado inválido para esta suscripción.',
  'billingErrors.CANNOT_CANCEL_FINISHED_SUBSCRIPTION':
    'No se puede cancelar una suscripción que ya ha finalizado.',
  'billingErrors.CANNOT_ACTIVATE_CANCELLED_SUBSCRIPTION':
    'No se puede reactivar una suscripción cancelada.',
  'billingErrors.INVOICE_SERIES_NOT_FOUND': 'Serie de factura no encontrada.',
  'billingErrors.INVOICE_SERIES_PREFIX_ALREADY_EXISTS':
    'Ya existe una serie de factura con este prefijo en este workspace.',
  'billingErrors.INVOICE_SERIES_IN_USE':
    'No se puede eliminar esta serie de factura ya que está siendo utilizada por facturas existentes.',
  'billingErrors.INVOICE_SERIES_WORKSPACE_MISMATCH':
    'La serie de factura seleccionada no pertenece a este workspace.',
  'billingErrors.NO_ACTIVE_INVOICE_SERIES_FOUND':
    'No se encontró ninguna serie de factura activa para este workspace. Por favor cree una primero.',
  'billingErrors.CANNOT_DELETE_SERIES_IN_USE':
    'No se puede eliminar esta serie de factura ya que está siendo utilizada por facturas existentes.',
  'billingErrors.CANNOT_MODIFY_CURRENT_NUMBER_DIRECTLY':
    'El número actual no puede ser modificado directamente. Es gestionado automáticamente por el sistema.',
  'billingErrors.INVOICE_NOT_FOUND': 'Factura no encontrada.',
  'billingErrors.INVOICE_ITEM_NOT_FOUND': 'Item de factura no encontrado.',
  'billingErrors.INVOICE_PAYMENT_NOT_FOUND': 'Pago de factura no encontrado.',
  'billingErrors.SUBSCRIPTION_NOT_FOUND': 'Suscripción no encontrada.',
  'billingErrors.SUBSCRIPTION_ITEM_NOT_FOUND':
    'Item de suscripción no encontrado.',
  'billingErrors.CANNOT_DELETE_BILLED_SUBSCRIPTION_ITEM':
    'No se puede eliminar este item de suscripción porque ya ha sido facturado.',
  'billingErrors.CANNOT_DELETE_BILLED_SUBSCRIPTION':
    'No se puede eliminar esta suscripción porque tiene items que ya han sido facturados.',
  'billingErrors.CUSTOMER_NOT_FOUND_IN_WORKSPACE':
    'Cliente no encontrado en este workspace.',
  'billingErrors.DEVICE_NOT_FOUND': 'Dispositivo no encontrado.',
  'billingErrors.DEVICE_HAS_NO_CUSTOMER':
    'El dispositivo no tiene un cliente asociado.',
  'billingErrors.PLAN_NOT_FOUND': 'Plan no encontrado.',
  'billingErrors.ITEM_NOT_FOUND': 'Item no encontrado.',
  'billingErrors.AUTHORIZATION_ERROR':
    'No tiene permiso para realizar esta acción.',
  'billingErrors.ITEM_IN_USE_BY_INVOICE':
    'No se puede eliminar este item ya que está siendo utilizado en una o más facturas.',
  'billingErrors.ITEM_IN_USE_BY_PLAN':
    'No se puede eliminar este item ya que está siendo utilizado en uno o más planes.',
  'billingErrors.ITEM_IN_USE_BY_SUBSCRIPTION':
    'No se puede eliminar este item ya que está siendo utilizado en una o más suscripciones.',
  'billingErrors.UNKNOWN_ERROR': 'Ha ocurrido un error desconocido.',
  'billingErrors.DUPLICATE_KEY':
    'Este valor ya existe. Por favor utilice un valor diferente.',
  'billingErrors.FOREIGN_KEY_CONSTRAINT':
    'No se puede realizar esta acción debido a registros relacionados existentes.',
  'billingErrors.NOT_NULL_CONSTRAINT':
    'Falta un campo requerido. Por favor complete todos los campos obligatorios.',
  'billingErrors.GENERIC_ERROR':
    'Ha ocurrido un error. Por favor intente nuevamente.',

  'payment_method.label': 'Método de pago',
  'payment_method.add_new': 'Agregar nuevo',
  'payment_method.create_title': 'Crear método de pago',
  'payment_method.name': 'Nombre del método',
  'payment_method.created_success': 'Método de pago creado exitosamente',
  'payment_method.create_error': 'Error al crear el método de pago',
  'payment_method.search_error': 'Error al cargar los métodos de pago',

  'kanban.task_completed_text': 'Completada',
  'kanban.task_not_completed_text': 'No completada',

  'kanban.column_created_success': 'Columna creada exitosamente',
  'kanban.column_created_error': 'Error al crear columna',
  'kanban.column_name_placeholder': 'Nombre de la columna',
  'kanban.column_create_helper_text': 'Ingresa el nombre de la columna',
  'kanban.add_column_text': 'Nueva columna',

  'kanban.delete_column_title': 'Eliminar columna',
  'kanban.delete_column_description': '¿Desea eliminar la columna?',
  'kanban.more_options.edit': 'Editar',
  'kanban.more_options.delete': 'Eliminar',

  'kanban.column_update_success': 'Columna actualizada',
  'kanban.column_update_error': 'Error al actualizar columna',
  'kanban.column_delete_success': 'Columna eliminada',
  'kanban.column_delete_error': 'Error al eliminar la columna',

  'kanban.task_created_success': 'Tarea creada exitosamente',
  'kanban.task_created_error': 'Error al crear tarea',
  'service_order.create': 'Crear orden de servicio',

  'kanban.contacts_title': 'Usuarios',
  'kanban.contacts_search_placeholder': 'Buscar...',
  'kanban.contacts_select_button': 'Agregar',

  'kanban.delete_task_title': 'Borrar tarea',
  'kanban.delete_task_description': '¿Desea eliminar la tarea?',
  'kanban.task_delete_tooltip': 'Eliminar',

  'kanban_comment.comment_placeholder': 'Escribe un comentario...',
  'kanban_comment.comment_submit_text': 'Comentar',
  'kanban_comment.submit_error':
    'Error al enviar el comentario. Intenta de nuevo.',

  'service_order_form.submit_text': 'Actualizar',
  'service_order_form.name_label': 'Título',
  'service_order_form.name_placeholder': 'Título de la orden',
  'service_order_form.lead_technician_label': 'Técnico principal',
  'service_order_form.technicians_label': 'Técnicos',
  'service_order_form.add_technician_tooltip': 'Agregar técnicos',
  'service_order_form.scheduledAt_label': 'Fecha programada',
  'service_order_form.priority_label': 'Prioridad',
  'service_order_form.description_label': 'Descripción',
  'service_order_form.description.placeholder': 'Descripción de la tarea...',
  'service_order_form.device_label': 'Dispositivo',
  'service_order.device_placeholder': 'Selecciona un dispositivo',
  'service_order_form.completed_check_label': 'Completada',
  'service_order.completed_tooltip': 'Marcar orden como completada',
  'service_order.add_text': 'Crear',
  'service_order.priority_low': 'Baja',
  'service_order.priority_medium': 'Media',
  'service_order.priority_high': 'Alta',
  'service_order.status_required_error_message':
    'El estado de la orden de servicio es requerido',
  'service_orders.dialog_title': 'Ordenes de servicio',
  'service_orders.dialog_description':
    'Gestiona las ordenes de servicio de este dispositivo.',
  'service_order_form.name_required': 'El título es requerido',
  'service_order_form.device_required': 'Seleccione un dispositivo',
  'service_order_form.status_label': 'Estado',
  'service_order.status_placeholder': 'Selecciona un estado',

  // Service Orders Table
  'service_orders.view_table': 'Tabla',
  'service_orders.view_kanban': 'Kanban',
  'service_orders.create_button': 'Nueva Orden de Servicio',
  'service_orders.edit_dialog_title': 'Editar Orden de Servicio',
  'service_orders.delete_confirm':
    '¿Está seguro de que desea eliminar esta orden de servicio?',
  'service_orders.delete_success': 'Orden de servicio eliminada',
  'service_orders.delete_error': 'Error al eliminar la orden de servicio',
  'service_orders.completed': 'Completada',
  'service_orders.pending': 'Pendiente',
  'service_orders.status.unknown': 'Desconocido',
  'service_orders.table.title': 'Título',
  'service_orders.table.device': 'Dispositivo',
  'service_orders.table.status': 'Estado',
  'service_orders.table.lead_technician': 'Técnico Principal',
  'service_orders.table.technicians': 'Técnicos',
  'service_orders.table.priority': 'Prioridad',
  'service_orders.table.scheduled_at': 'Programado',
  'service_orders.table.created_at': 'Creado',
  'service_orders.table.completed': 'Completada',
  'service_orders.table.actions': 'Acciones',

  // Service Order MoreMenuButton translations
  'serviceOrderItem.delete.title.confirmation': 'Eliminar Orden de Servicio',
  'serviceOrderItem.delete.confirmation':
    '¿Está seguro que desea eliminar esta orden de servicio? Esta acción no se puede deshacer.',
  'table.more_options.edit.serviceOrder': 'Editar orden de servicio',
  'table.more_options.delete.serviceOrder': 'Eliminar orden de servicio',

  'kanban.delete_task_title': 'Eliminar tarea',
  'kanban.delete_task_description': '¿Está seguro de eliminar la tarea?',
  'kanban.task_delete_tooltip': 'Eliminar',

  'kanban.update_task_success_message': 'Tarea actualizada exitosamente',
  'kanban.update_task_error_message': 'Error al actualizar la tarea',

  'kanban_details.overview_tab_title': 'Detalles',
  'kanban_details.subtasks_tab_title': 'Subtareas',
  'kanban_details.comments_tab_title {{ comments }}':
    'Comentarios ({{ comments }})',

  'kanban.update_subtask_success': 'Subtarea actualizada',
  'kanban.update_subtask_error': 'Error al actualizar la subtarea',

  'kanban.add_subtask_success': 'Subtarea agregada',
  'kanban.add_subtask_error': 'Error al crear subtarea',

  'kanban_subtask.total_count {{ count }} {{ total }}':
    '{{ count }} de {{ total }}',
  'kanban_subtask.empty_text':
    'De momento no hay subtareas, ¡prueba agregando una!',
  'kanban_subtask.add_subtask_text': 'Agregar',
  'kanban_subtask.add_subtask_description_placeholder':
    'Introduce una descripción',

  'kanban.column_updated_error': 'Error al actualizar la columna',
  'kanban.task_updated_error': 'Error al actualizar la tarea',
  'kanban.task_delete_success': 'Tarea eliminada exitosamente',

  'kanban.error_title': 'No hay columnas existentes',
  'kanban.toggle_completed__text': 'Mostrar completadas',

  'kanban.comment_created': 'Ha creado una orden de servicio',
  'kanban.task_assigned {{ userId }} {{ technicians }}':
    'Ha agregado a como técnico a {{ userId }} {{ technicians }}',
  'kanban.task_scheduled': 'Ha agregado una fecha de ejecución',
  'kanban.status_changed {{ statusId }}': 'Ha movido la tarea a {{ statusId }}',
  'kanban.task_finished': 'Ha marcado como completada esta tarea',
  'kanban.task_unfinished': 'Ha marcado como no completada esta tarea',
  'kanban.unknown_type': 'Desconocido',

  // PERMISSIONS TRANSLATIONS
  treinco_permissions_account: 'Cuenta',
  'treinco_permissions_account.view': 'Ver cuentas',
  treinco_permissions_system: 'Sistema',

  treinco_permissions_action_group: 'Grupo de Acción',
  'treinco_permissions_action_group.create': 'Crear',
  'treinco_permissions_action_group.update': 'Actualizar',
  'treinco_permissions_action_group.delete': 'Eliminar',
  'treinco_permissions_action_group.view': 'Ver',
  treinco_permissions_invoice: 'Facturas',
  'treinco_permissions_invoice.create': 'Crear',
  'treinco_permissions_invoice.update': 'Actualizar',
  'treinco_permissions_invoice.delete': 'Eliminar',
  'treinco_permissions_invoice.view': 'Ver',
  'treinco_permissions_invoice.read': 'Leer',
  treinco_permissions_subscription: 'Suscripciones',
  'treinco_permissions_subscription.create': 'Crear',
  'treinco_permissions_subscription.update': 'Actualizar',
  'treinco_permissions_subscription.delete': 'Eliminar',
  'treinco_permissions_subscription.view': 'Ver',
  treinco_permissions_plan: 'Planes',
  'treinco_permissions_plan.create': 'Crear',
  'treinco_permissions_plan.update': 'Actualizar',
  'treinco_permissions_plan.delete': 'Eliminar',
  'treinco_permissions_plan.view': 'Ver',
  treinco_permissions_item: 'Artículos',
  'treinco_permissions_item.create': 'Crear',
  'treinco_permissions_item.update': 'Actualizar',
  'treinco_permissions_item.delete': 'Eliminar',
  'treinco_permissions_item.view': 'Ver',
  treinco_permissions_brand: 'Marca',
  'treinco_permissions_brand.create': 'Crear',
  'treinco_permissions_brand.update': 'Actualizar',
  'treinco_permissions_brand.delete': 'Eliminar',
  'treinco_permissions_brand.view': 'Ver',
  treinco_permissions_cloud_connector: 'Conector de Nube',
  'treinco_permissions_cloud_connector.create': 'Crear Conector en la Nube',
  'treinco_permissions_cloud_connector.update':
    'Actualizar Conector en la Nube',
  'treinco_permissions_cloud_connector.delete': 'Eliminar Conector en la Nube',
  treinco_permissions_command_sent: 'Comandos Enviados',
  'treinco_permissions_command_sent.create': 'Crear',
  treinco_permissions_connector: 'Conector',
  'treinco_permissions_connector.create': 'Crear',
  'treinco_permissions_connector.update': 'Actualizar',
  'treinco_permissions_connector.delete': 'Eliminar',
  'treinco_permissions_connector.view': 'Ver',
  treinco_permissions_conversation: 'Conversación',
  'treinco_permissions_conversation.create': 'Crear',
  'treinco_permissions_conversation.update': 'Actualizar',
  'treinco_permissions_conversation.delete': 'Eliminar',
  'treinco_permissions_conversation.view': 'Ver',
  treinco_permissions_company: 'Compañía',
  'treinco_permissions_company.view': 'Ver',
  'treinco_permissions_company.create': 'Crear',
  'treinco_permissions_company.update': 'Actualizar',
  'treinco_permissions_company.delete': 'Eliminar',
  treinco_permissions_customer: 'Cliente',
  'treinco_permissions_customer.create': 'Crear',
  'treinco_permissions_customer.update': 'Actualizar',
  'treinco_permissions_customer.delete': 'Eliminar',
  'treinco_permissions_customer.view': 'Ver',
  'treinco_permissions_customer.user_management': 'Gestión de usuarios',
  treinco_permissions_device: 'Dispositivo',
  'treinco_permissions_device.create': 'Crear',
  'treinco_permissions_device.update': 'Actualizar',
  'treinco_permissions_device.delete': 'Eliminar',
  'treinco_permissions_device.view': 'Ver dispositivos',
  treinco_permissions_device_link: 'Enlace de Dispositivo',
  'treinco_permissions_device_link.view': 'Ver',
  'treinco_permissions_device_link.create': 'Crear',
  'treinco_permissions_device_link.update': 'Actualizar',
  'treinco_permissions_device_link.delete': 'Eliminar',
  'treinco_permissions_device.user_management': 'Gestión de usuarios',
  treinco_permissions_device_event: 'Evento de Dispositivo',
  'treinco_permissions_device_event.create': 'Crear',
  'treinco_permissions_device_event.update': 'Actualizar',
  'treinco_permissions_device_event.delete': 'Eliminar',
  'treinco_permissions_device_event.view': 'Ver',
  treinco_permissions_device_history: 'Historial de Dispositivo',
  'treinco_permissions_device_history.create': 'Crear',
  'treinco_permissions_device_history.update': 'Actualizar',
  'treinco_permissions_device_history.delete': 'Eliminar',
  'treinco_permissions_device_history.view': 'Ver',
  treinco_permissions_device_inactivations: 'Inactivaciones de Dispositivo',
  'treinco_permissions_device_inactivations.create': 'Crear',
  'treinco_permissions_device_inactivations.update': 'Actualizar',
  'treinco_permissions_device_inactivations.delete': 'Eliminar',
  'treinco_permissions_device_inactivations.view': 'Ver',
  treinco_permissions_device_note: 'Nota de Dispositivo',
  'treinco_permissions_device_note.create': 'Crear',
  'treinco_permissions_device_note.update': 'Actualizar',
  'treinco_permissions_device_note.delete': 'Eliminar',
  'treinco_permissions_device_note.view': 'Ver',
  treinco_permissions_device_round: 'Ronda de Dispositivo',
  'treinco_permissions_device_round.create': 'Crear',
  'treinco_permissions_device_round.update': 'Actualizar',
  'treinco_permissions_device_round.delete': 'Eliminar',
  'treinco_permissions_device_round.view': 'Ver',
  treinco_permissions_device_schedule: 'Horario de Dispositivo',
  'treinco_permissions_device_schedule.create': 'Crear',
  'treinco_permissions_device_schedule.update': 'Actualizar',
  'treinco_permissions_device_schedule.delete': 'Eliminar',
  'treinco_permissions_device_schedule.view': 'Ver',
  treinco_permissions_device_user: 'Usuario de Dispositivo',
  'treinco_permissions_device_user.create': 'Crear',
  'treinco_permissions_device_user.update': 'Actualizar',
  'treinco_permissions_device_user.delete': 'Eliminar',
  'treinco_permissions_device_user.view': 'Ver',
  treinco_permissions_device_zone: 'Zona de Dispositivo',
  'treinco_permissions_device_zone.create': 'Crear',
  'treinco_permissions_device_zone.update': 'Actualizar',
  'treinco_permissions_device_zone.delete': 'Eliminar',
  'treinco_permissions_device_zone.view': 'Ver',
  treinco_permissions_emergency_contact: 'Contacto de Emergencia',
  'treinco_permissions_emergency_contact.create': 'Crear',
  'treinco_permissions_emergency_contact.update': 'Actualizar',
  'treinco_permissions_emergency_contact.delete': 'Eliminar',
  'treinco_permissions_emergency_contact.view': 'Ver',
  treinco_permissions_event: 'Evento',
  'treinco_permissions_event.create': 'Crear',
  'treinco_permissions_event.update': 'Actualizar',
  'treinco_permissions_event.delete': 'Eliminar',
  'treinco_permissions_event.view': 'Ver',
  treinco_permissions_invitation: 'Invitación',
  'treinco_permissions_invitation.create': 'Crear',
  'treinco_permissions_invitation.update': 'Actualizar',
  'treinco_permissions_invitation.delete': 'Eliminar',
  'treinco_permissions_invitation.view': 'Ver',
  treinco_permissions_model: 'Modelo',
  'treinco_permissions_model.create': 'Crear',
  'treinco_permissions_model.update': 'Actualizar',
  'treinco_permissions_model.delete': 'Eliminar',
  'treinco_permissions_model.view': 'Ver',
  treinco_permissions_monitoring_resolution: 'Resolución de Monitoreo',
  'treinco_permissions_monitoring_resolution.create': 'Crear',
  'treinco_permissions_monitoring_resolution.update': 'Actualizar',
  'treinco_permissions_monitoring_resolution.delete': 'Eliminar',
  'treinco_permissions_monitoring_resolution.view': 'Ver',
  treinco_permissions_place: 'Lugar',
  'treinco_permissions_place.create': 'Crear',
  'treinco_permissions_place.update': 'Actualizar',
  'treinco_permissions_place.delete': 'Eliminar',
  'treinco_permissions_place.view': 'Ver',
  treinco_permissions_role: 'Rol',
  'treinco_permissions_role.create': 'Crear',
  'treinco_permissions_role.update': 'Actualizar',
  'treinco_permissions_role.delete': 'Eliminar',
  'treinco_permissions_role.view': 'Ver',
  treinco_permissions_service_order: 'Orden de Servicio',
  'treinco_permissions_service_order.create': 'Crear',
  'treinco_permissions_service_order.update': 'Actualizar',
  'treinco_permissions_service_order.delete': 'Eliminar',
  'treinco_permissions_service_order.view': 'Ver',
  treinco_permissions_timer: 'Temporizador',
  'treinco_permissions_timer.create': 'Crear',
  'treinco_permissions_timer.update': 'Actualizar',
  'treinco_permissions_timer.delete': 'Eliminar',
  'treinco_permissions_timer.view': 'Ver',
  treinco_permissions_user: 'Usuario',
  'treinco_permissions_user.create': 'Crear',
  'treinco_permissions_user.update': 'Actualizar',
  'treinco_permissions_user.delete': 'Eliminar',
  'treinco_permissions_user.view': 'Ver',
  treinco_permissions_user_role: 'Rol de Usuario',
  'treinco_permissions_user_role.create': 'Crear usuario',
  'treinco_permissions_user_role.update': 'Actualizar',
  'treinco_permissions_user_role.delete': 'Eliminar usuario',
  'treinco_permissions_user_role.view': 'Ver usuario',
  treinco_permissions_workspace: 'Espacio de Trabajo',
  'treinco_permissions_workspace.create': 'Crear',
  'treinco_permissions_workspace.update': 'Actualizar',
  'treinco_permissions_workspace.delete': 'Eliminar',
  'treinco_permissions_workspace.view': 'Ver',
  treinco_permissions_workspace_shared_access:
    'Acceso Compartido de Espacio de Trabajo',
  'treinco_permissions_workspace_shared_access.create': 'Crear',
  'treinco_permissions_workspace_shared_access.manage': 'Gestionar',
  'treinco_permissions_workspace_shared_access.view': 'Ver',
  'treinco_permissions_workspace_shared_access.delete': 'Eliminar',
  treinco_permissions_device_partition: 'Partición de Dispositivo',
  'treinco_permissions_device_partition.create': 'Crear',
  'treinco_permissions_device_partition.update': 'Actualizar',
  'treinco_permissions_device_partition.delete': 'Eliminar',
  'treinco_permissions_device_partition.view': 'Ver',
  treinco_permissions_geofence: 'Geocerca',
  'treinco_permissions_geofence.create': 'Crear',
  'treinco_permissions_geofence.update': 'Actualizar',
  'treinco_permissions_geofence.delete': 'Eliminar',
  'treinco_permissions_geofence.view': 'Ver',
  treinco_permissions_monitoring: 'Monitoreo',
  'treinco_permissions_monitoring.create': 'Crear',
  'treinco_permissions_monitoring.update': 'Actualizar',
  'treinco_permissions_monitoring.delete': 'Eliminar',
  'treinco_permissions_monitoring.view': 'Ver',
  treinco_permissions_event_group: 'Grupo de Eventos',
  'treinco_permissions_event_group.create': 'Crear',
  'treinco_permissions_event_group.update': 'Actualizar',
  'treinco_permissions_event_group.delete': 'Eliminar',
  'treinco_permissions_event_group.view': 'Ver',
  'treinco_permissions_attachment.create': 'Crear',
  treinco_permissions_device_cctv_channel: 'Canales de CCTV',
  'treinco_permissions_device_cctv_channel.create': 'Crear',
  'treinco_permissions_device_cctv_channel.update': 'Actualizar',
  'treinco_permissions_device_cctv_channel.delete': 'Eliminar',
  'treinco_permissions_device_cctv_channel.view': 'Ver',

  'userItem.addRole': 'Agregar rol',
  'general.phonenumbers.button.show_more': 'más',
  'general.phonenumbers.button.show_less': 'Mostrar menos',

  'create_channel.title': 'Crear Canal',
  'update_channel.title': 'Actualizar Canal',
  'channel_form.create_button_text': 'Crear',
  'channel_form.update_button_text': 'Actualizar',
  'channel_form.channelNumber_label': 'ID de Canal',
  'channel_form.description_label': 'Descripción',
  'create_channel.success': 'Canal creado exitosamente',
  'update_channel.success': 'Canal actualizado exitosamente',
  'channel.delete_success': 'Canal eliminado exitosamente',
  'channel.delete_error_associated_with_round':
    'No se puede eliminar el canal: su punto asociado está siendo usado en una ronda.',
  'channel.delete_error': 'Ocurrió un error al eliminar el canal.',
  'cctv.check_plugin': 'Verificar plugin',
  // partition

  'partitionSelector.title': 'Selecciona una partición',
  'partition.search': 'Buscar',
  'partitionSelector.noPartitions.subtitle': 'Sin particiones',
  'partitionSelector.button.add': 'Agregar partición',
  'devicePartition.error.identifier.already.exist': 'Partición ya existente',
  'devicePartition.general.error': 'Error al crear una partición',
  'devicePartition.user.partition.removed': 'La partición ha sido eliminada',
  'createPartition.form.identifier': 'Identificador',
  'createPartition.form.name': 'Nombre',
  'createPartition.button.edit': 'Editar',
  'createPartition.button.add': 'Crear',
  'createPartition.button.delete': 'Eliminar',
  'partitionSelector.delete.title.confirmation':
    '¿Está seguro de eliminar esta partición?',
  'partitionSelector.delete.subtitle.confirmation':
    'Esta acción no puede deshacerse',
  'partition.status': 'Estado',
  'partition.actions': 'Acciones',
  'partitions.create.success_message': 'Partición creada exitosamente',
  'partitions.update.success_message': 'Partición actualizada exitosamente',
  'partitions.disarmed': 'Desarmado',
  'partitions.armed': 'Armado',

  // attachment
  'fetchAttachments.error': 'Error al obtener los adjuntos.',
  'attachments.title': 'Adjuntos',
  'attachments.empty_message': 'No se encontraron adjuntos.',
  'attachments.error_message': 'Error al cargar los adjuntos.',
  'attachments.upload_error_message': 'Error al subir el adjunto.',
  'attachments.delete_success_message': 'Adjunto eliminado exitosamente.',
  'attachments.delete_error_message': 'Error al eliminar el adjunto.',
  'attachments.view_error_message':
    'No se pudo abrir el adjunto. Puede que falte la URL.',
  'common.actions.view': 'Ver',
  'common.actions.download': 'Descargar',
  'common.actions.delete': 'Eliminar',
  'attachments.delete_confirm_message':
    '¿Estás seguro de que quieres eliminar este adjunto?',
  'table.more_options.download_view': 'Ver / Descargar',
  'attachmentsTable.error_graphql_create':
    'Error al crear el registro del adjunto.',
  'attachmentsTable.error_getting_upload_url':
    'No se pudo obtener la URL de subida.',
  'createAttachmentForm.success_single': 'Adjunto subido exitosamente.',
  'createAttachmentForm.error_submit':
    'Error al enviar el adjunto. Por favor, inténtalo de nuevo.',
  'createAttachmentForm.title_single': 'Subir Nuevo Adjunto',
  'attachmentsTable.title': 'Adjuntos',
  'attachmentsTable.add_button': 'Agregar Adjunto',
  'attachments_table.filename_field': 'Nombre del archivo',
  'attachments_table.created_at_field': 'Creado el',
  'attachments_table.actions_field': 'Acciones',
  'createAttachmentForm.error_no_file_selected':
    'Por favor, selecciona un archivo para subir.',
  'common.cancel': 'Cancelar',
  'createAttachmentForm.uploading_button': 'Subiendo...',
  'createAttachmentForm.upload_button': 'Subir',
  'createAttachmentForm.error_forbidden_type':
    'Tipo de archivo no permitido para {{fileName}}.',
  'createAttachmentForm.error_remove_existing':
    'Por favor elimine el archivo existente para poder subir uno nuevo.',
  'createAttachmentForm.file_selected_title': 'Archivo seleccionado',
  'createAttachmentForm.drop_zone_title_single': 'Arrastra un archivo aquí',
  'createAttachmentForm.drop_zone_text_single': 'o ',
  'createAttachmentForm.browse_link': 'explorar',
  'createAttachmentForm.file_to_upload': 'Archivo a subir',
  'attachments_table.file_type_field': 'Tipo de archivo',
  'createAttachmentForm.error_size_limit':
    'El archivo {{fileName}} excede el tamaño máximo permitido de {{maxSize}}.',
  'deviceSettings.validation.installerMaxLength':
    'El nombre del instalador debe tener como máximo 100 caracteres.',
  // Device general settings
  'deviceSettings.success.update':
    'Configuracion del dispositivo actualizada correctamente',
  'deviceSettings.error.update_failed':
    'Error actualizando la configuracion del dispositivo',
  'deviceSettings.loading': 'Cargando...',
  'deviceSettings.tooltip.edit': 'Editar',
  'deviceSettings.form.key': 'Clave',
  'deviceSettings.form.secretKey': 'Clave secreta',
  'deviceSettings.form.craSecretKey': 'Clave secreta CRA',
  'deviceSettings.form.duressCode': 'Clave de coacción',
  'deviceSettings.tooltip.secretKey':
    'Clave que el usuario escribe en la app para confirmar que la alarma fue falsa. Cierra el evento automáticamente.',
  'deviceSettings.tooltip.craSecretKey':
    'Clave de la central receptora (CRA). Solo se muestra al operador para verificación manual; no se usa en la verificación por chat.',
  'deviceSettings.tooltip.duressCode':
    'Clave que el usuario escribe si está bajo coacción. Parece una respuesta normal, pero marca la alarma como real y mantiene el evento abierto.',
  'deviceSettings.form.sim': 'SIM',
  'deviceSettings.form.imei': 'IMEI',
  'deviceSettings.form.deviceSerial': 'Serial del dispositivo',
  'deviceSettings.form.password': 'Contraseña del dispositivo',
  'deviceSettings.form.contactTitle': 'Datos de contacto',
  'deviceSettings.form.localPhone': 'Teléfono local',
  'deviceSettings.form.mobilePhone': 'Teléfono',
  'deviceSettings.form.email': 'Correo electrónico',
  'deviceSettings.form.contact_person': 'Persona contacto',
  'deviceSettings.form.installer': 'Instalador',
  'deviceSettings.form.submit': 'Enviar',
  'deviceSettings.form.description': 'Descripción',
  'deviceSettings.form.create_asset_brand_title': 'Crear marca del activo',
  'deviceSettings.form.create_asset_model_title': 'Crear modelo del activo',
  'deviceSettings.button.save': 'Guardar',
  'device_category.created_success': 'Categoría creada exitosamente',
  'device_category.create_error': 'Error al crear la categoría',
  'deviceSettings.form.device_category': 'Categoría',
  'device_category.search_error': 'Error al buscar categorías',
  'device_category.add_new': 'Agregar nueva categoría',
  'device_category.create_title': 'Crear nueva categoría',
  'device_category.description_label': 'Descripción',
  'device_category.create_button': 'Crear categoría',
  'device_category.select_label': 'Categoría',
  'deviceSettings.validation.simDigits': 'El SIM debe contener solo dígitos',
  'deviceSettings.validation.simMin': 'El SIM parece demasiado corto',
  'deviceSettings.validation.simMax': 'El SIM parece demasiado largo',
  'deviceSettings.validation.imeiDigits': 'El IMEI debe contener solo dígitos',
  'deviceSettings.validation.imeiLength': 'El IMEI debe tener 15 dígitos',
  'deviceSettings.validation.phoneCodeFormat':
    'Formato de código telefónico inválido',
  'deviceSettings.validation.phoneNumberDigits':
    'El número de teléfono debe contener solo dígitos',
  'deviceSettings.validation.emailFormat':
    'El correo electrónico debe ser una dirección válida',
  'deviceSettings.validation.keyInvalid': 'La clave no es válida',
  'deviceSettings.validation.keyMaxLength':
    'La clave no puede superar los 100 caracteres',
  'deviceSettings.validation.keysMustDiffer':
    'Las claves secreta, CRA y de coacción deben ser distintas entre sí',
  'device_profile.generals_tab_title': 'General',
  'deviceSettings.validation.phonePairRequired':
    'Se requiere el código y el número del teléfono',
  'deviceLabelsAutocomplete.label': 'Etiquetas del dispositivo',
  'deviceLabelsAutocomplete.placeholder':
    'Escribe para buscar o agregar etiquetas',
  'deviceLabelsAutocomplete.add_label': 'Agregar "{{label}}"',
  'deviceLabelsAutocomplete.create_new_label': 'Crear nueva etiqueta',
  'deviceLabelsAutocomplete.error_loading_labels':
    'Error al cargar etiquetas: {{message}}',
  'customerLabelsAutocomplete.label': 'Etiquetas del cliente',
  'customerLabelsAutocomplete.placeholder':
    'Escribe para buscar o agregar etiquetas',
  'customerLabelsAutocomplete.add_label': 'Agregar "{{label}}"',
  'customerLabelsAutocomplete.create_new_label': 'Crear nueva etiqueta',
  'customerLabelsAutocomplete.error_loading_labels':
    'Error al cargar etiquetas: {{message}}',
  'createDeviceLabelForm.title': 'Nombre de la etiqueta',
  'createDeviceLabelForm.color': 'Color',
  'createDeviceLabelForm.create_button': 'Crear etiqueta',
  'createDeviceLabelForm.creating': 'Creando...',
  'createDeviceLabelForm.error': 'Error creando etiqueta',
  'createDeviceLabelForm.success': 'Etiqueta creada exitosamente',
  'deviceSettings.form.device_object_data_title':
    'Datos del activo del dispositivo',
  'deviceSettings.form.create_asset_brand_success': 'Marca creada exitosamente',
  'deviceSettings.form.create_asset_brand_error': 'Error al crear la marca',
  'deviceSettings.form.create_asset_model_success':
    'Modelo creado exitosamente',
  'deviceSettings.form.create_asset_model_error': 'Error al crear el modelo',
  'deviceSettings.form.delete_asset_brand_success':
    'Marca eliminada exitosamente',
  'deviceSettings.form.delete_asset_brand_error': 'Error al eliminar la marca',
  'deviceSettings.form.delete_asset_model_success':
    'Modelo eliminado exitosamente',
  'deviceSettings.form.delete_asset_model_error': 'Error al eliminar el modelo',
  'deviceSettings.form.device_asset_brand_label': 'Marca',
  'deviceSettings.form.device_asset_model_label': 'Modelo',

  'common.actions': 'Acciones',

  'createCustomerLabelForm.name': 'Nombre de la etiqueta',
  'createCustomerLabelForm.color': 'Color',
  'createCustomerLabelForm.error': 'Error creando etiqueta',
  'createCustomerLabelForm.success': 'Etiqueta creada exitosamente',
  'customers.generals.updateError': 'Error al actualizar los datos del cliente',
  'customers.generals.updateSuccess': 'Cliente actualizado correctamente',

  // Calendar Toolbar
  'calendar.today': 'Hoy',
  'calendar.week': 'Semana',
  'calendar.day': 'Día',
  'calendar.agenda': 'Agenda',
  'calendar.month': 'Mes',

  'calendar.move.error':
    'No se pudo mover el evento, editar la configuración de recurrencia.',

  'users.category_field_text': 'Categoría',
  'device_user_category.select_label': 'Seleccionar categoría',
  'device_user_category.created_success': 'Categoría creada exitosamente',
  'device_user_category.create_error': 'Error al crear la categoría',
  'device_user_category.add_new': 'Agregar nueva categoría',
  'device_user_category.create_title': 'Crear nueva categoría',
  'device_user_category.description_label': 'Descripción de la categoría',
  'device_user_category.create_button': 'Crear categoría',

  // event inactivity
  'event_inactivity_form.title_text': 'Notificación de inactividad por evento',
  'event_inactivity_form.unit_minutes': 'Minutos',
  'event_inactivity_form.unit_hours': 'Horas',
  'event_inactivity_form.interval_label': 'Intervalo',
  'event_inactivity_form.last_activity_label': 'Última actividad',
  'event_inactivity_form.submit_text': 'Guardar',
  'event_inactivity_form.remove_text': 'Eliminar',
  'event_inactivity_form.unit_required': 'La unidad es requerida',
  'event_inactivity_form.interval_required': 'El intervalo es requerido',
  'event_inactivity_form.interval_min_error':
    'El intervalo debe ser al menos 1',
  'device_quick_actions.event_inactivity_text': 'Inactividad del sistema',
  // position inactivity
  'position_inactivity_form.title_text':
    'Notificación de inactividad por posición',
  'position_inactivity_form.unit_minutes': 'Minutos',
  'position_inactivity_form.unit_hours': 'Horas',
  'position_inactivity_form.interval_label': 'Intervalo',
  'position_inactivity_form.last_activity_label': 'Última actividad',
  'position_inactivity_form.submit_text': 'Guardar',
  'position_inactivity_form.remove_text': 'Eliminar',
  'position_inactivity_form.unit_required': 'La unidad es requerida',
  'position_inactivity_form.interval_required': 'El intervalo es requerido',
  'position_inactivity_form.interval_min_error':
    'El intervalo debe ser al menos 1',
  'device_quick_actions.position_inactivity_text': 'Inactividad de posición',
  'device_quick_actions.stop_limit_inactivity_text':
    'Limite de tiempo detenido',
  'stop_limit_inactivity_form.title_text': 'Tiempo maximo detenido',

  // stop limit
  'stop_limit_inactivity_form.title_text':
    'Notificación de tiempo máximo detenido',
  'stop_limit_inactivity_form.unit_minutes': 'Minutos',
  'stop_limit_inactivity_form.unit_hours': 'Horas',
  'stop_limit_inactivity_form.interval_label': 'Intervalo',
  'stop_limit_inactivity_form.last_activity_label': 'Última actividad',
  'stop_limit_inactivity_form.submit_text': 'Guardar',
  'stop_limit_inactivity_form.remove_text': 'Eliminar',
  'stop_limit_inactivity_form.unit_required': 'La unidad es obligatoria',
  'stop_limit_inactivity_form.interval_required': 'El intervalo es obligatorio',
  'stop_limit_inactivity_form.interval_min_error':
    'El intervalo debe ser al menos 1',
  'device_quick_actions.stop_limit_inactivity_text': 'Tiempo maximo detenido',

  // Timer validation messages
  ACTION_REQUIRED: 'La acción es requerida',
  START_DATE_REQUIRED: 'La fecha de inicio es requerida',
  END_DATE_MUST_BE_LARGER_THAN_START:
    'La fecha de fin debe ser posterior a la fecha de inicio',
  INTERVAL_REQUIRED: 'El intervalo es requerido',
  EVENT_PROTOCOL_REQUIRED: 'El protocolo del evento es requerido',
  EVENT_CODE_REQUIRED: 'El código del evento es requerido',
  'inactivity_form.create_success':
    'Evento de inactivación creado exitosamente',
  'inactivity_form.update_success':
    'Evento de inactivación actualizado exitosamente',
  'inactivity_form.delete_success':
    'Evento de inactivación eliminado exitosamente',
  'inactivity_form.error': 'Error al procesar el evento de inactivación',
  'inactivity_form.delete_error': 'Error al eliminar el evento de inactivación',

  'profile.update_user_successful': 'Usuario actualizado exitosamente',

  'inactivity_form.title_text': 'Notificación de inactividad del dispositivo',
  'inactivity_form.interval_label': 'Intervalo de notificación',
  'inactivity_form.unit_label': 'Unidad',
  'inactivity_form.unit_minutes': 'minutos',
  'inactivity_form.unit_hours': 'horas',
  'inactivity_form.last_activity_date_label': 'Fecha de última actividad',
  'inactivity_form.submit_button': 'Guardar',
  'inactivity_form.remove_button': 'Eliminar',
  'inactivity_form.interval_required':
    'El intervalo de notificación es requerido',
  'inactivity_form.interval_positive':
    'El intervalo de notificación debe ser positivo',
  'inactivity_form.interval_integer':
    'El intervalo de notificación debe ser un número entero',
  'inactivity_form.unit_required': 'La unidad es requerida',
  'inactivity_form.last_activity_date_required':
    'La fecha de última actividad es requerida',

  'device_quick_actions.send_command_text': 'Enviar comando',
  'device_quick_actions.inactivity_event_text': 'Inactividad de evento',
  'device_quick_actions.inactivity_position_text': 'Inactividad de posición',
  'device_quick_actions.speed_value_text': 'Límite de velocidad',

  'speed_limit_form.title_text': 'Notificación de velocidad máxima',
  'speed_limit_form.speed_limit_label': 'Notificación de velocidad',

  'monitoring.email_field_label': 'Correo electrónico',
  'monitoring.events_per_page': 'Eventos por página',
  'monitoring.start_date_label': 'Fecha de inicio',
  'monitoring.end_date_label': 'Fecha de fin',
  'monitoring.apply_filter_button_text': 'Aplicar filtros',
  'monitoring.reset_filter_button_text': 'Restablecer filtros',
  'monitoring.filter_options_text': 'Opciones de filtro',
  'monitoring.refresh_button_text': 'Actualizar',
  'monitoring.event_details_title': 'Detalles del Evento',
  'monitoring.event_details_id_label': 'ID del Evento',
  'monitoring.event_details_device_label': 'Dispositivo',
  'monitoring.event_details_event_label': 'Evento',
  'monitoring.event_details_generated_label': 'Generado el',
  'monitoring.event_details_received_label': 'Recibido el',
  'monitoring.event_details_status_label': 'Estado',
  'monitoring.event_details_processed_by_label': 'Procesado por',
  'monitoring.event_details_processed_at_label': 'Procesado el',
  'monitoring.event_details_notes_label': 'Notas',
  'monitoring.event_details_actions_label': 'Acciones',
  'monitoring.event_details_type_label': 'Tipo',
  'monitoring.event_details_priority_label': 'Prioridad',
  'monitoring.event_details_is_monitorable_label': 'Es monitoreable',
  'monitoring.event_details_event_group_label': 'Grupo de eventos',
  'monitoring.event_details_created_at_label': 'Creado el',
  'monitoring.event_details_updated_at_label': 'Actualizado el',
  'monitoring.event_details_raw_data_label': 'Datos brutos',
  'monitoring.event_details_raw_data_copy_button': 'Copiar datos brutos',
  'monitoring.event_details_raw_data_copied':
    '¡Datos brutos copiados al portapapeles!',

  // Timer validation messages
  ACTION_REQUIRED: 'La acción es requerida',
  START_DATE_REQUIRED: 'La fecha de inicio es requerida',
  END_DATE_MUST_BE_LARGER_THAN_START:
    'La fecha de fin debe ser posterior a la fecha de inicio',
  INTERVAL_REQUIRED: 'El intervalo es requerido',
  EVENT_PROTOCOL_REQUIRED: 'El protocolo del evento es requerido',
  EVENT_CODE_REQUIRED: 'El código del evento es requerido',
  'inactivity_form.error': 'Error al procesar el evento de inactivación',
  'inactivity_form.delete_error': 'Error al eliminar el evento de inactivación',
  'event_inactivity_form.never': 'Nunca',

  // Missing translation keys found in components
  'set.default.value.title.confirmation': 'Establecer Valor Predeterminado',
  'set.default.value.body.confirmation':
    '¿Está seguro de que desea establecer este como el valor predeterminado?',
  'video.attachments': 'Archivos Adjuntos de Video',
  'audio.attachments': 'Archivos Adjuntos de Audio',
  'audio n. ': 'Audio ',
  'AudioMenuDialog.no.audio': 'Ningún audio seleccionado',
  'AudioMenuDialog.select.audio.selected':
    'Selecciona un audio de la lista para reproducirlo',
  'videoMenuDialog.counter': 'Video {{current}} / {{total}}',
  'Monitoring.status.waiting': 'Estado del monitoreo: esperando',
  'Monitoring.status.paused': 'Estado del monitoreo: pausado',
  'Monitoring.loading.error': 'Error al cargar datos de monitoreo',
  'Monitoring.bulk_process.empty_options.error':
    'Por favor seleccione opciones de procesamiento',
  'Monitoring.bulk_process.empty_resolution_comment.error':
    'El comentario de resolución es requerido',
  'Monitoring.bulk_process.processed.success':
    'Se procesaron exitosamente {{count}} de {{total}} situaciones',
  'Monitoring.bulk_process.processed.partial_error':
    'Fallo al procesar {{failed}} de {{total}} situaciones',
  'Monitoring.bulk_process.processed.error': 'Error al procesar situaciones',
  'monitoring.bulk_process.selected_count':
    '{{count}} situaciones seleccionadas',
  'monitoring.bulk_process.processing': 'Procesando situaciones...',
  'monitoring.bulk_process.round_not_selectable':
    'Esta situación pertenece a una ronda y no puede ser procesada en lote',
  'fetchEvents.error': 'Error al obtener eventos',
  'createDeviceHistory.form.fetch_error_text':
    'Error al obtener datos para el formulario',
  'createDeviceHistory.success':
    'Historial del dispositivo creado exitosamente',
  'createDeviceHistory.general.error':
    'Error al crear historial del dispositivo',
  'sent_invitation.success': 'Invitación enviada exitosamente',
  'create_treinco_app.form.email_error':
    'Dirección de correo electrónico inválida',
  'create_treinco_app.form.email_required':
    'El correo electrónico es requerido',
  'create_treinco_app.form.name_error': 'El nombre es requerido',
  'create_treinco_app.form.last_name_error': 'El apellido es requerido',
  'create_treinco_app.form.device_name_error':
    'El nombre del dispositivo es requerido',
  'device_history_preview.latest_events_title': 'Últimos Eventos',
  'PlacerPicker.success_message': 'Lugar seleccionado exitosamente',
  'PlacerPicker.error_message': 'Error al seleccionar lugar',
  'emergencyContactList.noEmergencyContactList.title':
    'No hay Listas de Contactos de Emergencia',
  'emergencyContactList.noEmergencyContactList.subtitle':
    'Crea tu primera lista de contactos de emergencia para comenzar',
  'emergencyContactList.search.eventGroups': 'Buscar grupos de eventos...',
  'common.search.placeholder': 'Buscar...',
  'monitoring_monitoring_error_modal.button_reset': 'Restablecer Conexión',

  // Additional missing translation keys
  'deleteGeofenceById.create.success': 'Geocerca eliminada exitosamente',
  'deleteGeofenceById.geofence.has.devices.error':
    'No se puede eliminar la geocerca: tiene dispositivos asociados',
  'deleteGeofenceById.general.error': 'Error al eliminar geocerca',
  'deleteGeofenceById.delete.title.confirmation': 'Eliminar Geocerca',
  'deleteGeofenceById.delete.subtitle.confirmation':
    '¿Está seguro de que desea eliminar esta geocerca?',
  'deleteGeofenceAssociationById.success':
    'Asociación de geocerca eliminada exitosamente',
  'CreateGeofence.create.success': 'Geocerca creada exitosamente',
  'CreateGeofence.general.error': 'Error al crear geocerca',
  'updateGeofenceById.create.success': 'Geocerca actualizada exitosamente',
  'updateGeofenceById.general.error': 'Error al actualizar geocerca',
  'flushDeviceGeofence.general.error':
    'Error al limpiar geocerca del dispositivo',
  'no.geofenceType.error': 'El tipo de geocerca es requerido',
  'createDeviceGeofence.success':
    'Asociación de geocerca del dispositivo creada exitosamente',
  'createDeviceGeofence.general.error':
    'Error al crear asociación de geocerca del dispositivo',
  'geofence.remove.association.title.confirmation':
    'Eliminar Asociación de Geocerca',
  'geofence.remove.association.confirmation':
    '¿Está seguro de que desea eliminar esta asociación de geocerca?',
  'geofenceCard.link.edit.geofence': 'Editar Geocerca',
  'geofenceCard.remove.association': 'Eliminar Asociación',
  'geofenceCard.delete.geofence': 'Eliminar Geocerca',
  'close.geofence.list': 'Cerrar Lista de Geocercas',
  'open.geofence.list': 'Abrir Lista de Geocercas',
  'devicesGeofence.input.text': 'Buscar dispositivos por geocerca',
  'geofences.button.create': 'Crear Geocerca',
  'button.new.association': 'Agregar existente',
  'geofences.empty.create': 'Crea tu primera geocerca',
  'GeofenceListToAssociate.save': 'Guardar',
  'GeofenceListToAssociate.back': 'Volver',
  'GeofenceList.empty.geofences': 'No hay geocercas disponibles para asociar',

  'CreateGeofence.create.title': 'Crear Geocerca',
  'createGeofence.form.name': 'Nombre',
  'createGeofence.form.geofence.type': 'Tipo',
  'createGeofence.form.color': 'Color',
  'geofence.type.line': 'Línea',
  'geofence.type.polygon': 'Polígono',
  'geofence.type.circle': 'Círculo',
  'geofence.draw': 'Dibujar',
  'geofence.re-draw': 'Volver a dibujar',
  'geofence.stop': 'Detener',
  'geofence.submit': 'Guardar',
  'geofence.back': 'Volver',
  'devices_tab_title.devices': 'Dispositivos',
  'devices_tab_title.geofences': 'Geocercas',

  'RouteSummarySearch.general.error': 'Error al buscar resumen de ruta',
  'editDevice.success': 'Dispositivo actualizado exitosamente',
  'createDevice.success': 'Dispositivo creado exitosamente',
  'device_form.error': 'Error al procesar formulario del dispositivo',
  'device_form.error_uniqueId_exist':
    'Ya existe un dispositivo con esta combinación de prefijo e identificador',
  'devicePlace.update.error': 'Error al actualizar lugar del dispositivo',
  'deviceTable.general.error':
    'Error al procesar acción de tabla de dispositivos',
  'resetpassword.success': 'Contraseña restablecida exitosamente',
  'validateaccount.general.error': 'Error al validar cuenta',
  'validateaccount.success': 'Cuenta validada exitosamente',
  'deleteEmergencyContactListEventGroup.success':
    'Grupo de eventos de lista de contactos de emergencia eliminado exitosamente',
  'deleteEmergencyContactListEventGroup.error':
    'Error al eliminar grupo de eventos de lista de contactos de emergencia',
  'updateEmergencyContactListEventGroup.success':
    'Grupo de eventos de lista de contactos de emergencia actualizado exitosamente',
  'updateEmergencyContactListEventGroup.error':
    'Error al actualizar grupo de eventos de lista de contactos de emergencia',
  'createEmergencyContactEventGroup.success':
    'Grupo de eventos de contactos de emergencia creado exitosamente',
  'create_customer.error': 'El cliente es requerido',
  'createEmergencyContactEventGroup.general.error':
    'Error al agregar el contacto',

  // Validation error messages
  VALIDATE_PARTITION_IDENTIFIER_MIN_LENGHT_ERROR:
    'El identificador de partición debe tener al menos 1 carácter',
  VALIDATE_PARTITION_IDENTIFIER_MAX_LENGHT_ERROR:
    'El identificador de partición debe tener como máximo 50 caracteres',
  VALIDATE_PARTITION_IDENTIFIER_REQUIRED:
    'El identificador de partición es requerido',
  VALIDATE_PARTITION_NAME_MIN_LENGHT_ERROR:
    'El nombre de la partición debe tener al menos 3 caracteres',
  VALIDATE_PARTITION_NAME_MAX_LENGHT_ERROR:
    'El nombre de la partición debe tener como máximo 50 caracteres',
  VALIDATE_PARTITION_NAME_REQUIRED: 'El nombre de la partición es requerido',
  VALIDATE_EMERGENCY_NAME_MIN_LENGHT_ERROR:
    'El nombre del contacto de emergencia debe tener al menos 3 caracteres',
  VALIDATE_EMERGENCY_NAME_MAX_LENGHT_ERROR:
    'El nombre del contacto de emergencia debe tener como máximo 50 caracteres',
  VALIDATE_DEVICE_NAME_MIN_LENGHT_ERROR:
    'El nombre del dispositivo debe tener al menos 3 caracteres',
  VALIDATE_DEVICE_NAME_MAX_LENGHT_ERROR:
    'El nombre del dispositivo debe tener como máximo 50 caracteres',
  VALIDATE_DEVICE_NAME_REQUIRED: 'El nombre del dispositivo es requerido',
  VALIDATE_TIMEZONE_REQUIRED: 'La zona horaria es requerida',
  VALIDATE_GEOFENCE_COLOR_REQUIRED: 'El color de la geocerca es requerido',
  VALIDATE_DEVICE_ZONE_NAME_MIN_LENGHT_ERROR:
    'El nombre de la zona debe tener al menos 3 caracteres',
  VALIDATE_DEVICE_ZONE_NAME_MAX_LENGHT_ERROR:
    'El nombre de la zona debe tener como máximo 50 caracteres',
  VALIDATE_DEVICE_ZONE_NAME_REQUIRED: 'El nombre de la zona es requerido',

  // Workspace invitation and creation
  'workspaceInvitation.title.text': 'Invitación al Espacio de Trabajo',
  'workspaceInvitation.body.text':
    'Has sido invitado a unirte a un espacio de trabajo',
  'workspaceInvitation.body.error.text': 'Invitación inválida o expirada',
  'workspaces.create_workspace.button.text': 'Crear Espacio de Trabajo',
  'workspaces.create_workspace_modal.back_button.text': 'Atrás',
  'workspaces.create_workspace_modal.finish_button.text': 'Finalizar',
  'workspaces.create_workspace_modal.next_button.text': 'Siguiente',
  'workspaces.create_workspace_modal.retry_button.text': 'Reintentar',
  'workspaceInvitation.button.cancel': 'Cancelar',
  'workspaceInvitation.button.submit': 'Aceptar',
  'workspaceInvitation.button.goHome': 'Ir al Inicio',
  'WorkspaceInvitation.invitation.emailMismatch':
    'Este enlace de invitación no es para ti, por favor inicia sesión con la cuenta correcta para aceptar la invitación.',
  'workspaceInvitation.body.error.emailMismatch':
    'Este enlace de invitación no era para ti, por favor inicia sesión con la cuenta correcta para aceptar la invitación.',
  'page.workspace.invitation': 'Invitación al Espacio de Trabajo',
  'workspaceInvitation.body.accept_reject_success':
    'Has aceptado o rechazado la invitación exitosamente.',
  'workspaceInvitation.general.error':
    'Ocurrió un error al procesar la invitación.',
  // Monitoring resolution
  'monitoring_resolution.fetch.error': 'Error al obtener resoluciones',
  'monitoring_resolution.create.success':
    'Resolución de monitoreo creada exitosamente',
  'monitoring_resolution.create.error':
    'Error al crear resolución de monitoreo',
  'monitoring_resolution.update.success':
    'Resolución de monitoreo actualizada exitosamente',
  'monitoring_resolution.update.error':
    'Error al actualizar resolución de monitoreo',
  'monitoring_resolution.delete.success':
    'Resolución de monitoreo eliminada exitosamente',
  'monitoring_resolution.delete.error':
    'Error al eliminar resolución de monitoreo',
  'monitoring_resolution.delete.title.confirmation':
    'Eliminar Resolución de Monitoreo',
  'monitoring_resolution.delete.subtitle.confirmation':
    '¿Está seguro de que desea eliminar esta resolución de monitoreo?',
  'monitoring_resolution.no_resolutions.subtitle':
    'Crea tu primera resolución de monitoreo para comenzar',
  'monitoring_resolution.button.create': 'Crear Resolución de Monitoreo',
  'CreateResolution.title': 'Crear Resolución de Monitoreo',
  'UpdateResolution.title': 'Actualizar Resolución de Monitoreo',
  'CreateResolution.button.create': 'Crear',
  'CreateResolution.button.update': 'Actualizar',
  'CreateResolution.form.name': 'Nombre de la Resolución',
  // Form fields and actions
  'CreateResolution.form.text': 'Texto de Resolución',
  'device_action_groups.import.button.text': 'Importar Acciones',

  // User invitation to workspace
  'inviteUserToWorkspace.invitation.sent': 'Invitación enviada exitosamente',
  'InviteUserToWorkspace.invite': 'Enviar Invitación',
  'InviteUserToWorkspace.form.email': 'Dirección de Correo Electrónico',
  'inviteUserToWorkspace.error.user.exist':
    'El usuario ya existe en este espacio de trabajo',
  'common.delete': 'Eliminar',
  'common.delete_confirm': '¿Estás seguro de querer eliminar "{{ name }}"?',

  // situation logs
  'situation_logs.dialog.title': 'Log de la situación',
  'situation_logs.load_error': 'No se pudo cargar el log de la situación.',
  'situation_logs.action_field_title': 'Acción',
  'situation_logs.user_field_title': 'Usuario',
  'situation_logs.date_field_title': 'Fecha',
  'situation_logs.comment_field_title': 'Comentario',

  // Device Custom Key Values (usando "Atributo" en lugar de "Clave" en texto visible al usuario)
  'device.custom_key_values': 'Atributos Personalizados',
  'device.no_custom_key_values': 'No hay atributos personalizados asignados',
  'device.add_custom_key_value': 'Agregar Atributo Personalizado',
  'device.custom_key_created': 'Atributo personalizado creado exitosamente',
  'device.custom_key_already_exists':
    'Este atributo personalizado ya está asignado a este dispositivo',
  'device.custom_key_label': 'Atributo Personalizado',
  'device.custom_key_value': 'Valor',
  'device.create_custom_key_title': 'Crear Atributo Personalizado',
  'device.custom_key_name': 'Nombre del Atributo',
  'device.create_key_button': 'Crear Atributo',
  'device.unknown_key': 'Atributo Desconocido',
  'device.add_new_key': 'Agregar nuevo atributo',
  'device.custom_key_value_created':
    'Valor de atributo personalizado creado exitosamente',
  'device.custom_key_value_deleted':
    'Valor de atributo personalizado eliminado exitosamente',

  // Integration form translations
  'settings.integrations_table.receivers_field_text': 'Receptores',
  'integrations.add_receiver_label_menu': 'Agregar Receptor',
  'settings.connectors_table.connector_status_unknown_message':
    'Estado Desconocido',
  'update_receiver_form.title': 'Actualizar Receptor',
  'create_receiver_form.title': 'Crear Receptor',
  'update_receiver_form.submit': 'Actualizar',
  'create_receiver_form.submit': 'Crear',
  'receiver_form.description_label': 'Descripción',
  'receiver_form.description_placeholder': 'Ingrese descripción',
  'receiver_form.connection_type_label': 'Tipo de Conexión',
  'receiver_form.connection_types.serial': 'Serial',
  'receiver_form.connection_types.tcpClient': 'Cliente TCP',
  'receiver_form.connection_types.tcpServer': 'Servidor TCP',
  'receiver_form.connection_types.udp': 'UDP',
  'receiver_form.connection_types.httpServer': 'Servidor HTTP',
  'receiver_form.connection_types.polling': 'Polling',
  'receiver_form.receiver_type_label': 'Tipo de Receptor',
  'receiver_form.host_label': 'Host',
  'receiver_form.port_label': 'Puerto',
  'receiver_form.baudRate_label': 'Velocidad en Baudios',
  'receiver_form.parity_label': 'Paridad',
  'receiver_form.parity.none': 'Ninguna',
  'receiver_form.parity.even': 'Par',
  'receiver_form.parity.odd': 'Impar',
  'receiver_form.parity.mark': 'Marca',
  'receiver_form.parity.space': 'Espacio',
  'receiver_form.byteSize_label': 'Tamaño de Byte',
  'receiver_form.stopBits_label': 'Bits de Parada',
  'receiver_form.maxInactivity_label': 'Inactividad Máxima',
  'receiver_form.dahua.api_label': 'URL de la API DoLynk',
  'receiver_form.dahua.api_placeholder': 'Ingresa la URL de la API DoLynk',
  'receiver_form.dahua.access_key_label': 'Access Key de DoLynk',
  'receiver_form.dahua.access_key_placeholder':
    'Ingresa la Access Key de DoLynk',
  'receiver_form.dahua.sk_label': 'Secret Key de DoLynk',
  'receiver_form.dahua.sk_placeholder': 'Ingresa la Secret Key de DoLynk',
  'receiver_form.dahua.product_id_label': 'Product ID de DoLynk',
  'receiver_form.dahua.product_id_placeholder':
    'Ingresa el Product ID de DoLynk',
  'receiver_form.dahua.extra_required':
    'Todos los campos de DoLynk son obligatorios.',
  'receiver_form.dahua.api_invalid':
    'Ingresa una URL válida de la API DoLynk (debe iniciar con http o https).',
  'receiver_form.traccar.url_label': 'URL de la API Traccar',
  'receiver_form.traccar.url_placeholder': 'Ingresa la URL de la API Traccar',
  'receiver_form.traccar.user_label': 'Usuario de Traccar',
  'receiver_form.traccar.user_placeholder': 'Ingresa el usuario de Traccar',
  'receiver_form.traccar.password_label': 'Contraseña de Traccar',
  'receiver_form.traccar.password_placeholder':
    'Ingresa la contraseña de Traccar',
  'receiver_form.traccar.url_invalid':
    'Ingresa una URL válida de la API Traccar (debe iniciar con http o https).',
  'receiver_form.traccar_api_not_reachable':
    'No se pudo conectar a la API. Por favor verifica la URL y las credenciales.',
  'receiver_form.risco.api_url_label': 'URL de API Risco Cloud',
  'receiver_form.risco.api_url_placeholder':
    'Ingresa URL de API Risco Cloud (opcional)',
  'receiver_form.risco.proxy_host_label': 'Host del Proxy Risco',
  'receiver_form.risco.proxy_host_placeholder':
    'Ingresa host del proxy Risco (opcional)',
  'receiver_form.risco.proxy_port_label': 'Puerto del Proxy Risco',
  'receiver_form.risco.proxy_port_placeholder':
    'Ingresa puerto del proxy Risco (opcional)',
  'receiver_form.risco.username_label': 'Usuario Risco',
  'receiver_form.risco.username_placeholder':
    'Ingresa usuario Risco (opcional)',
  'receiver_form.risco.password_label': 'Contraseña Risco',
  'receiver_form.risco.password_placeholder':
    'Ingresa contraseña Risco (opcional)',
  'create_receiver_form.success_message': 'Receptor creado exitosamente',
  'create_receiver_form.error_message': 'Error al crear el receptor',
  'create_receiver_form.prefix_required_error':
    'Se requiere al menos un prefijo',
  'update_receiver_form.success_message': 'Receptor actualizado exitosamente',
  'update_receiver_form.error_message': 'Error al actualizar el receptor',
  'receiver_delete.success_message': 'Receptor eliminado exitosamente',
  'receiver_delete.error_message': 'Error al eliminar el receptor',
  // Workspace Shared Access
  'workspace.shared_access.title': 'Acceso Compartido',
  'workspace.shared_access.my_workspace_id': 'Mi ID de Espacio de Trabajo',
  'workspace.shared_access.id_copied':
    'ID del espacio de trabajo copiado al portapapeles',
  'workspace.shared_access.copy_error':
    'Error al copiar el ID del espacio de trabajo',
  'workspace.shared_access.loading': 'Cargando datos de acceso compartido...',
  'workspace.shared_access.fetch_error':
    'Error al cargar datos de acceso compartido',
  'workspace.shared_access.error_loading':
    'Error al cargar los datos de acceso compartido',
  'workspace.shared_access.incoming_title':
    'Espacios de trabajo que pueden observarme',
  'workspace.shared_access.outgoing_title':
    'Espacios de trabajo que puedo observar',
  'workspace.shared_access.no_incoming':
    'No hay espacios de trabajo solicitando acceso',
  'workspace.shared_access.no_outgoing':
    'No hay solicitudes de acceso salientes',
  'workspace.shared_access.add_new': 'Solicitar ser Monitoreado',
  'workspace.shared_access.delete_title': 'Eliminar Acceso Compartido',
  'workspace.shared_access.delete_message':
    '¿Está seguro de que desea eliminar el acceso compartido para "{{workspaceName}}"? Esta acción no se puede deshacer.',
  'workspace.shared_access.deleted_success':
    'Acceso compartido eliminado exitosamente',
  'workspace.shared_access.delete_error':
    'Error al eliminar el acceso compartido',
  'workspace.shared_access.approved_success': 'Solicitud de acceso aprobada',
  'workspace.shared_access.rejected_success': 'Solicitud de acceso rechazada',
  'workspace.shared_access.status_update_error':
    'Error al actualizar el estado de la solicitud',
  'workspace.shared_access.request_sent':
    'Solicitud de acceso enviada exitosamente',
  'workspace.shared_access.request_error':
    'Error al enviar la solicitud de acceso',
  'workspace.shared_access.workspace_not_found':
    'Espacio de trabajo no encontrado',
  'workspace.shared_access.cannot_request_self':
    'No puede solicitar acceso a su propio espacio de trabajo',
  'workspace.shared_access.request_exists': 'La solicitud ya existe',
  'workspace.shared_access.access_exists': 'El acceso ya ha sido otorgado',
  'workspace.shared_access.status.approved': 'Aprobado',
  'workspace.shared_access.status.pending': 'Pendiente',
  'workspace.shared_access.status.rejected': 'Rechazado',
  'workspace.shared_access.actions.approve': 'Aprobar',
  'workspace.shared_access.actions.reject': 'Rechazar',
  'workspace.shared_access.actions.remove': 'Quitar',
  'workspace.shared_access.form.description':
    'Ingrese el ID del espacio de trabajo al que desea SOLICITAR que lo monitoree. El propietario del espacio de trabajo deberá aprobar su solicitud para observar sus dispositivos.',
  'workspace.shared_access.form.workspace_id': 'ID del Espacio de Trabajo',
  'workspace.shared_access.form.workspace_id_required':
    'El ID del espacio de trabajo es requerido',
  'workspace.shared_access.form.invalid_uuid':
    'Por favor ingrese un ID de espacio de trabajo válido',
  'workspace.shared_access.form.cannot_add_self':
    'No puede solicitar acceso a su propio espacio de trabajo',
  'workspace.shared_access.form.workspace_already_exists':
    'Ya existe una solicitud para este espacio de trabajo',
  'workspace.shared_access.form.send_request': 'Enviar Solicitud',
  'workspace.shared_access.unknown_workspace': 'Espacio de Trabajo Desconocido',

  'invitations.pending_state_label': 'Pendiente',
  'invitationItem.delete.title.confirmation': 'Eliminar invitación',
  'invitationItem.delete.confirmation':
    '¿Está seguro de que desea eliminar esta invitación?',

  'createUserDialog.imageUploadFailed': 'Error al subir la imagen',
  'createUserDialog.form.image': 'Imagen del usuario',
  'deviceUsertable.view_image': 'Ver imagen del usuario',
  'createZoneDialog.imageUploadFailed': 'Error al subir la imagen',
  'createZoneDialog.form.image': 'Imagen de la zona',
  'deviceZonetable.view_image': 'Ver imagen de la zona',
  'CreateEmergencyContact.imageUploadFailed': 'Error al subir la imagen',
  'createEmergencyContact.form.image': 'Imagen del contacto',
  'emergencyContactItem.view_image_error': 'No hay imagen disponible',
  'emergencyContactItem.view_image': 'Ver imagen',
  'emergencycontactItem.delete.title.confirmation':
    'Eliminar contacto de emergencia',
  'emergencycontactItem.delete.confirmation':
    '¿Está seguro de que desea eliminar este contacto de emergencia?',
  'emergencyContactItem.general.error': 'Error con el contacto de emergencia',
  'emergencyContact.select': 'Seleccionar contacto de emergencia',
  'imageUploader.remove_image': 'Eliminar imagen',
  'imageUploader.drag_and_drop_or_click':
    'Arrastra y suelta o haz clic para seleccionar una imagen',
  'imageUploader.select_image': 'Seleccionar imagen',
  'createDeviceEmergencyContact.form.image': 'Imagen',

  // Common translations used in SharedAccess
  'error.forbidden_permissions': 'No tienes permisos para realizar esta acción',
  'common.retry': 'Reintentar',
  'common.cancel': 'Cancelar',
  'common.deleting': 'Eliminando...',
  'common.copied': '¡Copiado!',
  'common.copy': 'Copiar',
  'common.add': 'Agregar',
  'prefixLine.list.title': 'Líneas de prefijo',
  'prefixLine.prefix.label': 'Prefijo',
  'prefixLine.line.label': 'Línea',
  'prefixLine.list.empty':
    'Aún no hay elementos. Haz clic en "Agregar" para añadir el primero.',
  'prefix.range.prefix.label': 'Prefijo',
  'prefix.range.from.label': 'Desde',
  'prefix.range.to.label': 'Hasta',
  'receiver.prefix.title': 'Prefijos del Receptor',
  'prefix.range.no_data':
    'No se encontraron rangos de prefijos para este espacio de trabajo',
  'prefix.range.title': 'Rangos de Prefijos',
  'prefixRange.from.label': 'Desde',
  'prefixRange.to.label': 'Hasta',
  'device_search.label': 'Buscar un dispositivo',
  'device_search.empty': 'No se encontraron dispositivos',
  'device_search.loading': 'Cargando dispositivos...',
  'device_search.error': 'Error al buscar dispositivos',
  'delete.calendar.event.title.confirmation': 'Eliminar Evento del Calendario',
  'delete.calendar.event.body.confirmation':
    '¿Está seguro de que desea eliminar este evento del calendario?',
  'deviceProfile.partitions.armed': 'Armado',
  'deviceProfile.partitions.disarmed': 'Desarmado',
  'deviceProfile.partitions.alarm': 'Alarma',
  'address.map.no.result': 'No se encontraron resultados para esta dirección',
  'CustomRecurrenceForm.form.title': 'Recurrencia Personalizada',
  'CustomRecurrenceForm.recurrence_days': 'Días de la semana',
  'updateDeviceNote.general.error': 'Error al actualizar la nota',
  save: 'Guardar',
  repeatEvery: 'Repetir cada',
  days: 'días',
  weeks: 'semanas',
  months: 'meses',
  years: 'años',
  end: 'Fin',
  never: 'Nunca',
  occurrences: 'ocurrencias',
  'recurrence.end.never': 'Nunca',
  'recurrence.end.afterOccurrences': 'Después de ocurrencias',
  'occurrences.placeholder': '0',
  'reporters.username_text': 'Nombre de usuario',
  'reporters.email_text': 'Correo Electrónico',
  treinco_permissions_device_notification: 'Notificación de Dispositivo',
  'treinco_permissions_device_notification.create':
    'Crear Notificaciones de Dispositivo',
  'treinco_permissions_device_notification.update':
    'Actualizar Notificaciones de Dispositivo',
  'treinco_permissions_device_notification.delete':
    'Eliminar Notificaciones de Dispositivo',
  'treinco_permissions_device_notification.view':
    'Ver Notificaciones de Dispositivo',
  treinco_permissions_integration: 'Integración',
  'treinco_permissions_integration.create': 'Crear Integraciones',
  'treinco_permissions_integration.update': 'Actualizar Integraciones',
  'treinco_permissions_integration.delete': 'Eliminar Integraciones',
  'treinco_permissions_integration.view': 'Ver Integraciones',
  treinco_permissions_label: 'Etiqueta',
  'treinco_permissions_label.create': 'Crear Etiquetas',
  'treinco_permissions_label.update': 'Actualizar Etiquetas',
  'treinco_permissions_label.delete': 'Eliminar Etiquetas',
  'treinco_permissions_label.view': 'Ver Etiquetas',
  treinco_permissions_notification_group: 'Grupo de Notificación',
  'treinco_permissions_notification_group.create':
    'Crear Grupos de Notificación',
  'treinco_permissions_notification_group.update':
    'Actualizar Grupos de Notificación',
  'treinco_permissions_notification_group.delete':
    'Eliminar Grupos de Notificación',
  'treinco_permissions_notification_group.view': 'Ver Grupos de Notificación',
  treinco_permissions_workspace_to_workspace: 'Espacio de Trabajo compartido',
  'treinco_permissions_workspace.shared_access.create':
    'Crear Acceso Compartido',
  'treinco_permissions_workspace.shared_access.manage':
    'Administrar Acceso Compartido',
  'treinco_permissions_workspace.shared_access.view': 'Ver Acceso Compartido',
  'treinco_permissions_workspace.shared_access.delete':
    'Eliminar Acceso Compartido',
  treinco_permissions_device_cctv_channel: 'Canal CCTV de Dispositivo',
  treinco_permissions_attachment: 'Adjuntos',
  'treinco_permissions_attachment.delete': 'Eliminar',
  'treinco_permissions_attachment.view': 'Ver',
  'treinco_permissions_attachment.create': 'Crear',
  'treinco_permissions_workspace.user_management': 'Gestión de usuarios',
  treinco_permissions_situation: 'Situación',
  'treinco_permissions_situation.view': 'Ver Situaciones',
  treinco_permissions_apiKey: 'Clave de API',
  'treinco_permissions_api_key.create': 'Crear Claves API',
  'treinco_permissions_api_key.revoke': 'Revocar Claves API',
  'treinco_permissions_api_key.view': 'Ver Claves API',

  'history.event.loading_or_not_exist':
    'Cargando datos del evento o el evento no existe',
  'emergencyContactListTable.edit.emergencyContactList':
    'Editar Lista de Contactos de Emergencia',
  'emergencyContactListTable.delete.emergencyContactList':
    'Eliminar Lista de Contactos de Emergencia',

  'resolutionTable.edit.resolution': 'Editar Mensaje predeterminado',
  'resolutionTable.delete.resolution': 'Eliminar mensaje predeterminado',

  'resolutionItem.delete.title.confirmation':
    'Eliminar mensaje predeterminado de monitoreo',
  'resolutionItem.delete.success': 'Resolución eliminada exitosamente',
  'resolutionItem.delete.confirmation':
    '¿Está seguro de que desea eliminar este mensaje predeterminado?',
  'eventGroupTable.delete.eventGroup': 'Eliminar Grupo de Eventos',
  'eventItem.delete.title.confirmation': 'Eliminar evento',
  'eventItem.delete.confirmation':
    '¿Está seguro de que desea eliminar este evento?',
  'eventItem.general.error': 'Error al eliminar el evento',

  'eventGroupItem.delete.title.confirmation': 'Eliminar Grupo de Eventos',
  'eventGroupItem.delete.confirmation':
    '¿Está seguro de que desea eliminar este grupo de eventos?',

  'general.cancel': 'Cancelar',
  'common.yes': 'Sí',
  'common.no': 'No',
  'common.generic_error': 'Error inesperado',
  'common.update': 'Actualizar',
  'event.position': 'Posición',
  'qr.no_points_available':
    'No hay puntos disponibles para generar códigos QR.',
  'change.avatar.success': 'Imagen de perfil actualizada',
  'change.avatar.error': 'Error al modificar la imagen de perfil',

  // recorridos
  'routeSearch.search.title': 'Buscar recorridos',
  'routeSearch.server.time': 'Hora del servidor',
  'routeSearch.gps.time': 'Hora del GPS',
  'routeSearch.form.startDate': 'Fecha de inicio',
  'routeSearch.form.endDate': 'Fecha de fin',
  'routeSummary.empty.events': 'No hay recorridos',
  'places.places_field_text': 'Lugares',
  'device_profile.places_tab_title': 'Lugares',
  'device_profile.points_tab_title': 'Puntos',
  'device_profile.points.name_column': 'Nombre',
  'device_profile.points.identifier_column': 'Identificador',
  'device_profile.points.description_column': 'Descripción',
  'device_profile.points.type_column': 'Tipo',
  'device_profile.points.actions_column': 'Acciones',
  'device_profile.points.group_column': 'Lugar',
  'device_profile.points.without_place_group': 'Sin lugar',
  'device_profile.rounds_tab_identifier': 'Identificador',
  'point.button_add': 'Crear punto',
  'device_search.start_typing': 'Empieza a escribir para buscar dispositivos',
  'device_search.minimum_length': 'Ingresa al menos dos caracteres para buscar',
  'device_search.helper': 'Busca por nombre del dispositivo, ID o prefijo',
  'device_search.unnamed_device': 'Dispositivo sin nombre',
  'create_reporter_user.success_created': 'Usuario creado exitosamente',
  'create_reporter_user.success_assigned':
    'El usuario ya existe y fue asignado como reportero. Los datos del usuario existente fueron preservados.',
  'create_reporter_user.error_creating': 'Error al crear usuario',
  'create_reporter_user.error_user_exist':
    'Ya existe un usuario con este correo o nombre de usuario',
  'device_profile.subscriptions_tab_title': 'Suscripciones',
  'subscriptions.table.id': 'ID',
  'subscriptions.table.plan': 'Plan',
  'subscriptions.table.plan_item': 'Plan / Ítem',
  'subscriptions.table.no_plan': 'Sin plan',
  'subscriptions.table.status': 'Estado',
  'subscriptions.table.start_date': 'Fecha de inicio',
  'subscriptions.table.end_date': 'Fecha de fin',
  'subscriptions.table.billing_timing': 'Timing de cobro',
  'subscriptions.table.billing_anchor': 'Día de anclaje',
  'subscriptions.table.end_of_month': 'Fin mes',
  'subscriptions.table.day_n': 'Día {{n}}',
  'subscriptions.table.items_count': '# Ítems',
  'subscriptions.table.next_billing_date': 'Próxima fecha de cobro',
  'subscriptions.table.total_monthly_cost': 'Costo mensual total',
  'subscriptions.table.actions': 'Acciones',
  'subscriptions.add': 'Crear suscripción',
  'subscriptions.create_success': 'Suscripción creada',
  'subscriptions.update_success': 'Suscripción actualizada',
  'subscriptions.delete_success': 'Suscripción eliminada',
  'subscriptions.delete.error': 'Error eliminando suscripción',
  'subscriptions.save_error': 'Error guardando suscripción',
  'subscriptions.actions.pause': 'Pausar suscripción',
  'subscriptions.actions.resume': 'Reanudar suscripción',
  'subscriptions.actions.cancel': 'Cancelar suscripción',
  'subscriptions.actions.history': 'Ver historial de facturación',
  'subscriptions.actions.view': 'Ver',
  'subscriptions.actions.add_item': 'Agregar ítem',
  'subscriptions.history_coming_soon': 'Historial de facturación próximamente',
  'subscriptions.items.modal_title': 'Ítems de la suscripción',
  'subscriptions.items.add': 'Agregar ítem',
  'subscriptions.items.create_success': 'Ítem de suscripción creado',
  'subscriptions.items.update_success': 'Ítem de suscripción actualizado',
  'subscriptions.items.delete_success': 'Ítem de suscripción eliminado',
  'subscriptions.items.delete.title.confirmation':
    'Eliminar ítem de suscripción',
  'subscriptions.items.delete.confirmation':
    '¿Estás seguro de que deseas eliminar este ítem de suscripción? Esta acción no se puede deshacer.',
  'subscriptions.items.save_to_manage':
    'Selecciona un plan para previsualizar ítems o guarda la suscripción para administrarlos.',
  'subscriptions.form.edit_title': 'Editar suscripción',
  'subscriptions.form.create_title': 'Crear suscripción',
  'subscriptions.form.plan_id': 'Plan',
  'subscriptions.form.plan_none': 'Sin plan',
  'subscriptions.form.status': 'Estado',
  'subscriptions.form.start_date': 'Fecha de inicio',
  'subscriptions.form.end_date': 'Fecha de fin',
  'subscriptions.form.billing_timing': 'Timing de cobro',
  'subscriptions.form.billing_anchor': 'Día de anclaje (-1 o 1..31)',
  'subscriptions.form.status.active': 'Activa',
  'subscriptions.form.status.paused': 'Pausada',
  'subscriptions.form.status.finished': 'Finalizada',
  'subscriptions.form.status.cancelled': 'Cancelada',
  'subscriptions.form.timing.in_advance': 'Por adelantado',
  'subscriptions.form.timing.in_arrears': 'A mes vencido',
  'subscriptions.form.save': 'Guardar',
  'subscriptions.form.create': 'Crear',
  'subscriptions.form.cancel': 'Cancelar',
  'subscriptions.form.field_immutable': 'No se puede cambiar después de crear',
  'subscriptions.form.end_date_error':
    'La fecha de fin debe ser posterior a la fecha de inicio',
  'subscriptions.form.items_in_treeview':
    'Los ítems de suscripción se pueden administrar en la tabla de abajo expandiendo la fila de la suscripción.',
  'subscriptions.items.plan_preview': 'Vista previa de ítems del plan',
  'subscriptions.items.select_plan_preview':
    'Selecciona un plan para previsualizar los ítems que se crearán.',
  'subscriptions.items.form.edit_title': 'Editar ítem de suscripción',
  'subscriptions.items.form.create_title': 'Agregar ítem de suscripción',
  'subscriptions.items.form.item': 'Ítem',
  'subscriptions.items.form.charge_type': 'Tipo de cargo',
  'subscriptions.items.form.billing_period': 'Periodo de facturación',
  'subscriptions.items.form.every_n': 'Cada N',
  'subscriptions.items.form.total_cycles': 'Ciclos totales',
  'subscriptions.items.form.unit_price': 'Precio unitario',
  'subscriptions.items.form.status': 'Estado',
  'subscriptions.items.form.cancel': 'Cancelar',
  'subscriptions.items.form.save': 'Guardar',
  'subscriptions.items.form.add': 'Agregar',
  'subscriptions.items.form.helper.every_n': 'Tamaño de paso; por defecto 1',
  'subscriptions.items.form.helper.total_cycles':
    'Para cuotas debe ser > 0; nulo para recurrente ilimitado',
  'subscriptions.items.form.status.active': 'Activa',
  'subscriptions.items.form.status.paused': 'Pausada',
  'subscriptions.items.form.status.finished': 'Finalizada',
  'subscriptions.items.form.status.cancelled': 'Cancelada',
  'subscriptions.items.form.field_immutable':
    'No se puede cambiar después de crear',
  'subscriptions.items.form.charge_type.one_time': 'Único',
  'subscriptions.items.form.charge_type.recurring': 'Recurrente',
  'subscriptions.items.form.charge_type.installment': 'Cuotas',
  'subscriptions.items.form.billing_period.day': 'Día',
  'subscriptions.items.form.billing_period.month': 'Mes',
  'subscriptions.items.form.billing_period.year': 'Año',
  'subscriptions.confirm.pause_title': 'Pausar Suscripción',
  'subscriptions.confirm.pause_description':
    '¿Está seguro de que desea pausar esta suscripción? La facturación se suspenderá hasta que se reanude.',
  'subscriptions.confirm.cancel_title': 'Cancelar Suscripción',
  'subscriptions.confirm.cancel_description':
    '¿Está seguro de que desea cancelar esta suscripción? Esta acción no se puede deshacer y no se realizará más facturación.',
  'subscriptions.pause_success': 'Suscripción pausada',
  'subscriptions.resume_success': 'Suscripción reanudada',
  'subscriptions.cancel_success': 'Suscripción cancelada',
  'subscriptions.prorating.title': 'Facturación Prorrateada Requerida',
  'subscriptions.prorating.description':
    'La fecha de inicio de la suscripción crea un período de servicio no cubierto. Esto ocurre cuando el servicio comienza antes de la próxima fecha de facturación regular.',
  'subscriptions.prorating.items_with_gaps':
    'Ítems que requieren facturación prorrateada:',
  'subscriptions.prorating.item': 'Ítem',
  'subscriptions.prorating.gap_period': 'Período del Vacío',
  'subscriptions.prorating.next_billing': 'Próxima Facturación Regular',
  'subscriptions.prorating.prorated_amount': 'Monto Prorrateado',
  'subscriptions.prorating.total': 'Total',
  'subscriptions.prorating.choice_description':
    'Puede crear una factura prorrateada ahora para cubrir el período del vacío, u omitir el prorrateo y comenzar la facturación desde la próxima fecha de facturación regular.',
  'subscriptions.prorating.skip': 'Omitir Prorrateo',
  'subscriptions.prorating.create_invoice': 'Crear Factura Prorrateada',
  'subscriptions.prorating.invoice_created': 'Factura prorrateada creada',
  'subscriptions.cancellation.title': 'Servicio No Facturado',
  'subscriptions.cancellation.description':
    'Hay servicio no facturado que fue proporcionado pero aún no se ha facturado.',
  'subscriptions.cancellation.items_with_gaps': 'Ítems:',
  'subscriptions.cancellation.unbilled_period': 'Período',
  'subscriptions.cancellation.choice_description': 'Crear factura u omitir.',
  'subscriptions.cancellation.skip': 'Omitir',
  'subscriptions.cancellation.create_invoice': 'Crear Factura',
  'subscriptions.cancellation.invoice_created': 'Factura creada',
  'subscriptions.pause.title': 'Servicio No Facturado',
  'subscriptions.pause.description':
    'Hay servicio no facturado que fue proporcionado pero aún no se ha facturado.',
  'subscriptions.pause.items_with_gaps': 'Ítems:',
  'subscriptions.pause.choice_description': 'Crear factura u omitir.',
  'subscriptions.pause.skip': 'Omitir',
  'subscriptions.pause.create_invoice': 'Crear Factura',
  'subscriptions.pause.invoice_created': 'Factura creada',
  'subscriptions.resume.title': 'Brecha de Servicio al Reanudar',
  'subscriptions.resume.description':
    'Al reanudar esta suscripción se creará una brecha de servicio entre hoy y la próxima fecha de facturación. El calendario de facturación se recalculará desde hoy.',
  'subscriptions.resume.items_with_gaps': 'Ítems con brechas de servicio:',
  'subscriptions.resume.choice_description':
    'Puede crear una factura prorrateada por el periodo de brecha, u omitir y dar el periodo de brecha como servicio gratuito.',
  'subscriptions.resume.skip': 'Omitir Prorrateo',
  'subscriptions.resume.create_invoice': 'Crear Factura Prorrateada',
  'subscriptions.resume.prorated_invoice_created':
    'Factura prorrateada creada por brecha de servicio',
  'subscriptions.resume.new_next_billing': 'Nueva Próxima Facturación',
  'subscriptions.confirm.resume_title': 'Reanudar Suscripción',
  'subscriptions.confirm.resume_description':
    '¿Está seguro de que desea reanudar esta suscripción? La facturación continuará desde la próxima fecha programada.',
  // Subscription Items (Ítems de Suscripción)
  'subscriptionItems.form.charge_type.one_time': 'Único',
  'subscriptionItems.form.charge_type.recurring': 'Recurrente',
  'subscriptionItems.form.charge_type.installment': 'Cuotas',
  'subscriptionItems.form.billing_period.day': 'Día',
  'subscriptionItems.form.billing_period.month': 'Mes',
  'subscriptionItems.form.billing_period.year': 'Año',
  'subscriptionItems.form.status.active': 'Activo',
  'subscriptionItems.form.status.paused': 'Pausado',
  'subscriptionItems.form.status.finished': 'Finalizado',
  'subscriptionItems.form.status.cancelled': 'Cancelado',
  'subscriptionItems.table.item': 'Ítem',
  'subscriptionItems.table.status': 'Estado',
  'subscriptionItems.table.charge_type': 'Tipo de cargo',
  'subscriptionItems.table.billing_period': 'Periodo',
  'subscriptionItems.table.every_n': 'Cada N',
  'subscriptionItems.table.unit_price': 'Precio unitario',
  'subscriptionItems.table.next_billing': 'Próxima facturación',
  'subscriptionItems.table.cycles': 'Ciclos',
  'subscriptionItems.table.actions': 'Acciones',
  'subscriptionItems.actions.edit': 'Editar',
  'subscriptionItems.actions.delete': 'Eliminar',
  'subscriptionItems.actions.pause': 'Pausar',
  'subscriptionItems.actions.resume': 'Reanudar',
  'subscriptionItems.actions.cancel': 'Cancelar',
  'subscriptionItems.confirm.delete_title': 'Eliminar Ítem de Suscripción',
  'subscriptionItems.confirm.delete_description':
    '¿Está seguro de que desea eliminar este ítem de suscripción? Esta acción no se puede deshacer.',
  'subscriptionItems.confirm.pause_title': 'Pausar Ítem de Suscripción',
  'subscriptionItems.confirm.pause_description':
    '¿Está seguro de que desea pausar este ítem de suscripción? Dejará de facturarse hasta que se reanude.',
  'subscriptionItems.confirm.resume_title': 'Reanudar Ítem de Suscripción',
  'subscriptionItems.confirm.resume_description':
    '¿Está seguro de que desea reanudar este ítem de suscripción? La facturación continuará desde la próxima fecha programada.',
  'subscriptionItems.confirm.cancel_title': 'Cancelar Ítem de Suscripción',
  'subscriptionItems.confirm.cancel_description':
    '¿Está seguro de que desea cancelar este ítem de suscripción? Esta acción no se puede deshacer.',
  'subscriptionItems.pause_success': 'Ítem de suscripción pausado',
  'subscriptionItems.resume_success': 'Ítem de suscripción reanudado',
  'subscriptionItems.cancel_success': 'Ítem de suscripción cancelado',
  'planItems.table.item': 'Ítem',
  'planItems.table.charge_type': 'Tipo de cargo',
  'planItems.table.billing_period': 'Periodo',
  'planItems.table.every_n': 'Cada N',
  'planItems.table.cycles': 'Ciclos',
  'planItems.table.default_price': 'Precio por defecto',
  'planItems.table.actions': 'Acciones',
  'planItems.create_success': 'Ítem de plan creado',
  'planItems.update_success': 'Ítem de plan actualizado',
  'planItems.delete_success': 'Ítem de plan eliminado',
  'planItems.delete_error': 'Error eliminando ítem de plan',
  'planItems.delete_confirm': '¿Eliminar este ítem del plan?',
  'items.table.name': 'Nombre',
  'items.table.type': 'Tipo',
  'items.table.recurring': 'Recurrente',
  'items.table.default_price': 'Precio por defecto',
  'items.table.tax_rate': 'Tasa (%)',
  'items.table.active': 'Activo',
  'items.table.actions': 'Acciones',
  'items.add': 'Crear ítem',
  'items.create_success': 'Ítem creado',
  'items.update_success': 'Ítem actualizado',
  'items.delete_success': 'Ítem eliminado',
  'items.save_error': 'Error guardando ítem',
  'items.delete_error': 'Error eliminando ítem',
  'items.form.title_create': 'Crear ítem',
  'items.form.title_edit': 'Editar ítem',
  'items.form.name': 'Nombre',
  'items.form.type': 'Tipo',
  'items.form.recurring': 'Es recurrente',
  'items.form.default_price': 'Precio por defecto',
  'items.form.tax_rate': 'Tasa (%)',
  'items.form.sku': 'SKU',
  'items.form.active': 'Activo',
  'items.search_error': 'Error al cargar ítems',
  'items.add_new': 'Agregar nuevo',
  'items.delete_error_in_use_invoice':
    'No se puede eliminar este ítem porque está siendo usado en una o más facturas.',
  'items.delete_error_in_use_plan':
    'No se puede eliminar este ítem porque está siendo usado en uno o más planes.',
  'items.delete_error_in_use_subscription':
    'No se puede eliminar este ítem porque está siendo usado en una o más suscripciones.',
  'invoices.items.select_item': 'Seleccionar Ítem',
  'invoices.items.item_required': 'El ítem es requerido',
  'invoices.items.not_editable_message':
    'Los ítems de factura finales no se pueden editar.',
  'plans.table.name': 'Nombre',
  'plans.table.description': 'Descripción',
  'plans.table.isActive': 'Activo',
  'plans.table.items': '# Ítems',
  'plans.table.actions': 'Acciones',
  'plans.add': 'Crear plan',
  'plans.create_success': 'Plan creado',
  'plans.update_success': 'Plan actualizado',
  'plans.delete_success': 'Plan eliminado',
  'plans.delete_error': 'Error eliminando plan',
  'plans.save_error': 'Error guardando plan',
  'plans.form.title_create': 'Crear plan',
  'plans.form.title_edit': 'Editar plan',
  'plans.form.name': 'Nombre',
  'plans.form.description': 'Descripción',
  'plans.form.active': 'Activo',
  'plans.details.title': 'Detalles del plan',
  'plans.details.add_item': 'Agregar ítem',
  'plans.delete.error': 'Error eliminando plan',
  'plans.actions.edit': 'Editar',
  'plans.actions.add_item': 'Agregar ítem',
  'plans.actions.delete': 'Eliminar',
  'common.save': 'Guardar',
  'common.create': 'Crear',
  'common.loading': 'Cargando...',
  'common.back': 'Volver',
  'common.continue': 'Continuar',
  'common.done': 'Hecho',

  // Plan Items Form
  'planItems.form.title_create': 'Agregar ítem de plan',
  'planItems.actions.edit': 'Editar',
  'planItems.actions.delete': 'Eliminar',
  'planItems.form.title_edit': 'Editar ítem de plan',
  'planItems.form.item': 'Ítem',
  'planItems.form.charge_type': 'Tipo de cargo',
  'planItems.form.billing_period': 'Periodo de facturación',
  'planItems.form.billing_period_helper': 'Requerido para recurrente y cuotas',
  'planItems.form.every_n': 'Cada N',
  'planItems.form.every_n_helper': 'Tamaño de paso; por defecto 1',
  'planItems.form.cycles': 'Ciclos',
  'planItems.form.cycles_helper':
    'Para cuotas debe ser > 0; null para recurrente ilimitado',
  'planItems.form.default_price': 'Precio por defecto',
  'planItems.form.charge_type.one_time': 'Único',
  'planItems.form.charge_type.recurring': 'Recurrente',
  'planItems.form.charge_type.installment': 'Cuotas',
  'planItems.form.billing_period.day': 'Día',
  'planItems.form.billing_period.month': 'Mes',
  'planItems.form.billing_period.year': 'Año',
  'planItems.save_error': 'Error guardando ítem de plan',

  // Items Form - Type options
  'items.form.type.product': 'Producto',
  'items.form.type.service': 'Servicio',

  // Invoice Series Form - Additional validations
  'invoice_series.form.name_max':
    'El nombre debe tener menos de 100 caracteres',
  'invoice_series.form.prefix_max':
    'El prefijo debe tener menos de 10 caracteres',
  'invoice_series.form.prefix_format':
    'El prefijo debe contener solo letras mayúsculas y números',
  'invoice_series.form.current_number': 'Número actual',
  'invoice_series.form.next_invoice_will_be': 'La próxima factura será',
  'invoice_series.form.inactive_warning':
    'Las series inactivas no pueden usarse para nuevas facturas',
  'invoice_series.form.create_success': 'Serie de facturas creada exitosamente',
  'invoice_series.form.update_success':
    'Serie de facturas actualizada exitosamente',
  'invoice_series.form.create_error': 'Error al crear la serie de facturas',
  'invoice_series.form.update_error':
    'Error al actualizar la serie de facturas',

  // Invoice Create Form - Series
  'invoices.create.series': 'Serie de Factura',
  'invoices.create.series_helper':
    'Seleccione una serie para numeración automática, o deje vacío para ingresar manualmente',
  'invoices.create.no_series_available':
    'No hay series de facturas activas disponibles. Debe ingresar un número de factura manualmente.',

  // Subscription Item Form - Errors
  'subscriptions.items.form.errors.item_required': 'El ítem es requerido',
  'subscriptions.items.form.errors.total_cycles_required':
    'Los ciclos totales deben ser mayor a 0 para cuotas',
  'subscriptions.items.form.errors.unit_price_required':
    'El precio unitario es requerido',
  'subscriptions.items.form.next_run': 'Próxima facturación',

  // Plans Table - Items count fix
  'plans.table.items_count': '# Ítems',

  // Invoice Detail - Finalize
  'invoices.detail.finalize_invoice': 'Finalizar Factura',
  'invoices.detail.finalize_confirmation_title': 'Finalizar Factura',
  'invoices.detail.finalize_warning':
    'Advertencia: Esta acción no se puede deshacer.',
  'invoices.detail.finalize_confirmation_message':
    'Una vez finalizada, esta factura no podrá ser editada. El estado cambiará de borrador a final.',
  'invoices.detail.finalize_button': 'Finalizar',
  'invoices.detail.finalize_success': 'Factura finalizada exitosamente',
  'invoices.detail.series': 'Serie',
  'invoices.detail.total': 'Total',
  'invoices.detail.items_count': 'Ítems',

  // Billing Run
  'billing.run.button': 'Ejecutar Facturación',
  'billing.run.title': 'Ejecutar Facturación',
  'billing.run.select_date': 'Seleccionar fecha de facturación',
  'billing.run.preview': 'Previsualizar',
  'billing.run.generate': 'Generar {{count}} Facturas',
  'billing.run.no_items_due':
    'No hay ítems de suscripción pendientes para esta fecha',
  'billing.run.success': '{{count}} facturas borrador creadas exitosamente',
  'billing.run.preview_error': 'Error al generar previsualización',
  'billing.run.execute_error': 'Error al generar facturas',
  'billing.run.cancel': 'Cancelar',
  'billing.run.customer': 'Cliente',
  'billing.run.items': 'Ítems',
  'billing.run.subtotal': 'Subtotal',
  'billing.run.tax': 'Impuesto',
  'billing.run.total': 'Total',
  'billing.run.invoices_count': 'Facturas',
  'billing.run.total_amount': 'Monto Total',
  'billing.run.billing_date': 'Fecha de Facturación',
  'billing.run.already_billed':
    '{{count}} ítems ya facturados para este período (excluidos)',
  'billing.run.items_detail': 'Ítems',
  'billing.run.device': 'Dispositivo',
  'billing.run.item_name': 'Ítem',
  'billing.run.charge_type': 'Tipo',
  'billing.run.service_period': 'Período de Servicio',
  'billing.run.amount': 'Monto',

  // Table Filters
  'filters.value': 'Valor',
  'filters.select_option': 'Seleccionar...',
  'filters.is_operator_label': 'es',
  'filters.not_operator_label': 'no es',
  'filters.is_any_of_operator_label': 'es uno de',
  'filters.not_contains_operator_label': 'no contiene',
  'filters.not_equals_operator_label': 'no es igual',
  'filters.select_user': 'Seleccionar usuario',
  'CustomBooleanFilterInput.label_text': 'Valor',
  'CustomBooleanFilterInput.select_value_label': 'Seleccionar...',
  'CustomBooleanFilterInput.any_value_label': 'Cualquiera',
  'CustomBooleanFilterInput.true_value_label': 'Sí',
  'CustomBooleanFilterInput.false_value_label': 'No',

  // Traducciones VoIP
  'voip.extension_not_configured': 'Extensión VoIP No Configurada',
  'voip.debug_title': 'Depuración VoIP',
  'voip.debug_ua_label': 'UA:',
  'voip.debug_registered_label': 'Registrado:',
  'voip.debug_call_label': 'Llamada:',
  'voip.debug_muted_label': 'Silenciado:',
  'voip.debug_hold_label': 'En Espera:',
  'voip.status_connected': 'VoIP Conectado',
  'voip.status_connecting': 'Conectando...',
  'voip.status_connection_failed': 'Conexión Fallida',
  'voip.status_offline': 'VoIP Desconectado',
  'voip.status_label': 'VoIP',
  'voip.debug_panel_hide': 'Ocultar panel de depuración',
  'voip.debug_panel_show': 'Mostrar panel de depuración',
  'voip.not_connected': 'VoIP no conectado',
  'voip.extension_not_available': 'Extensión VoIP no disponible',
  'voip.cannot_call_editing': 'No se puede llamar mientras se edita',
  'voip.make_call': 'Hacer llamada',
  'voip.incoming_call': 'Llamada Entrante',
  'voip.calling': 'Llamando...',
  'voip.connecting': 'Conectando...',
  'voip.on_hold': 'En Espera',
  'voip.call_ended': 'Llamada Finalizada',
  'voip.unknown': 'Desconocido',
  'voip.select_number': 'Seleccionar Número',

  'treinco_table.error_message': 'Ha ocurrido un error al cargar los datos.',

  // Leaflet Draw localizations
  'leafletDraw.draw.handlers.circle.tooltip.start':
    'Haz clic y arrastra para dibujar un círculo.',
  'leafletDraw.draw.handlers.circle.radius': 'Radio',
  'leafletDraw.draw.handlers.circlemarker.tooltip.start':
    'Haz clic en el mapa para colocar un marcador circular.',
  'leafletDraw.draw.handlers.marker.tooltip.start':
    'Haz clic en el mapa para colocar un marcador.',
  'leafletDraw.draw.handlers.polygon.tooltip.start':
    'Haz clic para comenzar a dibujar la forma.',
  'leafletDraw.draw.handlers.polygon.tooltip.cont':
    'Haz clic para continuar dibujando la forma.',
  'leafletDraw.draw.handlers.polygon.tooltip.end':
    'Haz clic en el primer punto para cerrar esta forma.',
  'leafletDraw.draw.handlers.polyline.error':
    '<strong>Error:</strong> ¡Los bordes de la forma no pueden cruzarse!',
  'leafletDraw.draw.handlers.polyline.tooltip.start':
    'Haz clic para comenzar a dibujar la línea.',
  'leafletDraw.draw.handlers.polyline.tooltip.cont':
    'Haz clic para continuar dibujando la línea.',
  'leafletDraw.draw.handlers.polyline.tooltip.end':
    'Haz clic en el último punto para terminar la línea.',
  'leafletDraw.draw.handlers.rectangle.tooltip.start':
    'Haz clic y arrastra para dibujar un rectángulo.',
  'leafletDraw.draw.handlers.simpleshape.tooltip.end':
    'Suelta el mouse para terminar de dibujar.',

  'deviceMap.waiting.position': 'Esperando primera señal del GPS',
  'deviceMap.waiting.position.description':
    'Estamos esperando a que tu dispositivo envíe su primera señal. Esto suele ocurrir automáticamente en cuanto el GPS detecte movimiento o señal satelital.',

  // device mirror
  'deviceSettings.form.mirroredDevicesTitle': 'Dispositivos espejo',
  'deviceSettings.form.mirroredDevices': 'Dispositivos espejo seleccionados',
  'device_profile.reports_tab_title': 'Reportes',

  // Event Report — Reporte por Eventos (Device Profile)
  'device_profile.event_report.card.title': 'Reporte por Eventos',
  'device_profile.event_report.card.description':
    'Visualiza y exporta los eventos de un dispositivo filtrados por rango de fechas y tipos de evento.',
  // Rounds Report — Reporte de Rondas (Device Profile)
  'device_profile.rounds_report.card.title': 'Reporte de Rondas',
  'device_profile.rounds_report.card.description':
    'Visualiza los eventos registrados durante las rondas de guardia.',
  'device_profile.event_report.title': 'Reporte por Eventos',
  'device_profile.event_report.filters.device': 'Dispositivo',
  'device_profile.event_report.filters.start_date': 'Fecha Inicio',
  'device_profile.event_report.filters.end_date': 'Fecha Fin',
  'device_profile.event_report.filters.event_types': 'Tipos de Evento',
  'device_profile.event_report.filters.event_types_placeholder':
    'Seleccionar tipos de evento...',
  'device_profile.event_report.filters.search': 'Consultar',
  'device_profile.event_report.filters.clear': 'Limpiar',
  'device_profile.event_report.table.date': 'Fecha',
  'device_profile.event_report.table.event_type': 'Tipo de Evento',
  'device_profile.event_report.table.description': 'Descripción',
  'device_profile.event_report.table.no_search_prompt':
    'Seleccione los filtros y presione Consultar para ver los resultados',
  'device_profile.event_report.chart.title': 'Distribución de Eventos por Tipo',
  'device_profile.event_report.chart.x_axis_label': 'Cantidad',
  'device_profile.event_report.chart.series_label': 'Eventos',

  // CCTV channel screenshots (CAM-SCREENSHOT)
  'table.more_options.channel_screenshots': 'Capturas',
  'channelScreenshots.title': 'Capturas de referencia',
  'channelScreenshots.latest_label': 'Última captura',
  'channelScreenshots.capture_button': 'Tomar Captura',
  'channelScreenshots.capturing': 'Capturando...',
  'channelScreenshots.view_history': 'Ver historial',
  'channelScreenshots.view_history_full': 'Ver historial de capturas',
  'channelScreenshots.refresh_latest': 'Actualizar',
  'channelScreenshots.history_title': 'Historial de Capturas',
  'channelScreenshots.history_date_field': 'Fecha',
  'channelScreenshots.history_uploader_field': 'Subido por',
  'channelScreenshots.load_error': 'No se pudo cargar la captura',
  'channelScreenshots.empty_state': 'Aún no se han subido capturas.',
  'channelScreenshots.uploaded_by': 'Subido el {{date}} por {{uploader}}',
  'channelScreenshots.success_upload': 'Captura subida exitosamente.',
  'channelScreenshots.error_upload':
    'Error al subir la captura. Intente nuevamente.',
  'channelScreenshots.error_getting_upload_url':
    'No se pudo obtener la URL de subida.',
  'channelScreenshots.delete_confirm_title': 'Eliminar Captura',
  'channelScreenshots.delete_confirm_description':
    'Esta captura se eliminará permanentemente. Esta acción no se puede deshacer.',
  'channelScreenshots.delete_success': 'Captura eliminada.',
  'channelScreenshots.delete_error':
    'Error al eliminar la captura. Intente nuevamente.',

  // --- Telegram notification channel ---
  'integrations_table.telegram_type_text': 'Telegram',
  'integrations.telegram.delete_warning':
    'Se va a borrar el bot de Telegram del espacio de trabajo. {{notifications}} notificación(es) en {{devices}} dispositivo(s) van a dejar de entregarse por Telegram, y no hay respaldo por push. Esta acción no se puede deshacer.',
  'integrations_form.telegram_setup_help':
    'Cree un bot con /newbot en BotFather, súbale el logo de su empresa con /setuserpic y pegue aquí el token que le da. El logo solo se puede subir desde BotFather.',
  'integrations_form.telegram_bot_token_field': 'Token del bot',
  'integrations_form.telegram_bot_token_helper':
    'Se guarda cifrado y nunca se vuelve a mostrar completo. Déjelo como está si no desea cambiarlo.',
  'integrations_form.telegram_bot_username_field': 'Usuario del bot',
  'device_notifications.form.type_email': 'Correo',
  'device_notifications.form.channel_unavailable_telegram':
    'configure el bot en Ajustes > Integraciones',
  'device_notifications.form.channel_unavailable_email':
    'configure un servidor de correo en Ajustes > Integraciones',
  // --- Canal de correo por SMTP del espacio de trabajo ---
  'integrations_table.smtp_type_text': 'Correo (SMTP)',
  'integrations_form.smtp_setup_help':
    'Las alertas de los dispositivos salen por este servidor, con su propio nombre. Use un relay o una casilla que tenga permiso para enviar como la dirección de abajo.',
  'integrations_form.smtp_host_field': 'Servidor',
  'integrations_form.smtp_port_field': 'Puerto',
  'integrations_form.smtp_port_helper':
    '587 o 2525 para STARTTLS, 465 para TLS implícito.',
  'integrations_form.smtp_user_field': 'Usuario',
  'integrations_form.smtp_pass_field': 'Contraseña',
  'integrations_form.smtp_pass_helper':
    'Se guarda cifrada y nunca se vuelve a mostrar completa. Déjela como está si no desea cambiarla.',
  'integrations_form.smtp_from_email_field': 'Dirección del remitente',
  'integrations_form.smtp_from_email_helper':
    'Es lo que ven los destinatarios. El servidor tiene que tener permiso para enviar como esta dirección.',
  'integrations_form.smtp_from_name_field': 'Nombre del remitente',
  'integrations_form.smtp_reply_email_field': 'Dirección de respuesta',
  'integrations_form.smtp_reply_email_helper':
    'A dónde van las respuestas. Por defecto, la dirección del remitente.',
  'integrations_form.smtp_require_tls_field': 'Exigir conexión cifrada',
  'device_notifications.telegram.invite_title': 'Conectar Telegram',
  'device_notifications.telegram.invite_explanation':
    'Telegram solo permite que un bot escriba a alguien después de que esa persona inicie el chat. Envíe a cada contacto su enlace personal: por correo si tenemos su dirección, o cópielo y envíeselo por el medio que ya use para comunicarse con esa persona.',
  'device_notifications.telegram.send_invite': 'Enviar correo',
  'device_notifications.telegram.get_link': 'Obtener enlace',
  'device_notifications.telegram.link_ready': 'Enlace listo: copialo abajo',
  'device_notifications.telegram.copy_link': 'Copiar enlace',
  'device_notifications.telegram.link_copied': 'Enlace copiado al portapapeles',
  'device_notifications.telegram.no_email_on_file': 'Sin correo registrado',
  'notification_contacts.table.telegram': 'Telegram',
  'notification_contacts.table.telegram_linked': 'Conectado',
  'notification_contacts.table.telegram_not_linked': 'Sin conectar',
  'integration_errors.SMTP_VERIFICATION_FAILED':
    'El servidor de correo rechazó la conexión. Razón: {{reason}}',
  'integration_errors.TELEGRAM_VERIFICATION_FAILED':
    'Telegram rechazó el token del bot. Razón: {{reason}}',
  'integration_errors.SMTP_CONFIG_INCOMPLETE':
    'Servidor, usuario, contraseña y dirección del remitente son obligatorios.',
  'integration_errors.CREDENTIAL_REQUIRED_FOR_NEW_DESTINATION':
    'Cambió el servidor, así que ingrese la contraseña de nuevo: la guardada nunca se envía a un host nuevo.',
  'integration_errors.TELEGRAM_BOT_TOKEN_REQUIRED':
    'El token del bot es obligatorio.',
  'integration_errors.TELEGRAM_BOT_NOT_CONNECTED':
    'El bot del workspace no está conectado. Revise su token en Configuración → Integraciones.',
  'integration_errors.TELEGRAM_API_URL_NOT_CONFIGURED':
    'Telegram todavía no puede alcanzar a Treinco. Contacte a soporte.',
  'integration_errors.TELEGRAM_INTEGRATION_ALREADY_EXISTS':
    'Este workspace ya tiene un bot de Telegram.',
  'integration_errors.SMTP_INTEGRATION_ALREADY_EXISTS':
    'Este workspace ya tiene un servidor de correo.',
  'device_notifications.delivery.reachable_count':
    '{{reachable}} de {{total}} alcanzables',
  'device_notifications.delivery.no_recipients': 'Sin destinatarios',
  'device_notifications.email.no_mail_server': 'Sin servidor de correo',
  'device_notifications.email.missing_address':
    'Algunos contactos no tienen correo',
  'notification_contacts.invite_telegram': 'Invitar a Telegram',
  'notification_contacts.delete_warning':
    'Este contacto deja de recibir alertas en todas las notificaciones que lo incluyen. Las notificaciones con otros destinatarios siguen funcionando.',
  'device_notifications.telegram.no_bot': 'Sin bot configurado',
  'device_notifications.telegram.resend_invite':
    'Reenviar invitación a los que faltan',
  'device_notifications.telegram.invite_sent': 'Invitación enviada',
  'device_notifications.telegram.invite_error':
    'No se pudo enviar la invitación',
  'notifications_table.delivery_field_text': 'Entrega',
  // --- Canal SMS por móviles Android ---
  'device_notifications.form.type_sms': 'SMS',
  'device_notifications.form.channel_unavailable_sms':
    'configure la pasarela SMS en Ajustes > Integraciones',
  'device_notifications.sms.no_gateway': 'Sin pasarela SMS',
  'device_notifications.sms.missing_phone':
    'Algunos contactos no tienen teléfono',
  'notification_contacts.table.phone': 'Teléfono',
  'notification_contacts.form.phone': 'Teléfono',
  'notification_contacts.form.phone_helper':
    'Opcional. Necesario para alertas por SMS. Con prefijo de país, p. ej. +34600111222.',
  'notification_contacts.validation.phone_invalid':
    'Teléfono inválido: use el prefijo de país, p. ej. +34600111222',
  'integrations_table.sms_gateway_type_text': 'SMS (móviles Android)',
  'integrations_form.sms_gateway_setup_help':
    'Los SMS salen desde móviles Android del propio espacio de trabajo, con sus SIM. Al guardar se crea la cuenta de la pasarela; después, desde el menú "Móviles", añada cada móvil con un código de un solo uso. Con varios móviles, los envíos se reparten y, si uno no responde, el SMS pasa a otro.',
  'integration_errors.SMS_GATEWAY_SETUP_FAILED':
    'No se pudo crear la cuenta en la pasarela SMS. Razón: {{reason}}',
  'integration_errors.SMS_GATEWAY_NOT_CONFIGURED':
    'La pasarela SMS de Treinco todavía no está configurada. Contacte a soporte.',
  'integration_errors.SMS_GATEWAY_ACCOUNT_REJECTED':
    'La pasarela SMS ya no acepta la cuenta de este espacio de trabajo (se borró o alguien cambió su contraseña desde un móvil). Elimine la integración, créela de nuevo y vuelva a añadir los móviles.',
  'integration_errors.SMS_GATEWAY_DEVICE_NOT_REMOVED':
    'No se pudo quitar el móvil de la pasarela. Vuelva a intentarlo: hasta entonces los móviles pueden aparecer sin señal, aunque siguen enviando.',
  'integration_errors.SMS_GATEWAY_WEBHOOK_NOT_PUBLISHED':
    'El móvil se eliminó, pero la pasarela no recibió el nuevo secreto de los pings: los demás móviles pueden aparecer sin señal. Guarde la integración para reintentarlo.',
  'integration_errors.SMS_GATEWAY_INTEGRATION_ALREADY_EXISTS':
    'Este workspace ya tiene una pasarela SMS.',
  'sms_gateway.devices_menu_label': 'Móviles',
  'sms_gateway.devices_title': 'Móviles de la pasarela SMS',
  'sms_gateway.add_phone': 'Añadir móvil',
  'sms_gateway.add_phone_steps':
    '1. Instale en el móvil Android la app SMS Gateway (APK de la versión indicada por Treinco).\n2. En los ajustes de la app, en "Cloud server", ponga la URL del servidor de abajo y elija el canal de notificaciones "Solo SSE". Hágalo antes de iniciar sesión: así el móvil nunca pasa por el servicio push del autor de la app.\n3. Inicie sesión con la pestaña "Por código" e introduzca el código.',
  'sms_gateway.server_url': 'URL del servidor',
  'sms_gateway.login_code': 'Código de un solo uso',
  'sms_gateway.code_valid_until': 'Válido hasta {{time}}',
  'sms_gateway.code_error': 'No se pudo generar el código',
  'sms_gateway.keep_awake':
    'Deje el móvil enchufado y desactive la optimización de batería para la app: si Android la cierra, el móvil deja de enviar.',
  'sms_gateway.no_phones':
    'Todavía no hay móviles. Sin al menos uno, los SMS de esta pasarela no salen.',
  'sms_gateway.status_column': 'Estado',
  'sms_gateway.status_online': 'En línea',
  'sms_gateway.status_offline':
    'Sin señal: no ha enviado ping en los últimos 3 minutos',
  'sms_gateway.name_column': 'Móvil',
  'sms_gateway.battery_column': 'Batería',
  'sms_gateway.connection_column': 'Conexión',
  'sms_gateway.connection_none': 'Sin internet',
  'sms_gateway.connection_cellular': 'Datos móviles',
  'sms_gateway.connection_unknown': 'Desconocida',
  'sms_gateway.sims_column': 'SIM',
  'sms_gateway.failed_column': 'Fallidos (1 h)',
  'sms_gateway.last_ping_column': 'Último contacto',
  'sms_gateway.version_column': 'Versión',
  'sms_gateway.delete_confirm':
    'El móvil deja de enviar SMS por este espacio de trabajo al momento. Para volver a usarlo habrá que añadirlo de nuevo.',
  'sms_gateway.delete_success': 'Móvil eliminado',
  'sms_gateway.delete_error': 'No se pudo eliminar el móvil',
};
